import { g as Yt, a as Se, d as Qt, j as Be, u as U, F as Jt, _ as We, x as en, k as ue, o as wt, s as re, C as tn, f as ze, t as Ze, I as nn, v as an, S as on, r as sn, w as Ye, z as rn, B as ln, i as cn, c as un, b as dn, e as pn } from "./_plugin-vue_export-helper-Bj5Pjwhk.js";
import { defineComponent as z, ref as k, onMounted as je, openBlock as b, createBlock as D, unref as m, computed as S, withCtx as I, renderSlot as xe, createElementVNode as f, createElementBlock as x, Fragment as N, renderList as X, normalizeClass as G, toDisplayString as P, createCommentVNode as Z, createStaticVNode as hn, provide as _e, watch as B, onBeforeUnmount as he, toRef as me, inject as F, Comment as bt, markRaw as te, normalizeProps as kt, guardReactiveProps as _t, mergeProps as mn, withModifiers as fn, createVNode as M, h as gn, normalizeStyle as vn, createTextVNode as se, useTemplateRef as Ct, createSlots as yn, withAsyncContext as wn, Suspense as bn } from "vue";
import { c as kn, s as _n } from "./navigation-BwJTmB2L.js";
import { t as xt, e as Cn, g as xn, s as Qe, h as Y, i as R, j as Fe, k as V, u as $e, f as Pn, c as Mn, b as Sn, r as zn } from "./index-BA_m867W.js";
function jn(n, e) {
  const t = xt(n);
  return isNaN(e) ? Cn(n, NaN) : (e && t.setDate(t.getDate() + e), t);
}
function $n(n, e, t) {
  var c, h;
  const a = xn(), o = a.weekStartsOn ?? ((h = (c = a.locale) == null ? void 0 : c.options) == null ? void 0 : h.weekStartsOn) ?? 0, s = xt(n), r = s.getDay(), i = (e % 7 + 7) % 7, d = 7 - o, u = e < 0 || e > 6 ? e - (r + d) % 7 : (i + d) % 7 - (r + d) % 7;
  return jn(s, u);
}
function Je(n, e, t) {
  const a = Qe(n, t), o = Qe(e, t);
  return +a == +o;
}
const Ln = {
  lessThanXSeconds: {
    one: "mai puțin de o secundă",
    other: "mai puțin de {{count}} secunde"
  },
  xSeconds: {
    one: "1 secundă",
    other: "{{count}} secunde"
  },
  halfAMinute: "jumătate de minut",
  lessThanXMinutes: {
    one: "mai puțin de un minut",
    other: "mai puțin de {{count}} minute"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minute"
  },
  aboutXHours: {
    one: "circa 1 oră",
    other: "circa {{count}} ore"
  },
  xHours: {
    one: "1 oră",
    other: "{{count}} ore"
  },
  xDays: {
    one: "1 zi",
    other: "{{count}} zile"
  },
  aboutXWeeks: {
    one: "circa o săptămână",
    other: "circa {{count}} săptămâni"
  },
  xWeeks: {
    one: "1 săptămână",
    other: "{{count}} săptămâni"
  },
  aboutXMonths: {
    one: "circa 1 lună",
    other: "circa {{count}} luni"
  },
  xMonths: {
    one: "1 lună",
    other: "{{count}} luni"
  },
  aboutXYears: {
    one: "circa 1 an",
    other: "circa {{count}} ani"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ani"
  },
  overXYears: {
    one: "peste 1 an",
    other: "peste {{count}} ani"
  },
  almostXYears: {
    one: "aproape 1 an",
    other: "aproape {{count}} ani"
  }
}, In = (n, e, t) => {
  let a;
  const o = Ln[n];
  return typeof o == "string" ? a = o : e === 1 ? a = o.one : a = o.other.replace("{{count}}", String(e)), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "în " + a : a + " în urmă" : a;
}, En = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd.MM.yyyy"
}, An = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Dn = {
  full: "{{date}} 'la' {{time}}",
  long: "{{date}} 'la' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, On = {
  date: Y({
    formats: En,
    defaultWidth: "full"
  }),
  time: Y({
    formats: An,
    defaultWidth: "full"
  }),
  dateTime: Y({
    formats: Dn,
    defaultWidth: "full"
  })
}, Hn = {
  lastWeek: "eeee 'trecută la' p",
  yesterday: "'ieri la' p",
  today: "'astăzi la' p",
  tomorrow: "'mâine la' p",
  nextWeek: "eeee 'viitoare la' p",
  other: "P"
}, Tn = (n, e, t, a) => Hn[n], Rn = {
  narrow: ["Î", "D"],
  abbreviated: ["Î.d.C.", "D.C."],
  wide: ["Înainte de Cristos", "După Cristos"]
}, Vn = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: [
    "primul trimestru",
    "al doilea trimestru",
    "al treilea trimestru",
    "al patrulea trimestru"
  ]
}, Nn = {
  narrow: ["I", "F", "M", "A", "M", "I", "I", "A", "S", "O", "N", "D"],
  abbreviated: [
    "ian",
    "feb",
    "mar",
    "apr",
    "mai",
    "iun",
    "iul",
    "aug",
    "sep",
    "oct",
    "noi",
    "dec"
  ],
  wide: [
    "ianuarie",
    "februarie",
    "martie",
    "aprilie",
    "mai",
    "iunie",
    "iulie",
    "august",
    "septembrie",
    "octombrie",
    "noiembrie",
    "decembrie"
  ]
}, Zn = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["du", "lu", "ma", "mi", "jo", "vi", "sâ"],
  abbreviated: ["dum", "lun", "mar", "mie", "joi", "vin", "sâm"],
  wide: ["duminică", "luni", "marți", "miercuri", "joi", "vineri", "sâmbătă"]
}, qn = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "ami",
    morning: "dim",
    afternoon: "da",
    evening: "s",
    night: "n"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  }
}, Bn = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  }
}, Wn = (n, e) => String(n), Fn = {
  ordinalNumber: Wn,
  era: R({
    values: Rn,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: Vn,
    defaultWidth: "wide",
    argumentCallback: (n) => n - 1
  }),
  month: R({
    values: Nn,
    defaultWidth: "wide"
  }),
  day: R({
    values: Zn,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: qn,
    defaultWidth: "wide",
    formattingValues: Bn,
    defaultFormattingWidth: "wide"
  })
}, Un = /^(\d+)?/i, Kn = /\d+/i, Gn = {
  narrow: /^(Î|D)/i,
  abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
  wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
}, Xn = {
  any: [/^ÎC/i, /^DC/i],
  wide: [
    /^(Înainte de Cristos|Înaintea erei noastre)/i,
    /^(După Cristos|Era noastră)/i
  ]
}, Yn = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^trimestrul [1234]/i
}, Qn = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Jn = {
  narrow: /^[ifmaasond]/i,
  abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
  wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
}, ea = {
  narrow: [
    /^i/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^i/i,
    /^i/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ia/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mai/i,
    /^iun/i,
    /^iul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, ta = {
  narrow: /^[dlmjvs]/i,
  short: /^(d|l|ma|mi|j|v|s)/i,
  abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
  wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
}, na = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^mi/i, /^j/i, /^v/i, /^s/i]
}, aa = {
  narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
  any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
}, oa = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /amiaza/i,
    morning: /dimineaţa/i,
    afternoon: /după-amiaza/i,
    evening: /seara/i,
    night: /noaptea/i
  }
}, sa = {
  ordinalNumber: Fe({
    matchPattern: Un,
    parsePattern: Kn,
    valueCallback: (n) => parseInt(n, 10)
  }),
  era: V({
    matchPatterns: Gn,
    defaultMatchWidth: "wide",
    parsePatterns: Xn,
    defaultParseWidth: "any"
  }),
  quarter: V({
    matchPatterns: Yn,
    defaultMatchWidth: "wide",
    parsePatterns: Qn,
    defaultParseWidth: "any",
    valueCallback: (n) => n + 1
  }),
  month: V({
    matchPatterns: Jn,
    defaultMatchWidth: "wide",
    parsePatterns: ea,
    defaultParseWidth: "any"
  }),
  day: V({
    matchPatterns: ta,
    defaultMatchWidth: "wide",
    parsePatterns: na,
    defaultParseWidth: "any"
  }),
  dayPeriod: V({
    matchPatterns: aa,
    defaultMatchWidth: "any",
    parsePatterns: oa,
    defaultParseWidth: "any"
  })
}, ra = {
  code: "ro",
  formatDistance: In,
  formatLong: On,
  formatRelative: Tn,
  localize: Fn,
  match: sa,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
function ia(n, e) {
  return e === 1 && n.one ? n.one : e >= 2 && e <= 4 && n.twoFour ? n.twoFour : n.other;
}
function Oe(n, e, t) {
  return ia(n, e)[t].replace("{{count}}", String(e));
}
function la(n) {
  return ["lessThan", "about", "over", "almost"].filter(
    function(t) {
      return !!n.match(new RegExp("^" + t));
    }
  )[0];
}
function He(n) {
  let e = "";
  return n === "almost" && (e = "takmer"), n === "about" && (e = "približne"), e.length > 0 ? e + " " : "";
}
function Te(n) {
  let e = "";
  return n === "lessThan" && (e = "menej než"), n === "over" && (e = "viac než"), e.length > 0 ? e + " " : "";
}
function ca(n) {
  return n.charAt(0).toLowerCase() + n.slice(1);
}
const ua = {
  xSeconds: {
    one: {
      present: "sekunda",
      past: "sekundou",
      future: "sekundu"
    },
    twoFour: {
      present: "{{count}} sekundy",
      past: "{{count}} sekundami",
      future: "{{count}} sekundy"
    },
    other: {
      present: "{{count}} sekúnd",
      past: "{{count}} sekundami",
      future: "{{count}} sekúnd"
    }
  },
  halfAMinute: {
    other: {
      present: "pol minúty",
      past: "pol minútou",
      future: "pol minúty"
    }
  },
  xMinutes: {
    one: {
      present: "minúta",
      past: "minútou",
      future: "minútu"
    },
    twoFour: {
      present: "{{count}} minúty",
      past: "{{count}} minútami",
      future: "{{count}} minúty"
    },
    other: {
      present: "{{count}} minút",
      past: "{{count}} minútami",
      future: "{{count}} minút"
    }
  },
  xHours: {
    one: {
      present: "hodina",
      past: "hodinou",
      future: "hodinu"
    },
    twoFour: {
      present: "{{count}} hodiny",
      past: "{{count}} hodinami",
      future: "{{count}} hodiny"
    },
    other: {
      present: "{{count}} hodín",
      past: "{{count}} hodinami",
      future: "{{count}} hodín"
    }
  },
  xDays: {
    one: {
      present: "deň",
      past: "dňom",
      future: "deň"
    },
    twoFour: {
      present: "{{count}} dni",
      past: "{{count}} dňami",
      future: "{{count}} dni"
    },
    other: {
      present: "{{count}} dní",
      past: "{{count}} dňami",
      future: "{{count}} dní"
    }
  },
  xWeeks: {
    one: {
      present: "týždeň",
      past: "týždňom",
      future: "týždeň"
    },
    twoFour: {
      present: "{{count}} týždne",
      past: "{{count}} týždňami",
      future: "{{count}} týždne"
    },
    other: {
      present: "{{count}} týždňov",
      past: "{{count}} týždňami",
      future: "{{count}} týždňov"
    }
  },
  xMonths: {
    one: {
      present: "mesiac",
      past: "mesiacom",
      future: "mesiac"
    },
    twoFour: {
      present: "{{count}} mesiace",
      past: "{{count}} mesiacmi",
      future: "{{count}} mesiace"
    },
    other: {
      present: "{{count}} mesiacov",
      past: "{{count}} mesiacmi",
      future: "{{count}} mesiacov"
    }
  },
  xYears: {
    one: {
      present: "rok",
      past: "rokom",
      future: "rok"
    },
    twoFour: {
      present: "{{count}} roky",
      past: "{{count}} rokmi",
      future: "{{count}} roky"
    },
    other: {
      present: "{{count}} rokov",
      past: "{{count}} rokmi",
      future: "{{count}} rokov"
    }
  }
}, da = (n, e, t) => {
  const a = la(n) || "", o = ca(n.substring(a.length)), s = ua[o];
  return t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? He(a) + "o " + Te(a) + Oe(s, e, "future") : He(a) + "pred " + Te(a) + Oe(s, e, "past") : He(a) + Te(a) + Oe(s, e, "present");
}, pa = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. M. y",
  short: "d. M. y"
}, ha = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, ma = {
  full: "{{date}}, {{time}}",
  long: "{{date}}, {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}} {{time}}"
}, fa = {
  date: Y({
    formats: pa,
    defaultWidth: "full"
  }),
  time: Y({
    formats: ha,
    defaultWidth: "full"
  }),
  dateTime: Y({
    formats: ma,
    defaultWidth: "full"
  })
}, Ue = [
  "nedeľu",
  "pondelok",
  "utorok",
  "stredu",
  "štvrtok",
  "piatok",
  "sobotu"
];
function ga(n) {
  const e = Ue[n];
  switch (n) {
    case 0:
    case 3:
    case 6:
      return "'minulú " + e + " o' p";
    default:
      return "'minulý' eeee 'o' p";
  }
}
function et(n) {
  const e = Ue[n];
  return n === 4 ? "'vo' eeee 'o' p" : "'v " + e + " o' p";
}
function va(n) {
  const e = Ue[n];
  switch (n) {
    case 0:
    case 4:
    case 6:
      return "'budúcu " + e + " o' p";
    default:
      return "'budúci' eeee 'o' p";
  }
}
const ya = {
  lastWeek: (n, e, t) => {
    const a = n.getDay();
    return Je(n, e, t) ? et(a) : ga(a);
  },
  yesterday: "'včera o' p",
  today: "'dnes o' p",
  tomorrow: "'zajtra o' p",
  nextWeek: (n, e, t) => {
    const a = n.getDay();
    return Je(n, e, t) ? et(a) : va(a);
  },
  other: "P"
}, wa = (n, e, t, a) => {
  const o = ya[n];
  return typeof o == "function" ? o(e, t, a) : o;
}, ba = {
  narrow: ["pred Kr.", "po Kr."],
  abbreviated: ["pred Kr.", "po Kr."],
  wide: ["pred Kristom", "po Kristovi"]
}, ka = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. štvrťrok", "2. štvrťrok", "3. štvrťrok", "4. štvrťrok"]
}, _a = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "máj",
    "jún",
    "júl",
    "aug",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "január",
    "február",
    "marec",
    "apríl",
    "máj",
    "jún",
    "júl",
    "august",
    "september",
    "október",
    "november",
    "december"
  ]
}, Ca = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "máj",
    "jún",
    "júl",
    "aug",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "januára",
    "februára",
    "marca",
    "apríla",
    "mája",
    "júna",
    "júla",
    "augusta",
    "septembra",
    "októbra",
    "novembra",
    "decembra"
  ]
}, xa = {
  narrow: ["n", "p", "u", "s", "š", "p", "s"],
  short: ["ne", "po", "ut", "st", "št", "pi", "so"],
  abbreviated: ["ne", "po", "ut", "st", "št", "pi", "so"],
  wide: [
    "nedeľa",
    "pondelok",
    "utorok",
    "streda",
    "štvrtok",
    "piatok",
    "sobota"
  ]
}, Pa = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "poln.",
    noon: "pol.",
    morning: "ráno",
    afternoon: "pop.",
    evening: "več.",
    night: "noc"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "poln.",
    noon: "pol.",
    morning: "ráno",
    afternoon: "popol.",
    evening: "večer",
    night: "noc"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "polnoc",
    noon: "poludnie",
    morning: "ráno",
    afternoon: "popoludnie",
    evening: "večer",
    night: "noc"
  }
}, Ma = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "o poln.",
    noon: "nap.",
    morning: "ráno",
    afternoon: "pop.",
    evening: "več.",
    night: "v n."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "o poln.",
    noon: "napol.",
    morning: "ráno",
    afternoon: "popol.",
    evening: "večer",
    night: "v noci"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "o polnoci",
    noon: "napoludnie",
    morning: "ráno",
    afternoon: "popoludní",
    evening: "večer",
    night: "v noci"
  }
}, Sa = (n, e) => Number(n) + ".", za = {
  ordinalNumber: Sa,
  era: R({
    values: ba,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: ka,
    defaultWidth: "wide",
    argumentCallback: (n) => n - 1
  }),
  month: R({
    values: _a,
    defaultWidth: "wide",
    formattingValues: Ca,
    defaultFormattingWidth: "wide"
  }),
  day: R({
    values: xa,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: Pa,
    defaultWidth: "wide",
    formattingValues: Ma,
    defaultFormattingWidth: "wide"
  })
}, ja = /^(\d+)\.?/i, $a = /\d+/i, La = {
  narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
}, Ia = {
  any: [/^pr/i, /^(po|n)/i]
}, Ea = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]\. [šs]tvr[ťt]rok/i
}, Aa = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Da = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
  wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
}, Oa = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^m[áa]j/i,
    /^j[úu]n/i,
    /^j[úu]l/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Ha = {
  narrow: /^[npusšp]/i,
  short: /^(ne|po|ut|st|št|pi|so)/i,
  abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
  wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
}, Ta = {
  narrow: [/^n/i, /^p/i, /^u/i, /^s/i, /^š/i, /^p/i, /^s/i],
  any: [/^n/i, /^po/i, /^u/i, /^st/i, /^(št|stv)/i, /^pi/i, /^so/i]
}, Ra = {
  narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
  abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
  any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
}, Va = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /poln/i,
    noon: /^(nap|(na)?pol(\.|u))/i,
    morning: /^r[áa]no/i,
    afternoon: /^pop/i,
    evening: /^ve[čc]/i,
    night: /^(noc|v n\.)/i
  }
}, Na = {
  ordinalNumber: Fe({
    matchPattern: ja,
    parsePattern: $a,
    valueCallback: (n) => parseInt(n, 10)
  }),
  era: V({
    matchPatterns: La,
    defaultMatchWidth: "wide",
    parsePatterns: Ia,
    defaultParseWidth: "any"
  }),
  quarter: V({
    matchPatterns: Ea,
    defaultMatchWidth: "wide",
    parsePatterns: Aa,
    defaultParseWidth: "any",
    valueCallback: (n) => n + 1
  }),
  month: V({
    matchPatterns: Da,
    defaultMatchWidth: "wide",
    parsePatterns: Oa,
    defaultParseWidth: "any"
  }),
  day: V({
    matchPatterns: Ha,
    defaultMatchWidth: "wide",
    parsePatterns: Ta,
    defaultParseWidth: "any"
  }),
  dayPeriod: V({
    matchPatterns: Ra,
    defaultMatchWidth: "any",
    parsePatterns: Va,
    defaultParseWidth: "any"
  })
}, Za = {
  code: "sk",
  formatDistance: da,
  formatLong: fa,
  formatRelative: wa,
  localize: za,
  match: Na,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, qa = {
  lessThanXSeconds: {
    one: {
      standalone: "manje od 1 sekunde",
      withPrepositionAgo: "manje od 1 sekunde",
      withPrepositionIn: "manje od 1 sekundu"
    },
    dual: "manje od {{count}} sekunde",
    other: "manje od {{count}} sekundi"
  },
  xSeconds: {
    one: {
      standalone: "1 sekunda",
      withPrepositionAgo: "1 sekunde",
      withPrepositionIn: "1 sekundu"
    },
    dual: "{{count}} sekunde",
    other: "{{count}} sekundi"
  },
  halfAMinute: "pola minute",
  lessThanXMinutes: {
    one: {
      standalone: "manje od 1 minute",
      withPrepositionAgo: "manje od 1 minute",
      withPrepositionIn: "manje od 1 minutu"
    },
    dual: "manje od {{count}} minute",
    other: "manje od {{count}} minuta"
  },
  xMinutes: {
    one: {
      standalone: "1 minuta",
      withPrepositionAgo: "1 minute",
      withPrepositionIn: "1 minutu"
    },
    dual: "{{count}} minute",
    other: "{{count}} minuta"
  },
  aboutXHours: {
    one: {
      standalone: "oko 1 sat",
      withPrepositionAgo: "oko 1 sat",
      withPrepositionIn: "oko 1 sat"
    },
    dual: "oko {{count}} sata",
    other: "oko {{count}} sati"
  },
  xHours: {
    one: {
      standalone: "1 sat",
      withPrepositionAgo: "1 sat",
      withPrepositionIn: "1 sat"
    },
    dual: "{{count}} sata",
    other: "{{count}} sati"
  },
  xDays: {
    one: {
      standalone: "1 dan",
      withPrepositionAgo: "1 dan",
      withPrepositionIn: "1 dan"
    },
    dual: "{{count}} dana",
    other: "{{count}} dana"
  },
  aboutXWeeks: {
    one: {
      standalone: "oko 1 nedelju",
      withPrepositionAgo: "oko 1 nedelju",
      withPrepositionIn: "oko 1 nedelju"
    },
    dual: "oko {{count}} nedelje",
    other: "oko {{count}} nedelje"
  },
  xWeeks: {
    one: {
      standalone: "1 nedelju",
      withPrepositionAgo: "1 nedelju",
      withPrepositionIn: "1 nedelju"
    },
    dual: "{{count}} nedelje",
    other: "{{count}} nedelje"
  },
  aboutXMonths: {
    one: {
      standalone: "oko 1 mesec",
      withPrepositionAgo: "oko 1 mesec",
      withPrepositionIn: "oko 1 mesec"
    },
    dual: "oko {{count}} meseca",
    other: "oko {{count}} meseci"
  },
  xMonths: {
    one: {
      standalone: "1 mesec",
      withPrepositionAgo: "1 mesec",
      withPrepositionIn: "1 mesec"
    },
    dual: "{{count}} meseca",
    other: "{{count}} meseci"
  },
  aboutXYears: {
    one: {
      standalone: "oko 1 godinu",
      withPrepositionAgo: "oko 1 godinu",
      withPrepositionIn: "oko 1 godinu"
    },
    dual: "oko {{count}} godine",
    other: "oko {{count}} godina"
  },
  xYears: {
    one: {
      standalone: "1 godina",
      withPrepositionAgo: "1 godine",
      withPrepositionIn: "1 godinu"
    },
    dual: "{{count}} godine",
    other: "{{count}} godina"
  },
  overXYears: {
    one: {
      standalone: "preko 1 godinu",
      withPrepositionAgo: "preko 1 godinu",
      withPrepositionIn: "preko 1 godinu"
    },
    dual: "preko {{count}} godine",
    other: "preko {{count}} godina"
  },
  almostXYears: {
    one: {
      standalone: "gotovo 1 godinu",
      withPrepositionAgo: "gotovo 1 godinu",
      withPrepositionIn: "gotovo 1 godinu"
    },
    dual: "gotovo {{count}} godine",
    other: "gotovo {{count}} godina"
  }
}, Ba = (n, e, t) => {
  let a;
  const o = qa[n];
  return typeof o == "string" ? a = o : e === 1 ? t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? a = o.one.withPrepositionIn : a = o.one.withPrepositionAgo : a = o.one.standalone : e % 10 > 1 && e % 10 < 5 && // if last digit is between 2 and 4
  String(e).substr(-2, 1) !== "1" ? a = o.dual.replace("{{count}}", String(e)) : a = o.other.replace("{{count}}", String(e)), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "za " + a : "pre " + a : a;
}, Wa = {
  full: "EEEE, d. MMMM yyyy.",
  long: "d. MMMM yyyy.",
  medium: "d. MMM yy.",
  short: "dd. MM. yy."
}, Fa = {
  full: "HH:mm:ss (zzzz)",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Ua = {
  full: "{{date}} 'u' {{time}}",
  long: "{{date}} 'u' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Ka = {
  date: Y({
    formats: Wa,
    defaultWidth: "full"
  }),
  time: Y({
    formats: Fa,
    defaultWidth: "full"
  }),
  dateTime: Y({
    formats: Ua,
    defaultWidth: "full"
  })
}, Ga = {
  lastWeek: (n) => {
    switch (n.getDay()) {
      case 0:
        return "'prošle nedelje u' p";
      case 3:
        return "'prošle srede u' p";
      case 6:
        return "'prošle subote u' p";
      default:
        return "'prošli' EEEE 'u' p";
    }
  },
  yesterday: "'juče u' p",
  today: "'danas u' p",
  tomorrow: "'sutra u' p",
  nextWeek: (n) => {
    switch (n.getDay()) {
      case 0:
        return "'sledeće nedelje u' p";
      case 3:
        return "'sledeću sredu u' p";
      case 6:
        return "'sledeću subotu u' p";
      default:
        return "'sledeći' EEEE 'u' p";
    }
  },
  other: "P"
}, Xa = (n, e, t, a) => {
  const o = Ga[n];
  return typeof o == "function" ? o(e) : o;
}, Ya = {
  narrow: ["pr.n.e.", "AD"],
  abbreviated: ["pr. Hr.", "po. Hr."],
  wide: ["Pre Hrista", "Posle Hrista"]
}, Qa = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. kv.", "2. kv.", "3. kv.", "4. kv."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, Ja = {
  narrow: [
    "1.",
    "2.",
    "3.",
    "4.",
    "5.",
    "6.",
    "7.",
    "8.",
    "9.",
    "10.",
    "11.",
    "12."
  ],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "maj",
    "jun",
    "jul",
    "avg",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "januar",
    "februar",
    "mart",
    "april",
    "maj",
    "jun",
    "jul",
    "avgust",
    "septembar",
    "oktobar",
    "novembar",
    "decembar"
  ]
}, eo = {
  narrow: [
    "1.",
    "2.",
    "3.",
    "4.",
    "5.",
    "6.",
    "7.",
    "8.",
    "9.",
    "10.",
    "11.",
    "12."
  ],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "maj",
    "jun",
    "jul",
    "avg",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "januar",
    "februar",
    "mart",
    "april",
    "maj",
    "jun",
    "jul",
    "avgust",
    "septembar",
    "oktobar",
    "novembar",
    "decembar"
  ]
}, to = {
  narrow: ["N", "P", "U", "S", "Č", "P", "S"],
  short: ["ned", "pon", "uto", "sre", "čet", "pet", "sub"],
  abbreviated: ["ned", "pon", "uto", "sre", "čet", "pet", "sub"],
  wide: [
    "nedelja",
    "ponedeljak",
    "utorak",
    "sreda",
    "četvrtak",
    "petak",
    "subota"
  ]
}, no = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "posle podne",
    evening: "uveče",
    night: "noću"
  }
}, ao = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "posle podne",
    evening: "uveče",
    night: "noću"
  }
}, oo = (n, e) => Number(n) + ".", so = {
  ordinalNumber: oo,
  era: R({
    values: Ya,
    defaultWidth: "wide"
  }),
  quarter: R({
    values: Qa,
    defaultWidth: "wide",
    argumentCallback: (n) => n - 1
  }),
  month: R({
    values: Ja,
    defaultWidth: "wide",
    formattingValues: eo,
    defaultFormattingWidth: "wide"
  }),
  day: R({
    values: to,
    defaultWidth: "wide"
  }),
  dayPeriod: R({
    values: ao,
    defaultWidth: "wide",
    formattingValues: no,
    defaultFormattingWidth: "wide"
  })
}, ro = /^(\d+)\./i, io = /\d+/i, lo = {
  narrow: /^(pr\.n\.e\.|AD)/i,
  abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
  wide: /^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i
}, co = {
  any: [/^pr/i, /^(po|nova)/i]
}, uo = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?kv\.?/i,
  wide: /^[1234]\. kvartal/i
}, po = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ho = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
  wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
}, mo = {
  narrow: [
    /^1/i,
    /^2/i,
    /^3/i,
    /^4/i,
    /^5/i,
    /^6/i,
    /^7/i,
    /^8/i,
    /^9/i,
    /^10/i,
    /^11/i,
    /^12/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^avg/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, fo = {
  narrow: /^[npusčc]/i,
  short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  wide: /^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i
}, go = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, vo = {
  any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i
}, yo = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^pono/i,
    noon: /^pod/i,
    morning: /jutro/i,
    afternoon: /(posle\s|po)+podne/i,
    evening: /(uvece|uveče)/i,
    night: /(nocu|noću)/i
  }
}, wo = {
  ordinalNumber: Fe({
    matchPattern: ro,
    parsePattern: io,
    valueCallback: (n) => parseInt(n, 10)
  }),
  era: V({
    matchPatterns: lo,
    defaultMatchWidth: "wide",
    parsePatterns: co,
    defaultParseWidth: "any"
  }),
  quarter: V({
    matchPatterns: uo,
    defaultMatchWidth: "wide",
    parsePatterns: po,
    defaultParseWidth: "any",
    valueCallback: (n) => n + 1
  }),
  month: V({
    matchPatterns: ho,
    defaultMatchWidth: "wide",
    parsePatterns: mo,
    defaultParseWidth: "any"
  }),
  day: V({
    matchPatterns: fo,
    defaultMatchWidth: "wide",
    parsePatterns: go,
    defaultParseWidth: "any"
  }),
  dayPeriod: V({
    matchPatterns: vo,
    defaultMatchWidth: "any",
    parsePatterns: yo,
    defaultParseWidth: "any"
  })
}, bo = {
  code: "sr-Latn",
  formatDistance: Ba,
  formatLong: Ka,
  formatRelative: Xa,
  localize: so,
  match: wo,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, ko = "Benu na předpis", _o = "Dostupnost léků", Co = "Jaký lék hledáte?", xo = "Hledejte lék...", Po = "+ Přidejte další lék", Mo = "Zadejte prosím název léku", So = "Kde?", zo = "např. Jedlová 1", jo = "Zadejte prosím adresu", $o = "Zjistit dostupnost", Lo = "Upravit hledání", Io = "Hledáme pro vás <strong>dostupné léky...</strong>", Eo = "Využijte možnost<br /> <strong>zarezervovat si eRecept!</strong>", Ao = "Zjistili jsme dostupnost na <strong>{count}</strong> lékárně", Do = "Zjistili jsme dostupnost na <strong>{count}</strong> lékárnách", Oo = "Ukázat na mapě", Ho = "Řadit", To = "Řadit podle", Ro = "Dostupnost léků", Vo = "Vzdálenost od adresy", No = "Výsledky {currentPage}-{maxPage}", Zo = "Zadejte přesný název léku z vašeho receptu od lékaře a vaši adresu.", qo = "Časté dotazy", Bo = "Nenašli jste odpověď, kterou jste hledali?", Wo = 'Zavolejte na naši infolinku na číslo <a href="tel:{phoneNumber}">{phoneNumber}</a> nebo napište na <a href="mailto:{faq_email}">{faq_email}</a>', Fo = "+420 123 456 789", Uo = "info{'@'}benu.cz", Ko = "Navigovat do lékárny", Go = "K vyzvednuti okamžitě", Xo = "Následující pracovní den", Yo = "Ozveme se vám", Qo = "Rezervovat eRecept", Jo = "Dnes otevřeno", es = "Dnes zavřeno", ts = "Kontaktní údaje", ns = "O lékárně", as = "Otevírací doba lékárny", os = "Možnosti platby", ss = "Brzy otevírá", rs = "Brzy zavírá", is = "Aktuální poloha", ls = "Po vytvoření rezervace jsou léky připraveny <strong>k&nbsp;okamžitému vyzvednutí</strong> na vybrané lékárně.", cs = "Po vytvoření rezervace vám léky na lékárně připravíme <strong>zpravidla do 1&nbsp;pracovního dne.</strong>", us = "Po vytvoření rezervace vás bude farmaceut kontaktovat ohledně dostupnosti hledaného léku na vybrané lékárně.", ds = "Otevřeno", ps = "Zavřeno", hs = "Omlouváme se, ale tento lék bohužel aktuálně nemáme k dispozici.", ms = "Hledáte více léků současně a nejsou nikde okamžitě dostupné? Zkuste léky vyhledat samostatně nebo zobrazte dostupnost jednotlivých léků kliknutím na štítek dostupnosti.", fs = {
  title_website: ko,
  title_medicines_availability: _o,
  search_medicine: Co,
  search_placeholder: xo,
  add_medicine: Po,
  medicine_error: Mo,
  general_where: So,
  address_placeholder: zo,
  address_error: jo,
  check_availability: $o,
  adjust_search: Lo,
  searching_medicine: Io,
  use_reserve_ePrescription: Eo,
  pharmacy_count_singular: Ao,
  pharmacy_count_plural: Do,
  show_on_map: Oo,
  sort: Ho,
  sort_by: To,
  sort_by_availability_of_medicines: Ro,
  sort_by_distance_from_address: Vo,
  results: No,
  medicines_availability_description: Zo,
  faq: qo,
  faq_no_answer: Bo,
  faq_info_line_contact: Wo,
  faq_phone_number: Fo,
  faq_email: Uo,
  navigate_to_pharmacy: Ko,
  pickup_immediately: Go,
  next_working_day: Xo,
  we_will_contact_you: Yo,
  reserve_ePrescription: Qo,
  open_today: Jo,
  closed_today: es,
  contact_details: ts,
  about_the_pharmacy: ns,
  pharmacy_opening_hours: as,
  payment_methods: os,
  pharmacy_soon_open: ss,
  pharmacy_soon_close: rs,
  current_location: is,
  availability_info_stock: ls,
  availability_info_supplier: cs,
  availability_info_unavailable: us,
  open: ds,
  close: ps,
  empty_results: hs,
  unavailable_drugs_hint_message: ms
}, tt = "rx-drug-search", Pt = {
  suggestQueryArgument: "",
  suggestItemDataObjectArgument: "",
  drugsSuggestionsPath: "/api/v1/drug-search/suggest",
  faqPath: "/api/v1/content/faq",
  pharmacyDetailPath: "/api/v1/pharmacy",
  rxSearchPath: "/api/v1/drug-search/availability",
  reservationsLink: "https://www.benunapredpis.cz/rezervace-leku-na-predpis-z-ereceptu"
}, gs = { cs: fs }, fe = Yt("rx-data-attributes", Pt);
async function vs() {
  const n = fe();
  try {
    const { data: e } = await Se.get(`${n.datasetUrls.faqPath}?type=rxsearch`);
    return kn(e);
  } catch {
    throw new Error("Error while fetching FAQ data for RX reservation");
  }
}
const ys = /* @__PURE__ */ z({
  __name: "FaqQuestions",
  setup(n) {
    const e = k(!0), t = k([]);
    return je(async () => {
      e.value = !0;
      try {
        t.value = await vs();
      } catch {
        t.value = [];
      } finally {
        e.value = !1;
      }
    }), (a, o) => (b(), D(m(Qt), {
      tabs: t.value,
      loading: e.value,
      multiple: ""
    }, null, 8, ["tabs", "loading"]));
  }
});
async function ws(n) {
  const e = fe();
  try {
    const { data: t } = await Se.post(
      e.datasetUrls.rxSearchPath,
      n
    );
    return t.data;
  } catch {
    throw new Error("Error while fetching Rx search records");
  }
}
const ke = 10, Le = Be("rxResults", () => {
  const n = ["stock", "supplier", "unavailable"], e = k(0), t = k("availability"), a = k([]), o = k(!1), s = k(), r = k(!1), l = S(() => {
    const g = [...a.value].sort((y, w) => y.distance - w.distance);
    return t.value === "availability" ? g == null ? void 0 : g.sort((y, w) => n.indexOf(y.availability) - n.indexOf(w.availability)) : g;
  }), i = S(() => a.value.length), d = S(() => i.value > ke), u = S(() => e.value / ke + 1), c = S(() => Math.ceil(i.value / ke)), h = S(
    () => l.value.slice(e.value, e.value + ke)
  );
  async function v(g) {
    a.value = await ws(g), o.value = !0, e.value = 0;
  }
  function p(g) {
    t.value = g, e.value = 0;
  }
  return {
    activePageNumber: u,
    indexOfFirstItem: e,
    sortingBy: t,
    hasPagination: d,
    filteredResults: h,
    resultsCount: i,
    searchResults: a,
    hasBeenSearched: o,
    maxPageNumber: c,
    searchCoordinates: s,
    hasSearchedMoreDrugs: r,
    onSearch: v,
    setSortingBy: p
  };
});
async function bs(n) {
  const e = fe();
  try {
    const { data: t } = await Se.get(
      `${e.datasetUrls.pharmacyDetailPath}/${n}`
    );
    return t.data;
  } catch {
    throw new Error("Error while fetching pharmacy detail");
  }
}
const Mt = Be("pharmacyDetails", () => {
  const n = k([]);
  async function e(a) {
    const o = await bs(a);
    return n.value.push(o), o;
  }
  async function t(a) {
    return n.value.find((o) => o.id === a) ?? await e(a);
  }
  return {
    pharmacyDetails: n,
    getPharmacyDetail: t
  };
}), Ie = Be("selected-pharmacy-map-dialog", () => {
  const n = k(!1), e = k(null), t = k(null);
  async function a(r) {
    const l = Mt();
    n.value = !0, e.value = r, t.value = await l.getPharmacyDetail(r.id);
  }
  function o() {
    e.value = null, t.value = null;
  }
  function s() {
    n.value = !1, o();
  }
  return {
    showMap: n,
    selectedPharmacy: e,
    selectedPharmacyDetail: t,
    setSelectedPharmacy: a,
    unselectPharmacy: o,
    closeMapDialog: s
  };
}), St = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14"><path fill="currentColor" d="M.5 2.438v.812h7.719v6.094H5.718a1.62 1.62 0 0 0-1.562-1.219c-.752 0-1.38.52-1.561 1.219h-.47V7.313h-.813v2.843h1.283a1.62 1.62 0 0 0 1.561 1.219c.753 0 1.38-.52 1.562-1.219h3.377a1.62 1.62 0 0 0 1.561 1.219c.753 0 1.38-.52 1.562-1.219H13.5V6.843l-.026-.064-.812-2.437-.088-.28H9.03V2.438Zm.406 1.624v.813h3.656v-.813Zm8.125.813h2.958l.698 2.082v2.387h-.47a1.62 1.62 0 0 0-1.56-1.219c-.753 0-1.381.52-1.562 1.219H9.03V4.875Zm-7.719.813V6.5H3.75v-.813H1.312Zm2.844 3.25c.454 0 .813.358.813.812a.806.806 0 0 1-.813.813.806.806 0 0 1-.812-.813c0-.454.358-.813.812-.813zm6.5 0c.454 0 .813.358.813.812a.806.806 0 0 1-.813.813.806.806 0 0 1-.812-.813c0-.454.358-.813.812-.813z"/></svg>
`, zt = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14"><path fill="currentColor" d="M7 .5a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13zm0 1.3a5.2 5.2 0 1 0 0 10.4A5.2 5.2 0 0 0 7 1.8Zm0 7.8a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3Zm0-6.17a2.36 2.36 0 0 1 .88 4.54.54.54 0 0 0-.2.13c-.03.03-.04.07-.04.12l.01.08a.65.65 0 0 1-1.3.08v-.24c0-.75.6-1.2 1.04-1.38a1.06 1.06 0 1 0-1.45-.98.65.65 0 1 1-1.3 0A2.36 2.36 0 0 1 7 3.42Z" /></svg>
`, jt = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14"><path fill="currentColor" d="m11.69 4.66.64-.61a.68.68 0 0 0 0-.97.72.72 0 0 0-1 0l-.64.62a5.74 5.74 0 0 0-6.89 0l-.64-.63a.72.72 0 0 0-1 0 .68.68 0 0 0 0 .98l.65.62a5.31 5.31 0 0 0-.57 5.86 5.52 5.52 0 0 0 4.2 2.91 5.8 5.8 0 0 0 4.88-1.63 5.43 5.43 0 0 0 1.46-4.8 5.4 5.4 0 0 0-1.1-2.35Zm-4.44 7.46c-.84 0-1.65-.24-2.35-.7A4.13 4.13 0 0 1 3.35 9.6a3.99 3.99 0 0 1 .91-4.47 4.27 4.27 0 0 1 4.6-.89 4.2 4.2 0 0 1 1.9 1.51 4.02 4.02 0 0 1-.52 5.18 4.3 4.3 0 0 1-2.99 1.2ZM5.85 1.87h2.8c.2 0 .37-.08.5-.2a.67.67 0 0 0 0-.97.72.72 0 0 0-.5-.2h-2.8a.72.72 0 0 0-.5.2.67.67 0 0 0 0 .97c.13.12.3.2.5.2Z"/><path fill="currentColor" d="m5.6 10.66-.33-.13 1.1-1.93-1.16-.43c-.29-.1-.02-.26-.01-.26l3.03-2.28.33.12-1.1 1.93 1.16.43c.14.05.19.13.06.24l-3.08 2.3Z"/></svg>
`, ks = ["innerHTML"], _s = { class: "mt-1 flex items-center first:mt-0 sm:mt-2" }, Cs = ["innerHTML"], $t = /* @__PURE__ */ z({
  __name: "AvailabilityPopover",
  props: {
    overallAvailability: {},
    individualItems: {}
  },
  setup(n) {
    const e = n, { t } = U(), a = S(() => {
      switch (e.overallAvailability) {
        case "stock":
          return t("availability_info_stock");
        case "supplier":
          return t("availability_info_supplier");
        default:
          return t("availability_info_unavailable");
      }
    }), o = S(() => {
      const s = e.individualItems.filter((i) => i.availability === "stock"), r = e.individualItems.filter((i) => i.availability === "supplier"), l = e.individualItems.filter((i) => i.availability === "unavailable");
      return {
        ...s.length && {
          stock: {
            label: t("pickup_immediately"),
            icon: jt,
            color: "text-green-500",
            items: s
          }
        },
        ...r.length && {
          supplier: {
            label: t("next_working_day"),
            icon: St,
            color: "text-blue-500",
            items: r
          }
        },
        ...l.length && {
          unavailable: {
            label: t("we_will_contact_you"),
            icon: zt,
            color: "text-orange-400",
            items: l
          }
        }
      };
    });
    return (s, r) => (b(), D(m(Jt), { "content-class": "w-[calc(100vw-1rem)] sm:max-w-xs" }, {
      control: I(() => [
        xe(s.$slots, "default")
      ]),
      header: I(() => [
        f("div", {
          class: "pr-4 sm:pr-0",
          innerHTML: a.value
        }, null, 8, ks)
      ]),
      content: I(() => [
        (b(!0), x(N, null, X(o.value, (l, i) => (b(), x(N, { key: i }, [
          l ? (b(), x(N, { key: 0 }, [
            f("div", _s, [
              f("span", {
                class: G(["mr-1.5 size-3", l.color]),
                innerHTML: l.icon
              }, null, 10, Cs),
              f("strong", null, P(l.label), 1)
            ]),
            r[0] || (r[0] = f("hr", { class: "mb-1 mt-[1px] border-gray-100 sm:mt-1" }, null, -1)),
            f("ul", null, [
              (b(!0), x(N, null, X(l.items, (d) => (b(), x("li", {
                key: d.id,
                class: "text-mobile-caption-m"
              }, P(d.name), 1))), 128))
            ])
          ], 64)) : Z("", !0)
        ], 64))), 128))
      ]),
      _: 3
    }));
  }
}), xs = {
  class: "h-10 w-auto cursor-pointer",
  viewBox: "0 0 34 53",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ps = { filter: "url(#shadow-level-2)" }, Ms = ["fill", "stroke"], Ss = ["fill"], nt = /* @__PURE__ */ z({
  __name: "BenuMapPin",
  props: {
    availability: {},
    isActive: { type: Boolean }
  },
  setup(n) {
    const e = n, t = S(() => e.isActive ? "none" : "#5a8f3c"), a = S(() => e.isActive ? "#5a8f3c" : "#ffffff"), o = S(() => {
      switch (e.availability) {
        case "stock":
          return "#679c2b";
        case "supplier":
          return "#32dbc6";
        case "unavailable":
          return "#ff8c3c";
        default:
          return "#ff8c3c";
      }
    });
    return (s, r) => (b(), x("svg", xs, [
      r[4] || (r[4] = hn('<defs><filter id="shadow-level-2" x="-50%" y="-50%" width="200%" height="200%"><feDropShadow dx="0" dy="0" stdDeviation="1" flood-color="#4F5E711F"></feDropShadow><feDropShadow dx="0" dy="2" stdDeviation="2" flood-color="#4F5E711C"></feDropShadow><feDropShadow dx="0" dy="4" stdDeviation="4" flood-color="#4F5E711A"></feDropShadow><feDropShadow dx="0" dy="16" stdDeviation="16" flood-color="#4F5E7117"></feDropShadow></filter></defs>', 1)),
      f("g", Ps, [
        f("path", {
          d: "M30.244 19.601c0 8.175-3.842 20.433-14.643 31.572C3.78 39.044.959 27.806.959 19.6.959 11.514 7.514 4.96 15.6 4.96c8.088 0 14.643 6.555 14.643 14.642Z",
          fill: a.value,
          stroke: t.value,
          "stroke-width": "1.917"
        }, null, 8, Ms),
        f("path", {
          d: "M19.616 7.834c0-3.239 2.759-5.946 6.265-5.946s6.266 2.707 6.266 5.946c0 3.24-2.76 5.946-6.266 5.946-3.506 0-6.265-2.707-6.265-5.946Z",
          fill: o.value,
          stroke: "#fff",
          "stroke-width": "2.167"
        }, null, 8, Ss),
        r[0] || (r[0] = f("circle", {
          cx: "15.337",
          cy: "19.976",
          r: "8.947",
          fill: "#EEF6E8"
        }, null, -1)),
        r[1] || (r[1] = f("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M21.709 17.307H18.53v-3.179a.544.544 0 0 0-.543-.542h-4.776a.544.544 0 0 0-.543.542v3.18H9.489a.544.544 0 0 0-.542.541v4.777c0 .299.244.543.542.543h3.179v3.179c0 .298.244.543.543.543h4.776a.544.544 0 0 0 .543-.543v-3.179h3.179a.544.544 0 0 0 .543-.543V17.85a.544.544 0 0 0-.543-.542Z",
          fill: "#58A618"
        }, null, -1)),
        r[2] || (r[2] = f("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M14.324 19.645a2.451 2.451 0 0 1 3.393-2.362c-.424-.318-.918-.576-1.465-.646a1.926 1.926 0 0 0-1.136.227c-.382.2-.58.486-.58.486s-.01-.331.295-.628c.033-.032.069-.06.102-.085-.33.061-.608.122-.936.316-.216.127-.386.33-.522.643-.133.31-.108.68-.108.68s-.206-.337-.175-.655c.006-.054.025-.103.04-.149-.298.209-.478.394-.588.673-.076.19-.098.346-.028.68.052.249.252.451.252.451s-.284-.1-.407-.305a.896.896 0 0 1-.1-.322c-.206.45-.321.95-.321 1.477 0 .635.167 1.232.46 1.748a2.616 2.616 0 0 1 1.824-2.23Z",
          fill: "#BBD89C"
        }, null, -1)),
        r[3] || (r[3] = f("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M21.558 20.022s-.813-.249-1.771-1.381a2.436 2.436 0 0 0-.102-.113c.46.264.8.47 1.222.42-.802-.182-1.157-.849-1.862-1.12-1.357-.538-2.353.346-2.353.346v.001c-.08.052-.23.145-.3.19-1.253.803-1.735 1.253-1.735 1.253l1.834-.923s.67.72 1.448-.035a.839.839 0 0 0-.7-.224.193.193 0 1 1-.199-.044.129.129 0 0 1 .025-.009l.004-.002a.94.94 0 0 1 .902.191c.456.468.354.826.281 1.013-.379.78-1.225.66-1.582.57v-.001a3.455 3.455 0 0 1-.125-.036l-.039-.014v.001a4.293 4.293 0 0 1-.416-.157c-.004-.001-.006-.003-.007-.002a2.447 2.447 0 0 0-3.33 2.283v.021a3.631 3.631 0 0 0 .891.843c.119.078.243.15.371.213v.002c.474.238 1.009.372 1.575.373l-.013-.008a.909.909 0 0 1-.306-.518s.212.261.497.355c.253.082.462.1.614.085.308-.03.542-.142.76-.267a1.734 1.734 0 0 1-.21-.027c-.425-.08-.575-.45-.575-.45s.373.164.72.18c.505.024.77-.175.92-.285.215-.156.393-.358.52-.598-.056.03-.119.059-.187.086-.356.141-.862-.08-.862-.08s.431-.02.833-.281c.52-.339.672-.68.738-.88.087-.268.104-.56.104-.855l-.003-.12a1.4 1.4 0 0 1-.064.202c-.413 1.018-1.933 1.362-3.396.769a4.159 4.159 0 0 1-.219-.097l.005-.043c.06-.18.19-.33.478-.238.172.058.42.124.635.17 1.575.326 2.206-.82 2.276-1.092.185-.787-.185-1.293-.27-1.394a.922.922 0 0 0-.162-.175c.331.087.73.287 1.156.71 1.119 1.113 1.979 1.192 1.979 1.192Z",
          fill: "#FEFEFE"
        }, null, -1))
      ])
    ]));
  }
});
(function() {
  try {
    if (typeof document < "u") {
      var n = document.createElement("style");
      n.appendChild(document.createTextNode(".mapdiv[data-v-dbf82c40]{width:100%;height:100%}.custom-control-wrapper[data-v-d099a3a6]{display:none}.mapdiv .custom-control-wrapper[data-v-d099a3a6]{display:inline-block}.info-window-wrapper[data-v-cbe1707b]{display:none}.mapdiv .info-window-wrapper[data-v-cbe1707b]{display:inline-block}.custom-marker-wrapper[data-v-2d2d343a]{display:none}.mapdiv .custom-marker-wrapper[data-v-2d2d343a]{display:inline-block}")), document.head.appendChild(n);
    }
  } catch (e) {
    console.error("vite-plugin-css-injected-by-js", e);
  }
})();
var zs = Object.defineProperty, js = (n, e, t) => e in n ? zs(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, at = (n, e, t) => (js(n, typeof e != "symbol" ? e + "" : e, t), t);
const ge = Symbol("map"), ve = Symbol("api"), Lt = Symbol("marker"), It = Symbol("markerCluster"), Ee = Symbol("CustomMarker"), Et = Symbol("mapTilesLoaded"), pe = [
  "click",
  "dblclick",
  "drag",
  "dragend",
  "dragstart",
  "mousedown",
  "mousemove",
  "mouseout",
  "mouseover",
  "mouseup",
  "rightclick"
];
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function $s(n, e, t, a) {
  function o(s) {
    return s instanceof t ? s : new t(function(r) {
      r(s);
    });
  }
  return new (t || (t = Promise))(function(s, r) {
    function l(u) {
      try {
        d(a.next(u));
      } catch (c) {
        r(c);
      }
    }
    function i(u) {
      try {
        d(a.throw(u));
      } catch (c) {
        r(c);
      }
    }
    function d(u) {
      u.done ? s(u.value) : o(u.value).then(l, i);
    }
    d((a = a.apply(n, [])).next());
  });
}
var Ls = function n(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    var a, o, s;
    if (Array.isArray(e)) {
      if (a = e.length, a != t.length)
        return !1;
      for (o = a; o-- !== 0; )
        if (!n(e[o], t[o]))
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === t.toString();
    if (s = Object.keys(e), a = s.length, a !== Object.keys(t).length)
      return !1;
    for (o = a; o-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, s[o]))
        return !1;
    for (o = a; o-- !== 0; ) {
      var r = s[o];
      if (!n(e[r], t[r]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
};
const ot = "__googleMapsScriptId";
var le;
(function(n) {
  n[n.INITIALIZED = 0] = "INITIALIZED", n[n.LOADING = 1] = "LOADING", n[n.SUCCESS = 2] = "SUCCESS", n[n.FAILURE = 3] = "FAILURE";
})(le || (le = {}));
class ae {
  /**
   * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
   * using this library, instead the defaults are set by the Google Maps
   * JavaScript API server.
   *
   * ```
   * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
   * ```
   */
  constructor({ apiKey: e, authReferrerPolicy: t, channel: a, client: o, id: s = ot, language: r, libraries: l = [], mapIds: i, nonce: d, region: u, retries: c = 3, url: h = "https://maps.googleapis.com/maps/api/js", version: v }) {
    if (this.callbacks = [], this.done = !1, this.loading = !1, this.errors = [], this.apiKey = e, this.authReferrerPolicy = t, this.channel = a, this.client = o, this.id = s || ot, this.language = r, this.libraries = l, this.mapIds = i, this.nonce = d, this.region = u, this.retries = c, this.url = h, this.version = v, ae.instance) {
      if (!Ls(this.options, ae.instance.options))
        throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify(ae.instance.options)}`);
      return ae.instance;
    }
    ae.instance = this;
  }
  get options() {
    return {
      version: this.version,
      apiKey: this.apiKey,
      channel: this.channel,
      client: this.client,
      id: this.id,
      libraries: this.libraries,
      language: this.language,
      region: this.region,
      mapIds: this.mapIds,
      nonce: this.nonce,
      url: this.url,
      authReferrerPolicy: this.authReferrerPolicy
    };
  }
  get status() {
    return this.errors.length ? le.FAILURE : this.done ? le.SUCCESS : this.loading ? le.LOADING : le.INITIALIZED;
  }
  get failed() {
    return this.done && !this.loading && this.errors.length >= this.retries + 1;
  }
  /**
   * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
   *
   * @ignore
   * @deprecated
   */
  createUrl() {
    let e = this.url;
    return e += "?callback=__googleMapsCallback", this.apiKey && (e += `&key=${this.apiKey}`), this.channel && (e += `&channel=${this.channel}`), this.client && (e += `&client=${this.client}`), this.libraries.length > 0 && (e += `&libraries=${this.libraries.join(",")}`), this.language && (e += `&language=${this.language}`), this.region && (e += `&region=${this.region}`), this.version && (e += `&v=${this.version}`), this.mapIds && (e += `&map_ids=${this.mapIds.join(",")}`), this.authReferrerPolicy && (e += `&auth_referrer_policy=${this.authReferrerPolicy}`), e;
  }
  deleteScript() {
    const e = document.getElementById(this.id);
    e && e.remove();
  }
  /**
   * Load the Google Maps JavaScript API script and return a Promise.
   * @deprecated, use importLibrary() instead.
   */
  load() {
    return this.loadPromise();
  }
  /**
   * Load the Google Maps JavaScript API script and return a Promise.
   *
   * @ignore
   * @deprecated, use importLibrary() instead.
   */
  loadPromise() {
    return new Promise((e, t) => {
      this.loadCallback((a) => {
        a ? t(a.error) : e(window.google);
      });
    });
  }
  importLibrary(e) {
    return this.execute(), google.maps.importLibrary(e);
  }
  /**
   * Load the Google Maps JavaScript API script with a callback.
   * @deprecated, use importLibrary() instead.
   */
  loadCallback(e) {
    this.callbacks.push(e), this.execute();
  }
  /**
   * Set the script on document.
   */
  setScript() {
    var e, t;
    if (document.getElementById(this.id)) {
      this.callback();
      return;
    }
    const a = {
      key: this.apiKey,
      channel: this.channel,
      client: this.client,
      libraries: this.libraries.length && this.libraries,
      v: this.version,
      mapIds: this.mapIds,
      language: this.language,
      region: this.region,
      authReferrerPolicy: this.authReferrerPolicy
    };
    Object.keys(a).forEach(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (s) => !a[s] && delete a[s]
    ), !((t = (e = window == null ? void 0 : window.google) === null || e === void 0 ? void 0 : e.maps) === null || t === void 0) && t.importLibrary || ((s) => {
      let r, l, i, d = "The Google Maps JavaScript API", u = "google", c = "importLibrary", h = "__ib__", v = document, p = window;
      p = p[u] || (p[u] = {});
      const g = p.maps || (p.maps = {}), y = /* @__PURE__ */ new Set(), w = new URLSearchParams(), _ = () => (
        // @ts-ignore
        r || (r = new Promise((C, $) => $s(this, void 0, void 0, function* () {
          var E;
          yield l = v.createElement("script"), l.id = this.id, w.set("libraries", [...y] + "");
          for (i in s)
            w.set(i.replace(/[A-Z]/g, (q) => "_" + q[0].toLowerCase()), s[i]);
          w.set("callback", u + ".maps." + h), l.src = this.url + "?" + w, g[h] = C, l.onerror = () => r = $(Error(d + " could not load.")), l.nonce = this.nonce || ((E = v.querySelector("script[nonce]")) === null || E === void 0 ? void 0 : E.nonce) || "", v.head.append(l);
        })))
      );
      g[c] ? console.warn(d + " only loads once. Ignoring:", s) : g[c] = (C, ...$) => y.add(C) && _().then(() => g[c](C, ...$));
    })(a);
    const o = this.libraries.map((s) => this.importLibrary(s));
    o.length || o.push(this.importLibrary("core")), Promise.all(o).then(() => this.callback(), (s) => {
      const r = new ErrorEvent("error", { error: s });
      this.loadErrorCallback(r);
    });
  }
  /**
   * Reset the loader state.
   */
  reset() {
    this.deleteScript(), this.done = !1, this.loading = !1, this.errors = [], this.onerrorEvent = null;
  }
  resetIfRetryingFailed() {
    this.failed && this.reset();
  }
  loadErrorCallback(e) {
    if (this.errors.push(e), this.errors.length <= this.retries) {
      const t = this.errors.length * Math.pow(2, this.errors.length);
      console.error(`Failed to load Google Maps script, retrying in ${t} ms.`), setTimeout(() => {
        this.deleteScript(), this.setScript();
      }, t);
    } else
      this.onerrorEvent = e, this.callback();
  }
  callback() {
    this.done = !0, this.loading = !1, this.callbacks.forEach((e) => {
      e(this.onerrorEvent);
    }), this.callbacks = [];
  }
  execute() {
    if (this.resetIfRetryingFailed(), this.done)
      this.callback();
    else {
      if (window.google && window.google.maps && window.google.maps.version) {
        console.warn("Google Maps already loaded outside @googlemaps/js-api-loader.This may result in undesirable behavior as options and script parameters may not match."), this.callback();
        return;
      }
      this.loading || (this.loading = !0, this.setScript());
    }
  }
}
function Is(n) {
  return class extends n.OverlayView {
    constructor(e) {
      super(), at(this, "element"), at(this, "opts");
      const { element: t, ...a } = e;
      this.element = t, this.opts = a, this.opts.map && this.setMap(this.opts.map);
    }
    getPosition() {
      return this.opts.position ? this.opts.position instanceof n.LatLng ? this.opts.position : new n.LatLng(this.opts.position) : null;
    }
    getVisible() {
      if (!this.element)
        return !1;
      const e = this.element;
      return e.style.display !== "none" && e.style.visibility !== "hidden" && (e.style.opacity === "" || Number(e.style.opacity) > 0.01);
    }
    onAdd() {
      if (!this.element)
        return;
      const e = this.getPanes();
      e && e.overlayMouseTarget.appendChild(this.element);
    }
    draw() {
      if (!this.element)
        return;
      const e = this.getProjection(), t = e == null ? void 0 : e.fromLatLngToDivPixel(this.getPosition());
      if (t) {
        this.element.style.position = "absolute";
        const a = this.element.offsetHeight, o = this.element.offsetWidth;
        let s, r;
        switch (this.opts.anchorPoint) {
          case "TOP_CENTER":
            s = t.x - o / 2, r = t.y;
            break;
          case "BOTTOM_CENTER":
            s = t.x - o / 2, r = t.y - a;
            break;
          case "LEFT_CENTER":
            s = t.x, r = t.y - a / 2;
            break;
          case "RIGHT_CENTER":
            s = t.x - o, r = t.y - a / 2;
            break;
          case "TOP_LEFT":
            s = t.x, r = t.y;
            break;
          case "TOP_RIGHT":
            s = t.x - o, r = t.y;
            break;
          case "BOTTOM_LEFT":
            s = t.x, r = t.y - a;
            break;
          case "BOTTOM_RIGHT":
            s = t.x - o, r = t.y - a;
            break;
          default:
            s = t.x - o / 2, r = t.y - a / 2;
        }
        this.element.style.left = s + "px", this.element.style.top = r + "px", this.element.style.transform = `translateX(${this.opts.offsetX || 0}px) translateY(${this.opts.offsetY || 0}px)`, this.opts.zIndex && (this.element.style.zIndex = this.opts.zIndex.toString());
      }
    }
    onRemove() {
      this.element && this.element.remove();
    }
    setOptions(e) {
      const { element: t, ...a } = e;
      this.element = t, this.opts = a, this.draw();
    }
  };
}
let st;
const rt = [
  "bounds_changed",
  "center_changed",
  "click",
  "contextmenu",
  "dblclick",
  "drag",
  "dragend",
  "dragstart",
  "heading_changed",
  "idle",
  "isfractionalzoomenabled_changed",
  "mapcapabilities_changed",
  "maptypeid_changed",
  "mousemove",
  "mouseout",
  "mouseover",
  "projection_changed",
  "renderingtype_changed",
  "rightclick",
  "tilesloaded",
  "tilt_changed",
  "zoom_changed"
], Es = z({
  props: {
    apiPromise: {
      type: Promise
    },
    apiKey: {
      type: String,
      default: ""
    },
    version: {
      type: String,
      default: "weekly"
    },
    libraries: {
      type: Array,
      default: () => ["places"]
    },
    region: {
      type: String,
      required: !1
    },
    language: {
      type: String,
      required: !1
    },
    backgroundColor: {
      type: String,
      required: !1
    },
    center: {
      type: Object,
      default: () => ({ lat: 0, lng: 0 })
    },
    clickableIcons: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    controlSize: {
      type: Number,
      required: !1
    },
    disableDefaultUi: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    disableDoubleClickZoom: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    draggable: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    draggableCursor: {
      type: String,
      required: !1
    },
    draggingCursor: {
      type: String,
      required: !1
    },
    fullscreenControl: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    fullscreenControlPosition: {
      type: String,
      required: !1
    },
    gestureHandling: {
      type: String,
      required: !1
    },
    heading: {
      type: Number,
      required: !1
    },
    isFractionalZoomEnabled: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    keyboardShortcuts: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    mapTypeControl: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    mapTypeControlOptions: {
      type: Object,
      required: !1
    },
    mapTypeId: {
      type: [Number, String],
      required: !1
    },
    mapId: {
      type: String,
      required: !1
    },
    maxZoom: {
      type: Number,
      required: !1
    },
    minZoom: {
      type: Number,
      required: !1
    },
    noClear: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    panControl: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    panControlPosition: {
      type: String,
      required: !1
    },
    restriction: {
      type: Object,
      required: !1
    },
    rotateControl: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    rotateControlPosition: {
      type: String,
      required: !1
    },
    scaleControl: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    scaleControlStyle: {
      type: Number,
      required: !1
    },
    scrollwheel: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    streetView: {
      type: Object,
      required: !1
    },
    streetViewControl: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    streetViewControlPosition: {
      type: String,
      required: !1
    },
    styles: {
      type: Array,
      required: !1
    },
    tilt: {
      type: Number,
      required: !1
    },
    zoom: {
      type: Number,
      required: !1
    },
    zoomControl: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    zoomControlPosition: {
      type: String,
      required: !1
    },
    nonce: {
      type: String,
      default: ""
    }
  },
  emits: rt,
  setup(n, { emit: e }) {
    const t = k(), a = k(!1), o = k(), s = k(), r = k(!1);
    _e(ge, o), _e(ve, s), _e(Et, r);
    const l = () => {
      const c = { ...n };
      Object.keys(c).forEach((p) => {
        c[p] === void 0 && delete c[p];
      });
      const h = (p) => {
        var g;
        return p ? { position: (g = s.value) == null ? void 0 : g.ControlPosition[p] } : {};
      }, v = {
        scaleControlOptions: n.scaleControlStyle ? { style: n.scaleControlStyle } : {},
        panControlOptions: h(n.panControlPosition),
        zoomControlOptions: h(n.zoomControlPosition),
        rotateControlOptions: h(n.rotateControlPosition),
        streetViewControlOptions: h(n.streetViewControlPosition),
        fullscreenControlOptions: h(n.fullscreenControlPosition),
        disableDefaultUI: n.disableDefaultUi
      };
      return { ...c, ...v };
    }, i = B(
      [s, o],
      ([c, h]) => {
        const v = c, p = h;
        v && p && (v.event.addListenerOnce(p, "tilesloaded", () => {
          r.value = !0;
        }), setTimeout(i, 0));
      },
      { immediate: !0 }
    ), d = () => {
      try {
        const { apiKey: c, region: h, version: v, language: p, libraries: g, nonce: y } = n;
        st = new ae({ apiKey: c, region: h, version: v, language: p, libraries: g, nonce: y });
      } catch (c) {
        console.error(c);
      }
    }, u = (c) => {
      s.value = te(c.maps), o.value = te(new c.maps.Map(t.value, l()));
      const h = Is(s.value);
      s.value[Ee] = h, rt.forEach((p) => {
        var g;
        (g = o.value) == null || g.addListener(p, (y) => e(p, y));
      }), a.value = !0;
      const v = Object.keys(n).filter(
        (p) => !["apiPromise", "apiKey", "version", "libraries", "region", "language", "center", "zoom", "nonce"].includes(p)
      ).map((p) => me(n, p));
      B(
        [() => n.center, () => n.zoom, ...v],
        ([p, g], [y, w]) => {
          var _, C, $;
          const { center: E, zoom: q, ...O } = l();
          (_ = o.value) == null || _.setOptions(O), g !== void 0 && g !== w && ((C = o.value) == null || C.setZoom(g));
          const Q = !y || p.lng !== y.lng || p.lat !== y.lat;
          p && Q && (($ = o.value) == null || $.panTo(p));
        }
      );
    };
    return je(() => {
      n.apiPromise && n.apiPromise instanceof Promise ? n.apiPromise.then(u) : (d(), st.load().then(u));
    }), he(() => {
      var c;
      r.value = !1, o.value && ((c = s.value) == null || c.event.clearInstanceListeners(o.value));
    }), { mapRef: t, ready: a, map: o, api: s, mapTilesLoaded: r };
  }
}), At = (n, e) => {
  const t = n.__vccOpts || n;
  for (const [a, o] of e)
    t[a] = o;
  return t;
}, As = {
  ref: "mapRef",
  class: "mapdiv"
};
function Ds(n, e, t, a, o, s) {
  return b(), x("div", null, [
    f("div", As, null, 512),
    xe(n.$slots, "default", kt(_t({ ready: n.ready, map: n.map, api: n.api, mapTilesLoaded: n.mapTilesLoaded })), void 0, !0)
  ]);
}
const Os = /* @__PURE__ */ At(Es, [["render", Ds], ["__scopeId", "data-v-dbf82c40"]]);
function Hs(n) {
  return n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var Ts = function n(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    var a, o, s;
    if (Array.isArray(e)) {
      if (a = e.length, a != t.length)
        return !1;
      for (o = a; o-- !== 0; )
        if (!n(e[o], t[o]))
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === t.toString();
    if (s = Object.keys(e), a = s.length, a !== Object.keys(t).length)
      return !1;
    for (o = a; o-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, s[o]))
        return !1;
    for (o = a; o-- !== 0; ) {
      var r = s[o];
      if (!n(e[r], t[r]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
};
const ie = /* @__PURE__ */ Hs(Ts), Rs = (n) => n === "Marker", Vs = (n) => n === Ee, ye = (n, e, t, a) => {
  const o = k(), s = F(ge, k()), r = F(ve, k()), l = F(It, k()), i = S(
    () => !!(l.value && r.value && (o.value instanceof r.value.Marker || o.value instanceof r.value[Ee]))
  );
  return B(
    [s, t],
    (d, [u, c]) => {
      var h, v, p;
      const g = !ie(t.value, c) || s.value !== u;
      !s.value || !r.value || !g || (o.value ? (o.value.setOptions(t.value), i.value && ((h = l.value) == null || h.removeMarker(o.value), (v = l.value) == null || v.addMarker(o.value))) : (Rs(n) ? o.value = te(
        new r.value[n](t.value)
      ) : Vs(n) ? o.value = te(
        new r.value[n](t.value)
      ) : o.value = te(
        new r.value[n]({
          ...t.value,
          map: s.value
        })
      ), i.value ? (p = l.value) == null || p.addMarker(o.value) : o.value.setMap(s.value), e.forEach((y) => {
        var w;
        (w = o.value) == null || w.addListener(y, (_) => a(y, _));
      })));
    },
    {
      immediate: !0
    }
  ), he(() => {
    var d, u;
    o.value && ((d = r.value) == null || d.event.clearInstanceListeners(o.value), i.value ? (u = l.value) == null || u.removeMarker(o.value) : o.value.setMap(null));
  }), o;
}, it = [
  "animation_changed",
  "click",
  "dblclick",
  "rightclick",
  "dragstart",
  "dragend",
  "drag",
  "mouseover",
  "mousedown",
  "mouseout",
  "mouseup",
  "draggable_changed",
  "clickable_changed",
  "contextmenu",
  "cursor_changed",
  "flat_changed",
  "rightclick",
  "zindex_changed",
  "icon_changed",
  "position_changed",
  "shape_changed",
  "title_changed",
  "visible_changed"
];
z({
  name: "Marker",
  props: {
    options: {
      type: Object,
      required: !0
    }
  },
  emits: it,
  setup(n, { emit: e, expose: t, slots: a }) {
    const o = me(n, "options"), s = ye("Marker", it, o, e);
    return _e(Lt, s), t({ marker: s }), () => {
      var r;
      return (r = a.default) == null ? void 0 : r.call(a);
    };
  }
});
z({
  name: "Polyline",
  props: {
    options: {
      type: Object,
      required: !0
    }
  },
  emits: pe,
  setup(n, { emit: e }) {
    const t = me(n, "options");
    return { polyline: ye("Polyline", pe, t, e) };
  },
  render: () => null
});
z({
  name: "Polygon",
  props: {
    options: {
      type: Object,
      required: !0
    }
  },
  emits: pe,
  setup(n, { emit: e }) {
    const t = me(n, "options");
    return { polygon: ye("Polygon", pe, t, e) };
  },
  render: () => null
});
const lt = pe.concat(["bounds_changed"]);
z({
  name: "Rectangle",
  props: {
    options: {
      type: Object,
      required: !0
    }
  },
  emits: lt,
  setup(n, { emit: e }) {
    const t = me(n, "options");
    return { rectangle: ye("Rectangle", lt, t, e) };
  },
  render: () => null
});
const ct = pe.concat(["center_changed", "radius_changed"]);
z({
  name: "Circle",
  props: {
    options: {
      type: Object,
      required: !0
    }
  },
  emits: ct,
  setup(n, { emit: e }) {
    const t = me(n, "options");
    return { circle: ye("Circle", ct, t, e) };
  },
  render: () => null
});
z({
  props: {
    position: {
      type: String,
      required: !0
    },
    index: {
      type: Number,
      default: 1
    }
  },
  emits: ["content:loaded"],
  setup(n, { emit: e }) {
    const t = k(null), a = F(ge, k()), o = F(ve, k()), s = F(Et, k(!1)), r = B(
      [s, o, t],
      ([d, u, c]) => {
        u && d && c && (l(n.position), e("content:loaded"), setTimeout(r, 0));
      },
      { immediate: !0 }
    ), l = (d) => {
      if (a.value && o.value && t.value) {
        const u = o.value.ControlPosition[d];
        a.value.controls[u].push(t.value);
      }
    }, i = (d) => {
      if (a.value && o.value) {
        let u = null;
        const c = o.value.ControlPosition[d];
        a.value.controls[c].forEach((h, v) => {
          h === t.value && (u = v);
        }), u !== null && a.value.controls[c].removeAt(u);
      }
    };
    return he(() => i(n.position)), B(
      () => n.position,
      (d, u) => {
        i(u), l(d);
      }
    ), B(
      () => n.index,
      (d) => {
        d && t.value && (t.value.index = n.index);
      }
    ), { controlRef: t };
  }
});
const ut = ["closeclick", "content_changed", "domready", "position_changed", "visible", "zindex_changed"];
z({
  inheritAttrs: !1,
  props: {
    options: {
      type: Object,
      default: () => ({})
    },
    modelValue: {
      type: Boolean
    }
  },
  emits: [...ut, "update:modelValue"],
  setup(n, { slots: e, emit: t, expose: a }) {
    const o = k(), s = k(), r = F(ge, k()), l = F(ve, k()), i = F(Lt, k());
    let d, u = n.modelValue;
    const c = S(() => {
      var g;
      return (g = e.default) == null ? void 0 : g.call(e).some((y) => y.type !== bt);
    }), h = (g) => {
      u = g, t("update:modelValue", g);
    }, v = (g) => {
      o.value && (o.value.open({ map: r.value, anchor: i.value, ...g }), h(!0));
    }, p = () => {
      o.value && (o.value.close(), h(!1));
    };
    return je(() => {
      B(
        [r, () => n.options],
        ([g, y], [w, _]) => {
          var C;
          const $ = !ie(y, _) || r.value !== w;
          r.value && l.value && $ && (o.value ? (o.value.setOptions({
            ...y,
            content: c.value ? s.value : y.content
          }), i.value || v()) : (o.value = te(
            new l.value.InfoWindow({
              ...y,
              content: c.value ? s.value : y.content
            })
          ), i.value && (d = i.value.addListener("click", () => {
            v();
          })), (!i.value || u) && v(), ut.forEach((E) => {
            var q;
            (q = o.value) == null || q.addListener(E, (O) => t(E, O));
          }), (C = o.value) == null || C.addListener("closeclick", () => h(!1))));
        },
        {
          immediate: !0
        }
      ), B(
        () => n.modelValue,
        (g) => {
          g !== u && (g ? v() : p());
        }
      );
    }), he(() => {
      var g;
      d && d.remove(), o.value && ((g = l.value) == null || g.event.clearInstanceListeners(o.value), p());
    }), a({ infoWindow: o, open: v, close: p }), { infoWindow: o, infoWindowRef: s, hasSlotContent: c, open: v, close: p };
  }
});
const dt = [
  Int8Array,
  Uint8Array,
  Uint8ClampedArray,
  Int16Array,
  Uint16Array,
  Int32Array,
  Uint32Array,
  Float32Array,
  Float64Array
], Re = 1, we = 8;
class Ke {
  /**
   * Creates an index from raw `ArrayBuffer` data.
   * @param {ArrayBuffer} data
   */
  static from(e) {
    if (!(e instanceof ArrayBuffer))
      throw new Error("Data must be an instance of ArrayBuffer.");
    const [t, a] = new Uint8Array(e, 0, 2);
    if (t !== 219)
      throw new Error("Data does not appear to be in a KDBush format.");
    const o = a >> 4;
    if (o !== Re)
      throw new Error(`Got v${o} data when expected v${Re}.`);
    const s = dt[a & 15];
    if (!s)
      throw new Error("Unrecognized array type.");
    const [r] = new Uint16Array(e, 2, 1), [l] = new Uint32Array(e, 4, 1);
    return new Ke(l, r, s, e);
  }
  /**
   * Creates an index that will hold a given number of items.
   * @param {number} numItems
   * @param {number} [nodeSize=64] Size of the KD-tree node (64 by default).
   * @param {TypedArrayConstructor} [ArrayType=Float64Array] The array type used for coordinates storage (`Float64Array` by default).
   * @param {ArrayBuffer} [data] (For internal use only)
   */
  constructor(e, t = 64, a = Float64Array, o) {
    if (isNaN(e) || e < 0)
      throw new Error(`Unpexpected numItems value: ${e}.`);
    this.numItems = +e, this.nodeSize = Math.min(Math.max(+t, 2), 65535), this.ArrayType = a, this.IndexArrayType = e < 65536 ? Uint16Array : Uint32Array;
    const s = dt.indexOf(this.ArrayType), r = e * 2 * this.ArrayType.BYTES_PER_ELEMENT, l = e * this.IndexArrayType.BYTES_PER_ELEMENT, i = (8 - l % 8) % 8;
    if (s < 0)
      throw new Error(`Unexpected typed array class: ${a}.`);
    o && o instanceof ArrayBuffer ? (this.data = o, this.ids = new this.IndexArrayType(this.data, we, e), this.coords = new this.ArrayType(this.data, we + l + i, e * 2), this._pos = e * 2, this._finished = !0) : (this.data = new ArrayBuffer(we + r + l + i), this.ids = new this.IndexArrayType(this.data, we, e), this.coords = new this.ArrayType(this.data, we + l + i, e * 2), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([219, (Re << 4) + s]), new Uint16Array(this.data, 2, 1)[0] = t, new Uint32Array(this.data, 4, 1)[0] = e);
  }
  /**
   * Add a point to the index.
   * @param {number} x
   * @param {number} y
   * @returns {number} An incremental index associated with the added item (starting from `0`).
   */
  add(e, t) {
    const a = this._pos >> 1;
    return this.ids[a] = a, this.coords[this._pos++] = e, this.coords[this._pos++] = t, a;
  }
  /**
   * Perform indexing of the added points.
   */
  finish() {
    const e = this._pos >> 1;
    if (e !== this.numItems)
      throw new Error(`Added ${e} items when expected ${this.numItems}.`);
    return qe(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
  }
  /**
   * Search the index for items within a given bounding box.
   * @param {number} minX
   * @param {number} minY
   * @param {number} maxX
   * @param {number} maxY
   * @returns {number[]} An array of indices correponding to the found items.
   */
  range(e, t, a, o) {
    if (!this._finished)
      throw new Error("Data not yet indexed - call index.finish().");
    const { ids: s, coords: r, nodeSize: l } = this, i = [0, s.length - 1, 0], d = [];
    for (; i.length; ) {
      const u = i.pop() || 0, c = i.pop() || 0, h = i.pop() || 0;
      if (c - h <= l) {
        for (let y = h; y <= c; y++) {
          const w = r[2 * y], _ = r[2 * y + 1];
          w >= e && w <= a && _ >= t && _ <= o && d.push(s[y]);
        }
        continue;
      }
      const v = h + c >> 1, p = r[2 * v], g = r[2 * v + 1];
      p >= e && p <= a && g >= t && g <= o && d.push(s[v]), (u === 0 ? e <= p : t <= g) && (i.push(h), i.push(v - 1), i.push(1 - u)), (u === 0 ? a >= p : o >= g) && (i.push(v + 1), i.push(c), i.push(1 - u));
    }
    return d;
  }
  /**
   * Search the index for items within a given radius.
   * @param {number} qx
   * @param {number} qy
   * @param {number} r Query radius.
   * @returns {number[]} An array of indices correponding to the found items.
   */
  within(e, t, a) {
    if (!this._finished)
      throw new Error("Data not yet indexed - call index.finish().");
    const { ids: o, coords: s, nodeSize: r } = this, l = [0, o.length - 1, 0], i = [], d = a * a;
    for (; l.length; ) {
      const u = l.pop() || 0, c = l.pop() || 0, h = l.pop() || 0;
      if (c - h <= r) {
        for (let y = h; y <= c; y++)
          pt(s[2 * y], s[2 * y + 1], e, t) <= d && i.push(o[y]);
        continue;
      }
      const v = h + c >> 1, p = s[2 * v], g = s[2 * v + 1];
      pt(p, g, e, t) <= d && i.push(o[v]), (u === 0 ? e - a <= p : t - a <= g) && (l.push(h), l.push(v - 1), l.push(1 - u)), (u === 0 ? e + a >= p : t + a >= g) && (l.push(v + 1), l.push(c), l.push(1 - u));
    }
    return i;
  }
}
function qe(n, e, t, a, o, s) {
  if (o - a <= t)
    return;
  const r = a + o >> 1;
  Dt(n, e, r, a, o, s), qe(n, e, t, a, r - 1, 1 - s), qe(n, e, t, r + 1, o, 1 - s);
}
function Dt(n, e, t, a, o, s) {
  for (; o > a; ) {
    if (o - a > 600) {
      const d = o - a + 1, u = t - a + 1, c = Math.log(d), h = 0.5 * Math.exp(2 * c / 3), v = 0.5 * Math.sqrt(c * h * (d - h) / d) * (u - d / 2 < 0 ? -1 : 1), p = Math.max(a, Math.floor(t - u * h / d + v)), g = Math.min(o, Math.floor(t + (d - u) * h / d + v));
      Dt(n, e, t, p, g, s);
    }
    const r = e[2 * t + s];
    let l = a, i = o;
    for (be(n, e, a, t), e[2 * o + s] > r && be(n, e, a, o); l < i; ) {
      for (be(n, e, l, i), l++, i--; e[2 * l + s] < r; )
        l++;
      for (; e[2 * i + s] > r; )
        i--;
    }
    e[2 * a + s] === r ? be(n, e, a, i) : (i++, be(n, e, i, o)), i <= t && (a = i + 1), t <= i && (o = i - 1);
  }
}
function be(n, e, t, a) {
  Ve(n, t, a), Ve(e, 2 * t, 2 * a), Ve(e, 2 * t + 1, 2 * a + 1);
}
function Ve(n, e, t) {
  const a = n[e];
  n[e] = n[t], n[t] = a;
}
function pt(n, e, t, a) {
  const o = n - t, s = e - a;
  return o * o + s * s;
}
const Ns = {
  minZoom: 0,
  // min zoom to generate clusters on
  maxZoom: 16,
  // max zoom level to cluster the points on
  minPoints: 2,
  // minimum points to form a cluster
  radius: 40,
  // cluster radius in pixels
  extent: 512,
  // tile extent (radius is calculated relative to it)
  nodeSize: 64,
  // size of the KD-tree leaf node, affects performance
  log: !1,
  // whether to log timing info
  // whether to generate numeric ids for input features (in vector tiles)
  generateId: !1,
  // a reduce function for calculating custom cluster properties
  reduce: null,
  // (accumulated, props) => { accumulated.sum += props.sum; }
  // properties to use for individual points when running the reducer
  map: (n) => n
  // props => ({sum: props.my_value})
}, ht = Math.fround || /* @__PURE__ */ ((n) => (e) => (n[0] = +e, n[0]))(new Float32Array(1)), ne = 2, ee = 3, Ne = 4, J = 5, Ot = 6;
class Ht {
  constructor(e) {
    this.options = Object.assign(Object.create(Ns), e), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
  }
  load(e) {
    const { log: t, minZoom: a, maxZoom: o } = this.options;
    t && console.time("total time");
    const s = `prepare ${e.length} points`;
    t && console.time(s), this.points = e;
    const r = [];
    for (let i = 0; i < e.length; i++) {
      const d = e[i];
      if (!d.geometry)
        continue;
      const [u, c] = d.geometry.coordinates, h = ht(Pe(u)), v = ht(Me(c));
      r.push(
        h,
        v,
        // projected point coordinates
        1 / 0,
        // the last zoom the point was processed at
        i,
        // index of the source feature in the original input array
        -1,
        // parent cluster id
        1
        // number of points in a cluster
      ), this.options.reduce && r.push(0);
    }
    let l = this.trees[o + 1] = this._createTree(r);
    t && console.timeEnd(s);
    for (let i = o; i >= a; i--) {
      const d = +Date.now();
      l = this.trees[i] = this._createTree(this._cluster(l, i)), t && console.log("z%d: %d clusters in %dms", i, l.numItems, +Date.now() - d);
    }
    return t && console.timeEnd("total time"), this;
  }
  getClusters(e, t) {
    let a = ((e[0] + 180) % 360 + 360) % 360 - 180;
    const o = Math.max(-90, Math.min(90, e[1]));
    let s = e[2] === 180 ? 180 : ((e[2] + 180) % 360 + 360) % 360 - 180;
    const r = Math.max(-90, Math.min(90, e[3]));
    if (e[2] - e[0] >= 360)
      a = -180, s = 180;
    else if (a > s) {
      const c = this.getClusters([a, o, 180, r], t), h = this.getClusters([-180, o, s, r], t);
      return c.concat(h);
    }
    const l = this.trees[this._limitZoom(t)], i = l.range(Pe(a), Me(r), Pe(s), Me(o)), d = l.data, u = [];
    for (const c of i) {
      const h = this.stride * c;
      u.push(d[h + J] > 1 ? mt(d, h, this.clusterProps) : this.points[d[h + ee]]);
    }
    return u;
  }
  getChildren(e) {
    const t = this._getOriginId(e), a = this._getOriginZoom(e), o = "No cluster with the specified id.", s = this.trees[a];
    if (!s)
      throw new Error(o);
    const r = s.data;
    if (t * this.stride >= r.length)
      throw new Error(o);
    const l = this.options.radius / (this.options.extent * Math.pow(2, a - 1)), i = r[t * this.stride], d = r[t * this.stride + 1], u = s.within(i, d, l), c = [];
    for (const h of u) {
      const v = h * this.stride;
      r[v + Ne] === e && c.push(r[v + J] > 1 ? mt(r, v, this.clusterProps) : this.points[r[v + ee]]);
    }
    if (c.length === 0)
      throw new Error(o);
    return c;
  }
  getLeaves(e, t, a) {
    t = t || 10, a = a || 0;
    const o = [];
    return this._appendLeaves(o, e, t, a, 0), o;
  }
  getTile(e, t, a) {
    const o = this.trees[this._limitZoom(e)], s = Math.pow(2, e), { extent: r, radius: l } = this.options, i = l / r, d = (a - i) / s, u = (a + 1 + i) / s, c = {
      features: []
    };
    return this._addTileFeatures(
      o.range((t - i) / s, d, (t + 1 + i) / s, u),
      o.data,
      t,
      a,
      s,
      c
    ), t === 0 && this._addTileFeatures(
      o.range(1 - i / s, d, 1, u),
      o.data,
      s,
      a,
      s,
      c
    ), t === s - 1 && this._addTileFeatures(
      o.range(0, d, i / s, u),
      o.data,
      -1,
      a,
      s,
      c
    ), c.features.length ? c : null;
  }
  getClusterExpansionZoom(e) {
    let t = this._getOriginZoom(e) - 1;
    for (; t <= this.options.maxZoom; ) {
      const a = this.getChildren(e);
      if (t++, a.length !== 1)
        break;
      e = a[0].properties.cluster_id;
    }
    return t;
  }
  _appendLeaves(e, t, a, o, s) {
    const r = this.getChildren(t);
    for (const l of r) {
      const i = l.properties;
      if (i && i.cluster ? s + i.point_count <= o ? s += i.point_count : s = this._appendLeaves(e, i.cluster_id, a, o, s) : s < o ? s++ : e.push(l), e.length === a)
        break;
    }
    return s;
  }
  _createTree(e) {
    const t = new Ke(e.length / this.stride | 0, this.options.nodeSize, Float32Array);
    for (let a = 0; a < e.length; a += this.stride)
      t.add(e[a], e[a + 1]);
    return t.finish(), t.data = e, t;
  }
  _addTileFeatures(e, t, a, o, s, r) {
    for (const l of e) {
      const i = l * this.stride, d = t[i + J] > 1;
      let u, c, h;
      if (d)
        u = Tt(t, i, this.clusterProps), c = t[i], h = t[i + 1];
      else {
        const g = this.points[t[i + ee]];
        u = g.properties;
        const [y, w] = g.geometry.coordinates;
        c = Pe(y), h = Me(w);
      }
      const v = {
        type: 1,
        geometry: [[
          Math.round(this.options.extent * (c * s - a)),
          Math.round(this.options.extent * (h * s - o))
        ]],
        tags: u
      };
      let p;
      d || this.options.generateId ? p = t[i + ee] : p = this.points[t[i + ee]].id, p !== void 0 && (v.id = p), r.features.push(v);
    }
  }
  _limitZoom(e) {
    return Math.max(this.options.minZoom, Math.min(Math.floor(+e), this.options.maxZoom + 1));
  }
  _cluster(e, t) {
    const { radius: a, extent: o, reduce: s, minPoints: r } = this.options, l = a / (o * Math.pow(2, t)), i = e.data, d = [], u = this.stride;
    for (let c = 0; c < i.length; c += u) {
      if (i[c + ne] <= t)
        continue;
      i[c + ne] = t;
      const h = i[c], v = i[c + 1], p = e.within(i[c], i[c + 1], l), g = i[c + J];
      let y = g;
      for (const w of p) {
        const _ = w * u;
        i[_ + ne] > t && (y += i[_ + J]);
      }
      if (y > g && y >= r) {
        let w = h * g, _ = v * g, C, $ = -1;
        const E = ((c / u | 0) << 5) + (t + 1) + this.points.length;
        for (const q of p) {
          const O = q * u;
          if (i[O + ne] <= t)
            continue;
          i[O + ne] = t;
          const Q = i[O + J];
          w += i[O] * Q, _ += i[O + 1] * Q, i[O + Ne] = E, s && (C || (C = this._map(i, c, !0), $ = this.clusterProps.length, this.clusterProps.push(C)), s(C, this._map(i, O)));
        }
        i[c + Ne] = E, d.push(w / y, _ / y, 1 / 0, E, -1, y), s && d.push($);
      } else {
        for (let w = 0; w < u; w++)
          d.push(i[c + w]);
        if (y > 1)
          for (const w of p) {
            const _ = w * u;
            if (!(i[_ + ne] <= t)) {
              i[_ + ne] = t;
              for (let C = 0; C < u; C++)
                d.push(i[_ + C]);
            }
          }
      }
    }
    return d;
  }
  // get index of the point from which the cluster originated
  _getOriginId(e) {
    return e - this.points.length >> 5;
  }
  // get zoom of the point from which the cluster originated
  _getOriginZoom(e) {
    return (e - this.points.length) % 32;
  }
  _map(e, t, a) {
    if (e[t + J] > 1) {
      const r = this.clusterProps[e[t + Ot]];
      return a ? Object.assign({}, r) : r;
    }
    const o = this.points[e[t + ee]].properties, s = this.options.map(o);
    return a && s === o ? Object.assign({}, s) : s;
  }
}
function mt(n, e, t) {
  return {
    type: "Feature",
    id: n[e + ee],
    properties: Tt(n, e, t),
    geometry: {
      type: "Point",
      coordinates: [Zs(n[e]), qs(n[e + 1])]
    }
  };
}
function Tt(n, e, t) {
  const a = n[e + J], o = a >= 1e4 ? `${Math.round(a / 1e3)}k` : a >= 1e3 ? `${Math.round(a / 100) / 10}k` : a, s = n[e + Ot], r = s === -1 ? {} : Object.assign({}, t[s]);
  return Object.assign(r, {
    cluster: !0,
    cluster_id: n[e + ee],
    point_count: a,
    point_count_abbreviated: o
  });
}
function Pe(n) {
  return n / 360 + 0.5;
}
function Me(n) {
  const e = Math.sin(n * Math.PI / 180), t = 0.5 - 0.25 * Math.log((1 + e) / (1 - e)) / Math.PI;
  return t < 0 ? 0 : t > 1 ? 1 : t;
}
function Zs(n) {
  return (n - 0.5) * 360;
}
function qs(n) {
  const e = (180 - n * 360) * Math.PI / 180;
  return 360 * Math.atan(Math.exp(e)) / Math.PI - 90;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function Ge(n, e) {
  var t = {};
  for (var a in n)
    Object.prototype.hasOwnProperty.call(n, a) && e.indexOf(a) < 0 && (t[a] = n[a]);
  if (n != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, a = Object.getOwnPropertySymbols(n); o < a.length; o++)
      e.indexOf(a[o]) < 0 && Object.prototype.propertyIsEnumerable.call(n, a[o]) && (t[a[o]] = n[a[o]]);
  return t;
}
class T {
  static isAdvancedMarkerAvailable(e) {
    return google.maps.marker && e.getMapCapabilities().isAdvancedMarkersAvailable === !0;
  }
  static isAdvancedMarker(e) {
    return google.maps.marker && e instanceof google.maps.marker.AdvancedMarkerElement;
  }
  static setMap(e, t) {
    this.isAdvancedMarker(e) ? e.map = t : e.setMap(t);
  }
  static getPosition(e) {
    if (this.isAdvancedMarker(e)) {
      if (e.position) {
        if (e.position instanceof google.maps.LatLng)
          return e.position;
        if (e.position.lat && e.position.lng)
          return new google.maps.LatLng(e.position.lat, e.position.lng);
      }
      return new google.maps.LatLng(null);
    }
    return e.getPosition();
  }
  static getVisible(e) {
    return this.isAdvancedMarker(e) ? !0 : e.getVisible();
  }
}
class Ce {
  constructor({ markers: e, position: t }) {
    this.markers = e, t && (t instanceof google.maps.LatLng ? this._position = t : this._position = new google.maps.LatLng(t));
  }
  get bounds() {
    if (this.markers.length === 0 && !this._position)
      return;
    const e = new google.maps.LatLngBounds(this._position, this._position);
    for (const t of this.markers)
      e.extend(T.getPosition(t));
    return e;
  }
  get position() {
    return this._position || this.bounds.getCenter();
  }
  /**
   * Get the count of **visible** markers.
   */
  get count() {
    return this.markers.filter((e) => T.getVisible(e)).length;
  }
  /**
   * Add a marker to the cluster.
   */
  push(e) {
    this.markers.push(e);
  }
  /**
   * Cleanup references and remove marker from map.
   */
  delete() {
    this.marker && (T.setMap(this.marker, null), this.marker = void 0), this.markers.length = 0;
  }
}
const Bs = (n, e, t, a) => {
  const o = Rt(n.getBounds(), e, a);
  return t.filter((s) => o.contains(T.getPosition(s)));
}, Rt = (n, e, t) => {
  const { northEast: a, southWest: o } = Ws(n, e), s = Fs({ northEast: a, southWest: o }, t);
  return Us(s, e);
}, ft = (n, e, t) => {
  const a = Rt(n, e, t), o = a.getNorthEast(), s = a.getSouthWest();
  return [s.lng(), s.lat(), o.lng(), o.lat()];
}, Ws = (n, e) => ({
  northEast: e.fromLatLngToDivPixel(n.getNorthEast()),
  southWest: e.fromLatLngToDivPixel(n.getSouthWest())
}), Fs = ({ northEast: n, southWest: e }, t) => (n.x += t, n.y -= t, e.x -= t, e.y += t, { northEast: n, southWest: e }), Us = ({ northEast: n, southWest: e }, t) => {
  const a = t.fromDivPixelToLatLng(e), o = t.fromDivPixelToLatLng(n);
  return new google.maps.LatLngBounds(a, o);
};
class Vt {
  constructor({ maxZoom: e = 16 }) {
    this.maxZoom = e;
  }
  /**
   * Helper function to bypass clustering based upon some map state such as
   * zoom, number of markers, etc.
   *
   * ```typescript
   *  cluster({markers, map}: AlgorithmInput): Cluster[] {
   *    if (shouldBypassClustering(map)) {
   *      return this.noop({markers})
   *    }
   * }
   * ```
   */
  noop({ markers: e }) {
    return Gs(e);
  }
}
class Ks extends Vt {
  constructor(e) {
    var { viewportPadding: t = 60 } = e, a = Ge(e, ["viewportPadding"]);
    super(a), this.viewportPadding = 60, this.viewportPadding = t;
  }
  calculate({ markers: e, map: t, mapCanvasProjection: a }) {
    return t.getZoom() >= this.maxZoom ? {
      clusters: this.noop({
        markers: e
      }),
      changed: !1
    } : {
      clusters: this.cluster({
        markers: Bs(t, a, e, this.viewportPadding),
        map: t,
        mapCanvasProjection: a
      })
    };
  }
}
const Gs = (n) => n.map((e) => new Ce({
  position: T.getPosition(e),
  markers: [e]
}));
class Xs extends Vt {
  constructor(e) {
    var { maxZoom: t, radius: a = 60 } = e, o = Ge(e, ["maxZoom", "radius"]);
    super({ maxZoom: t }), this.state = { zoom: -1 }, this.superCluster = new Ht(Object.assign({ maxZoom: this.maxZoom, radius: a }, o));
  }
  calculate(e) {
    let t = !1;
    const a = { zoom: e.map.getZoom() };
    if (!ie(e.markers, this.markers)) {
      t = !0, this.markers = [...e.markers];
      const o = this.markers.map((s) => {
        const r = T.getPosition(s);
        return {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [r.lng(), r.lat()]
          },
          properties: { marker: s }
        };
      });
      this.superCluster.load(o);
    }
    return t || (this.state.zoom <= this.maxZoom || a.zoom <= this.maxZoom) && (t = !ie(this.state, a)), this.state = a, t && (this.clusters = this.cluster(e)), { clusters: this.clusters, changed: t };
  }
  cluster({ map: e }) {
    return this.superCluster.getClusters([-180, -90, 180, 90], Math.round(e.getZoom())).map((t) => this.transformCluster(t));
  }
  transformCluster({ geometry: { coordinates: [e, t] }, properties: a }) {
    if (a.cluster)
      return new Ce({
        markers: this.superCluster.getLeaves(a.cluster_id, 1 / 0).map((s) => s.properties.marker),
        position: { lat: t, lng: e }
      });
    const o = a.marker;
    return new Ce({
      markers: [o],
      position: T.getPosition(o)
    });
  }
}
class Ys extends Ks {
  constructor(e) {
    var { maxZoom: t, radius: a = 60, viewportPadding: o = 60 } = e, s = Ge(e, ["maxZoom", "radius", "viewportPadding"]);
    super({ maxZoom: t, viewportPadding: o }), this.superCluster = new Ht(Object.assign({ maxZoom: this.maxZoom, radius: a }, s)), this.state = { zoom: -1, view: [0, 0, 0, 0] };
  }
  calculate(e) {
    const t = {
      zoom: Math.round(e.map.getZoom()),
      view: ft(e.map.getBounds(), e.mapCanvasProjection, this.viewportPadding)
    };
    let a = !ie(this.state, t);
    if (!ie(e.markers, this.markers)) {
      a = !0, this.markers = [...e.markers];
      const o = this.markers.map((s) => {
        const r = T.getPosition(s);
        return {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [r.lng(), r.lat()]
          },
          properties: { marker: s }
        };
      });
      this.superCluster.load(o);
    }
    return a && (this.clusters = this.cluster(e), this.state = t), { clusters: this.clusters, changed: a };
  }
  cluster({ map: e, mapCanvasProjection: t }) {
    const a = {
      zoom: Math.round(e.getZoom()),
      view: ft(e.getBounds(), t, this.viewportPadding)
    };
    return this.superCluster.getClusters(a.view, a.zoom).map((o) => this.transformCluster(o));
  }
  transformCluster({ geometry: { coordinates: [e, t] }, properties: a }) {
    if (a.cluster)
      return new Ce({
        markers: this.superCluster.getLeaves(a.cluster_id, 1 / 0).map((s) => s.properties.marker),
        position: { lat: t, lng: e }
      });
    const o = a.marker;
    return new Ce({
      markers: [o],
      position: T.getPosition(o)
    });
  }
}
class Qs {
  constructor(e, t) {
    this.markers = { sum: e.length };
    const a = t.map((s) => s.count), o = a.reduce((s, r) => s + r, 0);
    this.clusters = {
      count: t.length,
      markers: {
        mean: o / t.length,
        sum: o,
        min: Math.min(...a),
        max: Math.max(...a)
      }
    };
  }
}
class Js {
  /**
   * The default render function for the library used by {@link MarkerClusterer}.
   *
   * Currently set to use the following:
   *
   * ```typescript
   * // change color if this cluster has more markers than the mean cluster
   * const color =
   *   count > Math.max(10, stats.clusters.markers.mean)
   *     ? "#ff0000"
   *     : "#0000ff";
   *
   * // create svg url with fill color
   * const svg = window.btoa(`
   * <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
   *   <circle cx="120" cy="120" opacity=".6" r="70" />
   *   <circle cx="120" cy="120" opacity=".3" r="90" />
   *   <circle cx="120" cy="120" opacity=".2" r="110" />
   *   <circle cx="120" cy="120" opacity=".1" r="130" />
   * </svg>`);
   *
   * // create marker using svg icon
   * return new google.maps.Marker({
   *   position,
   *   icon: {
   *     url: `data:image/svg+xml;base64,${svg}`,
   *     scaledSize: new google.maps.Size(45, 45),
   *   },
   *   label: {
   *     text: String(count),
   *     color: "rgba(255,255,255,0.9)",
   *     fontSize: "12px",
   *   },
   *   // adjust zIndex to be above other markers
   *   zIndex: 1000 + count,
   * });
   * ```
   */
  render({ count: e, position: t }, a, o) {
    const s = `<svg fill="${e > Math.max(10, a.clusters.markers.mean) ? "#ff0000" : "#0000ff"}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
<circle cx="120" cy="120" opacity=".6" r="70" />
<circle cx="120" cy="120" opacity=".3" r="90" />
<circle cx="120" cy="120" opacity=".2" r="110" />
<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${e}</text>
</svg>`, r = `Cluster of ${e} markers`, l = Number(google.maps.Marker.MAX_ZINDEX) + e;
    if (T.isAdvancedMarkerAvailable(o)) {
      const d = document.createElement("div");
      d.innerHTML = s;
      const u = d.firstElementChild;
      u.setAttribute("transform", "translate(0 25)");
      const c = {
        map: o,
        position: t,
        zIndex: l,
        title: r,
        content: u
      };
      return new google.maps.marker.AdvancedMarkerElement(c);
    }
    const i = {
      position: t,
      zIndex: l,
      title: r,
      icon: {
        url: `data:image/svg+xml;base64,${btoa(s)}`,
        anchor: new google.maps.Point(25, 25)
      }
    };
    return new google.maps.Marker(i);
  }
}
function er(n, e) {
  for (let t in e.prototype)
    n.prototype[t] = e.prototype[t];
}
class Xe {
  constructor() {
    er(Xe, google.maps.OverlayView);
  }
}
var de;
(function(n) {
  n.CLUSTERING_BEGIN = "clusteringbegin", n.CLUSTERING_END = "clusteringend", n.CLUSTER_CLICK = "click";
})(de || (de = {}));
const tr = (n, e, t) => {
  t.fitBounds(e.bounds);
};
class nr extends Xe {
  constructor({ map: e, markers: t = [], algorithmOptions: a = {}, algorithm: o = new Xs(a), renderer: s = new Js(), onClusterClick: r = tr }) {
    super(), this.markers = [...t], this.clusters = [], this.algorithm = o, this.renderer = s, this.onClusterClick = r, e && this.setMap(e);
  }
  addMarker(e, t) {
    this.markers.includes(e) || (this.markers.push(e), t || this.render());
  }
  addMarkers(e, t) {
    e.forEach((a) => {
      this.addMarker(a, !0);
    }), t || this.render();
  }
  removeMarker(e, t) {
    const a = this.markers.indexOf(e);
    return a === -1 ? !1 : (T.setMap(e, null), this.markers.splice(a, 1), t || this.render(), !0);
  }
  removeMarkers(e, t) {
    let a = !1;
    return e.forEach((o) => {
      a = this.removeMarker(o, !0) || a;
    }), a && !t && this.render(), a;
  }
  clearMarkers(e) {
    this.markers.length = 0, e || this.render();
  }
  /**
   * Recalculates and draws all the marker clusters.
   */
  render() {
    const e = this.getMap();
    if (e instanceof google.maps.Map && e.getProjection()) {
      google.maps.event.trigger(this, de.CLUSTERING_BEGIN, this);
      const { clusters: t, changed: a } = this.algorithm.calculate({
        markers: this.markers,
        map: e,
        mapCanvasProjection: this.getProjection()
      });
      if (a || a == null) {
        const o = /* @__PURE__ */ new Set();
        for (const r of t)
          r.markers.length == 1 && o.add(r.markers[0]);
        const s = [];
        for (const r of this.clusters)
          r.marker != null && (r.markers.length == 1 ? o.has(r.marker) || T.setMap(r.marker, null) : s.push(r.marker));
        this.clusters = t, this.renderClusters(), requestAnimationFrame(() => s.forEach((r) => T.setMap(r, null)));
      }
      google.maps.event.trigger(this, de.CLUSTERING_END, this);
    }
  }
  onAdd() {
    this.idleListener = this.getMap().addListener("idle", this.render.bind(this)), this.render();
  }
  onRemove() {
    google.maps.event.removeListener(this.idleListener), this.reset();
  }
  reset() {
    this.markers.forEach((e) => T.setMap(e, null)), this.clusters.forEach((e) => e.delete()), this.clusters = [];
  }
  renderClusters() {
    const e = new Qs(this.markers, this.clusters), t = this.getMap();
    this.clusters.forEach((a) => {
      a.markers.length === 1 ? a.marker = a.markers[0] : (a.marker = this.renderer.render(a, e, t), a.markers.forEach((o) => T.setMap(o, null)), this.onClusterClick && a.marker.addListener(
        "click",
        /* istanbul ignore next */
        (o) => {
          google.maps.event.trigger(this, de.CLUSTER_CLICK, a), this.onClusterClick(o, a, t);
        }
      )), T.setMap(a.marker, t);
    });
  }
}
const gt = Object.values(de);
z({
  name: "MarkerCluster",
  props: {
    options: {
      type: Object,
      default: () => ({})
    }
  },
  emits: gt,
  setup(n, { emit: e, expose: t, slots: a }) {
    const o = k(), s = F(ge, k()), r = F(ve, k());
    return _e(It, o), B(
      s,
      () => {
        s.value && (o.value = te(
          new nr({
            map: s.value,
            // Better perf than the default `SuperClusterAlgorithm`. See:
            // https://github.com/googlemaps/js-markerclusterer/pull/640
            algorithm: new Ys(n.options.algorithmOptions ?? {}),
            ...n.options
          })
        ), gt.forEach((l) => {
          var i;
          (i = o.value) == null || i.addListener(l, (d) => e(l, d));
        }));
      },
      {
        immediate: !0
      }
    ), he(() => {
      var l;
      o.value && ((l = r.value) == null || l.event.clearInstanceListeners(o.value), o.value.clearMarkers(), o.value.setMap(null));
    }), t({ markerCluster: o }), () => {
      var l;
      return (l = a.default) == null ? void 0 : l.call(a);
    };
  }
});
const ar = z({
  inheritAttrs: !1,
  props: {
    options: {
      type: Object,
      required: !0
    }
  },
  setup(n, { slots: e, emit: t, expose: a }) {
    const o = k(), s = S(() => {
      var i;
      return (i = e.default) == null ? void 0 : i.call(e).some((d) => d.type !== bt);
    }), r = S(() => ({
      ...n.options,
      element: o.value
    })), l = ye(Ee, [], r, t);
    return a({
      customMarker: l
    }), { customMarkerRef: o, customMarker: l, hasSlotContent: s };
  }
}), or = {
  key: 0,
  class: "custom-marker-wrapper"
};
function sr(n, e, t, a, o, s) {
  return n.hasSlotContent ? (b(), x("div", or, [
    f("div", mn({
      ref: "customMarkerRef",
      style: { cursor: n.$attrs.onClick ? "pointer" : void 0 }
    }, n.$attrs), [
      xe(n.$slots, "default", {}, void 0, !0)
    ], 16)
  ])) : Z("", !0);
}
const rr = /* @__PURE__ */ At(ar, [["render", sr], ["__scopeId", "data-v-2d2d343a"]]);
z({
  name: "HeatmapLayer",
  props: {
    options: {
      type: Object,
      default: () => ({})
    }
  },
  setup(n) {
    const e = k(), t = F(ge, k()), a = F(ve, k());
    return B(
      [t, () => n.options],
      ([o, s], [r, l]) => {
        var i;
        const d = !ie(s, l) || t.value !== r;
        if (t.value && a.value && d) {
          const u = structuredClone(s);
          if (u.data && !(u.data instanceof a.value.MVCArray)) {
            const c = a.value.LatLng;
            u.data = (i = u.data) == null ? void 0 : i.map((h) => h instanceof c || "location" in h && (h.location instanceof c || h.location === null) ? h : "location" in h ? { ...h, location: new c(h.location) } : new c(h));
          }
          e.value ? e.value.setOptions(u) : e.value = te(
            new a.value.visualization.HeatmapLayer({
              ...u,
              map: t.value
            })
          );
        }
      },
      { immediate: !0 }
    ), he(() => {
      e.value && e.value.setMap(null);
    }), { heatmapLayer: e };
  },
  render: () => null
});
const ir = /* @__PURE__ */ z({
  __name: "MapMarker",
  props: {
    pharmacy: {},
    isActive: { type: Boolean }
  },
  emits: ["select-pharmacy"],
  setup(n, { emit: e }) {
    const t = n, a = e, { md: o } = $e();
    function s() {
      a("select-pharmacy", t.pharmacy);
    }
    return (r, l) => (b(), D(m(rr), {
      options: { position: r.pharmacy.coordinates, anchorPoint: "CENTER" },
      zIndex: 50,
      onClick: fn(s, ["stop"])
    }, {
      default: I(() => [
        m(o) ? (b(), D($t, {
          key: 0,
          overallAvailability: r.pharmacy.availability,
          individualItems: r.pharmacy.items
        }, {
          default: I(() => [
            M(nt, {
              availability: r.pharmacy.availability,
              "is-active": r.isActive
            }, null, 8, ["availability", "is-active"])
          ]),
          _: 1
        }, 8, ["overallAvailability", "individualItems"])) : (b(), D(nt, {
          key: 1,
          availability: r.pharmacy.availability,
          "is-active": r.isActive
        }, null, 8, ["availability", "is-active"]))
      ]),
      _: 1
    }, 8, ["options"]));
  }
}), lr = {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "splitpanes",
  emits: ["ready", "resize", "resized", "pane-click", "pane-maximize", "pane-add", "pane-remove", "splitter-click"],
  props: {
    horizontal: { type: Boolean },
    pushOtherPanes: { type: Boolean, default: !0 },
    dblClickSplitter: { type: Boolean, default: !0 },
    rtl: { type: Boolean, default: !1 },
    // Right to left direction.
    firstSplitter: { type: Boolean }
  },
  provide() {
    return {
      requestUpdate: this.requestUpdate,
      onPaneAdd: this.onPaneAdd,
      onPaneRemove: this.onPaneRemove,
      onPaneClick: this.onPaneClick
    };
  },
  data: () => ({
    container: null,
    ready: !1,
    panes: [],
    touch: {
      mouseDown: !1,
      dragging: !1,
      activeSplitter: null
    },
    splitterTaps: {
      // Used to detect double click on touch devices.
      splitter: null,
      timeoutId: null
    }
  }),
  computed: {
    panesCount() {
      return this.panes.length;
    },
    // Indexed panes by `uid` of Pane components for fast lookup.
    // Every time a pane is destroyed this index is recomputed.
    indexedPanes() {
      return this.panes.reduce((n, e) => (n[e.id] = e) && n, {});
    }
  },
  methods: {
    updatePaneComponents() {
      this.panes.forEach((n) => {
        n.update && n.update({
          // Panes are indexed by Pane component uid, as they might be inserted at different index.
          [this.horizontal ? "height" : "width"]: `${this.indexedPanes[n.id].size}%`
        });
      });
    },
    bindEvents() {
      document.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), document.addEventListener("mouseup", this.onMouseUp), "ontouchstart" in window && (document.addEventListener("touchmove", this.onMouseMove, { passive: !1 }), document.addEventListener("touchend", this.onMouseUp));
    },
    unbindEvents() {
      document.removeEventListener("mousemove", this.onMouseMove, { passive: !1 }), document.removeEventListener("mouseup", this.onMouseUp), "ontouchstart" in window && (document.removeEventListener("touchmove", this.onMouseMove, { passive: !1 }), document.removeEventListener("touchend", this.onMouseUp));
    },
    onMouseDown(n, e) {
      this.bindEvents(), this.touch.mouseDown = !0, this.touch.activeSplitter = e;
    },
    onMouseMove(n) {
      this.touch.mouseDown && (n.preventDefault(), this.touch.dragging = !0, this.calculatePanesSize(this.getCurrentMouseDrag(n)), this.$emit("resize", this.panes.map((e) => ({ min: e.min, max: e.max, size: e.size }))));
    },
    onMouseUp() {
      this.touch.dragging && this.$emit("resized", this.panes.map((n) => ({ min: n.min, max: n.max, size: n.size }))), this.touch.mouseDown = !1, setTimeout(() => {
        this.touch.dragging = !1, this.unbindEvents();
      }, 100);
    },
    // If touch device, detect double tap manually (2 taps separated by less than 500ms).
    onSplitterClick(n, e) {
      "ontouchstart" in window && (n.preventDefault(), this.dblClickSplitter && (this.splitterTaps.splitter === e ? (clearTimeout(this.splitterTaps.timeoutId), this.splitterTaps.timeoutId = null, this.onSplitterDblClick(n, e), this.splitterTaps.splitter = null) : (this.splitterTaps.splitter = e, this.splitterTaps.timeoutId = setTimeout(() => {
        this.splitterTaps.splitter = null;
      }, 500)))), this.touch.dragging || this.$emit("splitter-click", this.panes[e]);
    },
    // On splitter dbl click or dbl tap maximize this pane.
    onSplitterDblClick(n, e) {
      let t = 0;
      this.panes = this.panes.map((a, o) => (a.size = o === e ? a.max : a.min, o !== e && (t += a.min), a)), this.panes[e].size -= t, this.$emit("pane-maximize", this.panes[e]), this.$emit("resized", this.panes.map((a) => ({ min: a.min, max: a.max, size: a.size })));
    },
    onPaneClick(n, e) {
      this.$emit("pane-click", this.indexedPanes[e]);
    },
    // Get the cursor position relative to the splitpane container.
    getCurrentMouseDrag(n) {
      const e = this.container.getBoundingClientRect(), { clientX: t, clientY: a } = "ontouchstart" in window && n.touches ? n.touches[0] : n;
      return {
        x: t - e.left,
        y: a - e.top
      };
    },
    // Returns the drag percentage of the splitter relative to the container (ranging from 0 to 100%).
    getCurrentDragPercentage(n) {
      n = n[this.horizontal ? "y" : "x"];
      const e = this.container[this.horizontal ? "clientHeight" : "clientWidth"];
      return this.rtl && !this.horizontal && (n = e - n), n * 100 / e;
    },
    calculatePanesSize(n) {
      const e = this.touch.activeSplitter;
      let t = {
        prevPanesSize: this.sumPrevPanesSize(e),
        nextPanesSize: this.sumNextPanesSize(e),
        prevReachedMinPanes: 0,
        nextReachedMinPanes: 0
      };
      const a = 0 + (this.pushOtherPanes ? 0 : t.prevPanesSize), o = 100 - (this.pushOtherPanes ? 0 : t.nextPanesSize), s = Math.max(Math.min(this.getCurrentDragPercentage(n), o), a);
      let r = [e, e + 1], l = this.panes[r[0]] || null, i = this.panes[r[1]] || null;
      const d = l.max < 100 && s >= l.max + t.prevPanesSize, u = i.max < 100 && s <= 100 - (i.max + this.sumNextPanesSize(e + 1));
      if (d || u) {
        d ? (l.size = l.max, i.size = Math.max(100 - l.max - t.prevPanesSize - t.nextPanesSize, 0)) : (l.size = Math.max(100 - i.max - t.prevPanesSize - this.sumNextPanesSize(e + 1), 0), i.size = i.max);
        return;
      }
      if (this.pushOtherPanes) {
        const c = this.doPushOtherPanes(t, s);
        if (!c) return;
        ({ sums: t, panesToResize: r } = c), l = this.panes[r[0]] || null, i = this.panes[r[1]] || null;
      }
      l !== null && (l.size = Math.min(Math.max(s - t.prevPanesSize - t.prevReachedMinPanes, l.min), l.max)), i !== null && (i.size = Math.min(Math.max(100 - s - t.nextPanesSize - t.nextReachedMinPanes, i.min), i.max));
    },
    doPushOtherPanes(n, e) {
      const t = this.touch.activeSplitter, a = [t, t + 1];
      return e < n.prevPanesSize + this.panes[a[0]].min && (a[0] = this.findPrevExpandedPane(t).index, n.prevReachedMinPanes = 0, a[0] < t && this.panes.forEach((o, s) => {
        s > a[0] && s <= t && (o.size = o.min, n.prevReachedMinPanes += o.min);
      }), n.prevPanesSize = this.sumPrevPanesSize(a[0]), a[0] === void 0) ? (n.prevReachedMinPanes = 0, this.panes[0].size = this.panes[0].min, this.panes.forEach((o, s) => {
        s > 0 && s <= t && (o.size = o.min, n.prevReachedMinPanes += o.min);
      }), this.panes[a[1]].size = 100 - n.prevReachedMinPanes - this.panes[0].min - n.prevPanesSize - n.nextPanesSize, null) : e > 100 - n.nextPanesSize - this.panes[a[1]].min && (a[1] = this.findNextExpandedPane(t).index, n.nextReachedMinPanes = 0, a[1] > t + 1 && this.panes.forEach((o, s) => {
        s > t && s < a[1] && (o.size = o.min, n.nextReachedMinPanes += o.min);
      }), n.nextPanesSize = this.sumNextPanesSize(a[1] - 1), a[1] === void 0) ? (n.nextReachedMinPanes = 0, this.panes[this.panesCount - 1].size = this.panes[this.panesCount - 1].min, this.panes.forEach((o, s) => {
        s < this.panesCount - 1 && s >= t + 1 && (o.size = o.min, n.nextReachedMinPanes += o.min);
      }), this.panes[a[0]].size = 100 - n.prevPanesSize - n.nextReachedMinPanes - this.panes[this.panesCount - 1].min - n.nextPanesSize, null) : { sums: n, panesToResize: a };
    },
    sumPrevPanesSize(n) {
      return this.panes.reduce((e, t, a) => e + (a < n ? t.size : 0), 0);
    },
    sumNextPanesSize(n) {
      return this.panes.reduce((e, t, a) => e + (a > n + 1 ? t.size : 0), 0);
    },
    // Return the previous pane from siblings which has a size (width for vert or height for horz) of more than 0.
    findPrevExpandedPane(n) {
      return [...this.panes].reverse().find((e) => e.index < n && e.size > e.min) || {};
    },
    // Return the next pane from siblings which has a size (width for vert or height for horz) of more than 0.
    findNextExpandedPane(n) {
      return this.panes.find((e) => e.index > n + 1 && e.size > e.min) || {};
    },
    checkSplitpanesNodes() {
      Array.from(this.container.children).forEach((n) => {
        const e = n.classList.contains("splitpanes__pane"), t = n.classList.contains("splitpanes__splitter");
        !e && !t && (n.parentNode.removeChild(n), console.warn("Splitpanes: Only <pane> elements are allowed at the root of <splitpanes>. One of your DOM nodes was removed."));
      });
    },
    addSplitter(n, e, t = !1) {
      const a = n - 1, o = document.createElement("div");
      o.classList.add("splitpanes__splitter"), t || (o.onmousedown = (s) => this.onMouseDown(s, a), typeof window < "u" && "ontouchstart" in window && (o.ontouchstart = (s) => this.onMouseDown(s, a)), o.onclick = (s) => this.onSplitterClick(s, a + 1)), this.dblClickSplitter && (o.ondblclick = (s) => this.onSplitterDblClick(s, a + 1)), e.parentNode.insertBefore(o, e);
    },
    removeSplitter(n) {
      n.onmousedown = void 0, n.onclick = void 0, n.ondblclick = void 0, n.parentNode.removeChild(n);
    },
    redoSplitters() {
      const n = Array.from(this.container.children);
      n.forEach((t) => {
        t.className.includes("splitpanes__splitter") && this.removeSplitter(t);
      });
      let e = 0;
      n.forEach((t) => {
        t.className.includes("splitpanes__pane") && (!e && this.firstSplitter ? this.addSplitter(e, t, !0) : e && this.addSplitter(e, t), e++);
      });
    },
    // Called by Pane component on programmatic resize.
    requestUpdate({ target: n, ...e }) {
      const t = this.indexedPanes[n._.uid];
      Object.entries(e).forEach(([a, o]) => t[a] = o);
    },
    onPaneAdd(n) {
      let e = -1;
      Array.from(n.$el.parentNode.children).some((o) => (o.className.includes("splitpanes__pane") && e++, o === n.$el));
      const t = parseFloat(n.minSize), a = parseFloat(n.maxSize);
      this.panes.splice(e, 0, {
        id: n._.uid,
        index: e,
        min: isNaN(t) ? 0 : t,
        max: isNaN(a) ? 100 : a,
        size: n.size === null ? null : parseFloat(n.size),
        givenSize: n.size,
        update: n.update
      }), this.panes.forEach((o, s) => o.index = s), this.ready && this.$nextTick(() => {
        this.redoSplitters(), this.resetPaneSizes({ addedPane: this.panes[e] }), this.$emit("pane-add", { index: e, panes: this.panes.map((o) => ({ min: o.min, max: o.max, size: o.size })) });
      });
    },
    onPaneRemove(n) {
      const e = this.panes.findIndex((a) => a.id === n._.uid), t = this.panes.splice(e, 1)[0];
      this.panes.forEach((a, o) => a.index = o), this.$nextTick(() => {
        this.redoSplitters(), this.resetPaneSizes({ removedPane: { ...t, index: e } }), this.$emit("pane-remove", { removed: t, panes: this.panes.map((a) => ({ min: a.min, max: a.max, size: a.size })) });
      });
    },
    resetPaneSizes(n = {}) {
      !n.addedPane && !n.removedPane ? this.initialPanesSizing() : this.panes.some((e) => e.givenSize !== null || e.min || e.max < 100) ? this.equalizeAfterAddOrRemove(n) : this.equalize(), this.ready && this.$emit("resized", this.panes.map((e) => ({ min: e.min, max: e.max, size: e.size })));
    },
    equalize() {
      const n = 100 / this.panesCount;
      let e = 0;
      const t = [], a = [];
      this.panes.forEach((o) => {
        o.size = Math.max(Math.min(n, o.max), o.min), e -= o.size, o.size >= o.max && t.push(o.id), o.size <= o.min && a.push(o.id);
      }), e > 0.1 && this.readjustSizes(e, t, a);
    },
    initialPanesSizing() {
      let n = 100;
      const e = [], t = [];
      let a = 0;
      this.panes.forEach((s) => {
        n -= s.size, s.size !== null && a++, s.size >= s.max && e.push(s.id), s.size <= s.min && t.push(s.id);
      });
      let o = 100;
      n > 0.1 && (this.panes.forEach((s) => {
        s.size === null && (s.size = Math.max(Math.min(n / (this.panesCount - a), s.max), s.min)), o -= s.size;
      }), o > 0.1 && this.readjustSizes(n, e, t));
    },
    equalizeAfterAddOrRemove({ addedPane: n, removedPane: e } = {}) {
      let t = 100 / this.panesCount, a = 0;
      const o = [], s = [];
      n && n.givenSize !== null && (t = (100 - n.givenSize) / (this.panesCount - 1)), this.panes.forEach((r) => {
        a -= r.size, r.size >= r.max && o.push(r.id), r.size <= r.min && s.push(r.id);
      }), !(Math.abs(a) < 0.1) && (this.panes.forEach((r) => {
        n && n.givenSize !== null && n.id === r.id || (r.size = Math.max(Math.min(t, r.max), r.min)), a -= r.size, r.size >= r.max && o.push(r.id), r.size <= r.min && s.push(r.id);
      }), a > 0.1 && this.readjustSizes(a, o, s));
    },
    /* recalculatePaneSizes ({ addedPane, removedPane } = {}) {
          let leftToAllocate = 100
          let equalSpaceToAllocate = leftToAllocate / this.panesCount
          let ungrowable = []
          let unshrinkable = []
    
          // When adding a pane with no size, apply min-size if defined otherwise divide another pane
          // (next or prev) in 2.
          // if (addedPane && addedPane.size === null) {
          //   if (addedPane.min) addedPane.size = addedPane.min
          //   else {
          //     const paneToDivide = this.panes[addedPane.index + 1] || this.panes[addedPane.index - 1]
          //     if (paneToDivide) {
          //       // @todo: Dividing that pane in 2 could be incorrect if becoming lower than its min size.
          //       addedPane.size = paneToDivide.size / 2
          //       paneToDivide.size /= 2
          //     }
          //   }
          // }
    
          this.panes.forEach((pane, i) => {
            // Added pane - reduce the size of the next pane.
            if (addedPane && addedPane.index + 1 === i) {
              pane.size = Math.max(Math.min(100 - this.sumPrevPanesSize(i) - this.sumNextPanesSize(i + 1), pane.max), pane.min)
              // @todo: if could not allocate correctly, try to allocate in the next pane straight away,
              // then still do the second loop if not correct.
            }
    
            // Removed pane - increase the size of the next pane.
            else if (removedPane && removedPane.index === i) {
              pane.size = Math.max(Math.min(100 - this.sumPrevPanesSize(i) - this.sumNextPanesSize(i + 1), pane.max), pane.min)
              // @todo: if could not allocate correctly, try to allocate in the next pane straight away,
              // then still do the second loop if not correct.
            }
    
            // Initial load and on demand recalculation.
            else if (!addedPane && !removedPane && pane.size === null) {
              pane.size = Math.max(Math.min(equalSpaceToAllocate, pane.max), pane.min)
            }
    
            leftToAllocate -= pane.size
    
            if (pane.size >= pane.max) ungrowable.push(pane.id)
            if (pane.size <= pane.min) unshrinkable.push(pane.id)
          })
    
          // Do one more loop to adjust sizes if still wrong.
          // > 0.1: Prevent maths rounding issues due to bytes.
          if (Math.abs(leftToAllocate) > 0.1) this.readjustSizes(leftToAllocate, ungrowable, unshrinkable)
        }, */
    // Second loop to adjust sizes now that we know more about the panes constraints.
    readjustSizes(n, e, t) {
      let a;
      n > 0 ? a = n / (this.panesCount - e.length) : a = n / (this.panesCount - t.length), this.panes.forEach((o, s) => {
        if (n > 0 && !e.includes(o.id)) {
          const r = Math.max(Math.min(o.size + a, o.max), o.min), l = r - o.size;
          n -= l, o.size = r;
        } else if (!t.includes(o.id)) {
          const r = Math.max(Math.min(o.size + a, o.max), o.min), l = r - o.size;
          n -= l, o.size = r;
        }
        o.update({
          [this.horizontal ? "height" : "width"]: `${this.indexedPanes[o.id].size}%`
        });
      }), Math.abs(n) > 0.1 && this.$nextTick(() => {
        this.ready && console.warn("Splitpanes: Could not resize panes correctly due to their constraints.");
      });
    }
    /* distributeEmptySpace () {
          let growablePanes = []
          let collapsedPanesCount = 0
          let growableAmount = 0 // Total of how much the current panes can grow to fill blank space.
          let spaceToDistribute = 100 - this.panes.reduce((sum, pane) => (sum += pane.size) && sum, 0)
          // Do a first loop to determine if we can distribute the new blank space between all the
          // expandedPanes, without expanding the collapsed ones.
          this.panes.forEach(pane => {
            if (pane.size < pane.max) growablePanes.push(pane)
    
            if (!pane.size) collapsedPanesCount++
            else growableAmount += pane.max - pane.size
          })
    
          // If the blank space to distribute is too great for the expanded panes, also expand collapsed ones.
          let expandCollapsedPanes = growableAmount < spaceToDistribute
    
          // New space to distribute equally.
          let growablePanesCount = (growablePanes.length - (expandCollapsedPanes ? 0 : collapsedPanesCount))
          let equalSpaceToDistribute = spaceToDistribute / growablePanesCount
          // if (growablePanesCount === 1) equalSpace = 100 / this.panesCount
          let spaceLeftToDistribute = spaceToDistribute
    
          // Now add the equalSpaceToDistribute to each pane size accordingly.
          growablePanes.forEach(pane => {
            if (pane.size < pane.max && (pane.size || (!pane.size && expandCollapsedPanes))) {
              const newSize = Math.min(pane.size + equalSpaceToDistribute, pane.max)
              let allocatedSpace = (newSize - pane.size)
              spaceLeftToDistribute -= allocatedSpace
              pane.size = newSize
              // If the equalSpaceToDistribute is not fully added to the current pane, distribute the remainder
              // to the next panes.
              // Also fix decimal issue due to bites - E.g. calculating 8.33 and getting 8.3299999999999
              if (equalSpaceToDistribute - allocatedSpace > 0.1) equalSpaceToDistribute = spaceLeftToDistribute / (--growablePanesCount)
            }
          })
    
          /* Disabled otherwise will show up on hot reload.
          // if there is still space to allocate show warning message.
          if (this.panesCount && ~~spaceLeftToDistribute) {
            // eslint-disable-next-line no-console
            console.warn('Splitpanes: Could not distribute all the empty space between panes due to their constraints.')
          } *\/
    
          this.$emit('resized', this.panes.map(pane => ({ min: pane.min, max: pane.max, size: pane.size })))
        } */
  },
  watch: {
    panes: {
      // Every time a pane is updated, update the panes accordingly.
      deep: !0,
      immediate: !1,
      handler() {
        this.updatePaneComponents();
      }
    },
    horizontal() {
      this.updatePaneComponents();
    },
    firstSplitter() {
      this.redoSplitters();
    },
    dblClickSplitter(n) {
      [...this.container.querySelectorAll(".splitpanes__splitter")].forEach((e, t) => {
        e.ondblclick = n ? (a) => this.onSplitterDblClick(a, t) : void 0;
      });
    }
  },
  beforeUnmount() {
    this.ready = !1;
  },
  mounted() {
    this.container = this.$refs.container, this.checkSplitpanesNodes(), this.redoSplitters(), this.resetPaneSizes(), this.$emit("ready"), this.ready = !0;
  },
  render() {
    return gn(
      "div",
      {
        ref: "container",
        class: [
          "splitpanes",
          `splitpanes--${this.horizontal ? "horizontal" : "vertical"}`,
          {
            "splitpanes--dragging": this.touch.dragging
          }
        ]
      },
      this.$slots.default()
    );
  }
}, cr = (n, e) => {
  const t = n.__vccOpts || n;
  for (const [a, o] of e)
    t[a] = o;
  return t;
}, ur = {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "pane",
  inject: ["requestUpdate", "onPaneAdd", "onPaneRemove", "onPaneClick"],
  props: {
    size: { type: [Number, String], default: null },
    minSize: { type: [Number, String], default: 0 },
    maxSize: { type: [Number, String], default: 100 }
  },
  data: () => ({
    style: {}
  }),
  mounted() {
    this.onPaneAdd(this);
  },
  beforeUnmount() {
    this.onPaneRemove(this);
  },
  methods: {
    // Called from the splitpanes component.
    update(n) {
      this.style = n;
    }
  },
  computed: {
    sizeNumber() {
      return this.size || this.size === 0 ? parseFloat(this.size) : null;
    },
    minSizeNumber() {
      return parseFloat(this.minSize);
    },
    maxSizeNumber() {
      return parseFloat(this.maxSize);
    }
  },
  watch: {
    sizeNumber(n) {
      this.requestUpdate({ target: this, size: n });
    },
    minSizeNumber(n) {
      this.requestUpdate({ target: this, min: n });
    },
    maxSizeNumber(n) {
      this.requestUpdate({ target: this, max: n });
    }
  }
};
function dr(n, e, t, a, o, s) {
  return b(), x("div", {
    class: "splitpanes__pane",
    onClick: e[0] || (e[0] = (r) => s.onPaneClick(r, n._.uid)),
    style: vn(n.style)
  }, [
    xe(n.$slots, "default")
  ], 4);
}
const vt = /* @__PURE__ */ cr(ur, [["render", dr]]), pr = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.33" d="M2.67 2.67h10.66c.74 0 1.34.6 1.34 1.33v8c0 .73-.6 1.33-1.34 1.33H2.67c-.74 0-1.34-.6-1.34-1.33V4c0-.73.6-1.33 1.34-1.33Z"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.33" d="M14.67 4 8 8.67 1.33 4"/></svg>
`, hr = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.33" d="M14.67 11.28v2a1.33 1.33 0 0 1-1.46 1.33 13.2 13.2 0 0 1-5.75-2.04 13 13 0 0 1-4-4 13.2 13.2 0 0 1-2.05-5.78 1.33 1.33 0 0 1 1.33-1.46h2a1.33 1.33 0 0 1 1.33 1.15c.09.64.24 1.27.47 1.87a1.33 1.33 0 0 1-.3 1.41l-.85.85a10.67 10.67 0 0 0 4 4l.85-.85a1.33 1.33 0 0 1 1.4-.3c.61.23 1.24.38 1.88.47a1.33 1.33 0 0 1 1.15 1.35Z"/></svg>
`, mr = { class: "flex flex-col gap-2" }, fr = { class: "text-mobile-body-s font-normal text-gray-500" }, gr = ["href"], vr = ["innerHTML"], yr = ["href"], wr = ["innerHTML"], br = /* @__PURE__ */ z({
  __name: "PharmacyContactInfo",
  props: {
    contact: {}
  },
  setup(n) {
    const { t: e } = U(), t = n;
    return (a, o) => (b(), x("div", mr, [
      f("h3", fr, P(m(e)("contact_details")), 1),
      t.contact.phone ? (b(), x("a", {
        key: 0,
        class: "flex flex-row items-center gap-2 text-[15px] leading-5 text-secondary-700",
        href: `tel:${t.contact.phone}`
      }, [
        f("div", {
          class: "size-4 text-primary-500",
          innerHTML: m(hr)
        }, null, 8, vr),
        se(" " + P(t.contact.phone), 1)
      ], 8, gr)) : Z("", !0),
      t.contact.email ? (b(), x("a", {
        key: 1,
        class: "flex flex-row items-center gap-2 text-[15px] leading-5 text-secondary-700",
        href: `mailto:${t.contact.email}`
      }, [
        f("div", {
          class: "size-4 text-primary-500",
          innerHTML: m(pr)
        }, null, 8, wr),
        se(" " + P(t.contact.email), 1)
      ], 8, yr)) : Z("", !0)
    ]));
  }
}), kr = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.33" d="M6 3.75a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm0 0v4.5h5.5l2 4 1.5-.5"/>
  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.33" d="M10.49 10.25a4 4 0 1 1-4-4.25H10"/>
</svg>
`, _r = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
  <path d="M12 16.5V7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8.25 13.5C8.99168 13.5 9.7167 13.7199 10.3334 14.132C10.9501 14.544 11.4307 15.1297 11.7145 15.8149C11.9984 16.5002 12.0726 17.2542 11.9279 17.9816C11.7833 18.709 11.4261 19.3772 10.9017 19.9017C10.3772 20.4261 9.70902 20.7833 8.98159 20.9279C8.25416 21.0726 7.50016 20.9984 6.81494 20.7145C6.12971 20.4307 5.54404 19.9501 5.13199 19.3334C4.71993 18.7167 4.5 17.9917 4.5 17.25V16.6219" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M15.75 13.5C15.0083 13.5 14.2833 13.7199 13.6666 14.132C13.0499 14.544 12.5693 15.1297 12.2855 15.8149C12.0016 16.5002 11.9274 17.2542 12.0721 17.9816C12.2168 18.709 12.5739 19.3772 13.0984 19.9017C13.6228 20.4261 14.291 20.7833 15.0184 20.9279C15.7458 21.0726 16.4998 20.9984 17.1851 20.7145C17.8703 20.4307 18.456 19.9501 18.868 19.3334C19.2801 18.7167 19.5 17.9917 19.5 17.25V16.6219" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6.75 16.875H6C4.93634 16.8779 3.90604 16.5038 3.09192 15.8193C2.27779 15.1348 1.73245 14.184 1.55267 13.1356C1.37289 12.0873 1.57027 11.0091 2.10981 10.0924C2.64935 9.17575 3.49616 8.47983 4.5 8.12812V6.75C4.5 5.75544 4.89509 4.80161 5.59835 4.09835C6.30161 3.39509 7.25544 3 8.25 3C9.24456 3 10.1984 3.39509 10.9017 4.09835C11.6049 4.80161 12 5.75544 12 6.75V17.25" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M17.25 16.875H18C19.0637 16.8779 20.094 16.5038 20.9081 15.8193C21.7222 15.1348 22.2675 14.184 22.4473 13.1356C22.6271 12.0873 22.4297 11.0091 21.8902 10.0924C21.3506 9.17575 20.5038 8.47983 19.5 8.12812V6.75C19.5 5.75544 19.1049 4.80161 18.4017 4.09835C17.6984 3.39509 16.7446 3 15.75 3C14.7554 3 13.8016 3.39509 13.0983 4.09835C12.3951 4.80161 12 5.75544 12 6.75" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8.25 7.875V8.625C8.25 9.32119 7.97344 9.98887 7.48116 10.4812C6.98887 10.9734 6.32119 11.25 5.625 11.25" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M15.75 7.875V8.625C15.75 9.32119 16.0266 9.98887 16.5188 10.4812C17.0111 10.9734 17.6788 11.25 18.375 11.25" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`, Cr = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
  <path d="M12 15C15.866 15 19 11.866 19 8C19 4.13401 15.866 1 12 1C8.13401 1 5 4.13401 5 8C5 11.866 8.13401 15 12 15Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8.21 13.89L7 23L12 20L17 23L15.79 13.88" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`, xr = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
  <path d="M3 12H6.75L8.25 9.75L11.25 14.25L12.75 12H15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M2.63438 9.00001C2.625 8.87813 2.625 8.74688 2.625 8.62501C2.625 7.49803 3.01546 6.40585 3.72996 5.53431C4.44445 4.66277 5.43884 4.0657 6.54393 3.84468C7.64903 3.62366 8.79657 3.79235 9.79131 4.32204C10.7861 4.85174 11.5665 5.70972 12 6.75001V6.75001C12.4335 5.70972 13.2139 4.85174 14.2087 4.32204C15.2034 3.79235 16.351 3.62366 17.4561 3.84468C18.5612 4.0657 19.5555 4.66277 20.27 5.53431C20.9845 6.40585 21.375 7.49803 21.375 8.62501C21.375 15 12 20.25 12 20.25C12 20.25 8.25938 18.15 5.50313 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`, Pr = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
  <circle cx="16.0067" cy="6.00252" r="4.00167" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M21.0088 11.0046L18.8358 8.83167" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M15.0063 21.0087H18.0075C19.6651 21.0087 21.0088 19.665 21.0088 18.0075V15.0062" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M3.00125 10.0041V7.0029C3.00125 5.34535 4.34496 4.00165 6.0025 4.00165H8.00333" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.93224 19.7244V19.7244C3.69149 18.3063 3.69149 16.189 4.93224 14.771L7.08242 12.3137C7.25407 12.1175 7.50204 12.005 7.7627 12.005C8.02336 12.005 8.27134 12.1175 8.44299 12.3137L10.5932 14.771C11.8339 16.189 11.8339 18.3063 10.5932 19.7244V19.7244C9.87899 20.5405 8.84724 21.0087 7.7627 21.0087C6.67817 21.0087 5.64642 20.5405 4.93224 19.7244Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`, Mr = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.33" d="M14 7.67a5.59 5.59 0 0 1-2.69 4.82 5.67 5.67 0 0 1-5.51.24L2 14l1.27-3.8a5.59 5.59 0 0 1 .24-5.51A5.67 5.67 0 0 1 8.33 2h.34A5.65 5.65 0 0 1 14 7.33v.34Z"/>
</svg>
`, Sr = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 11 16">
  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.44" d="m9.45 7.25-.96 3.82c-.16.64-.73 1.1-1.4 1.1H3.57c-.66 0-1.24-.46-1.4-1.1l-.95-3.82A7.19 7.19 0 0 1 1 5.5V2.77c0-.8.65-1.44 1.44-1.44h5.78c.8 0 1.45.65 1.45 1.44V5.5c0 .59-.08 1.17-.22 1.75v0Z"/>
  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.44" d="M3.53 12.16h3.6c.4 0 .73.32.73.72v.36c0 .6-.48 1.09-1.08 1.09h-2.9c-.59 0-1.07-.49-1.07-1.09v-.36c0-.4.32-.72.72-.72Zm2.09-7.08.87 1.16a1.44 1.44 0 0 1-1.16 2.3v0a1.44 1.44 0 0 1-1.15-2.3l.86-1.16a.36.36 0 0 1 .58 0Z"/>
</svg>
`, zr = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 14" fill="none">
  <path d="M12 8L13 6M2 1H7.426C7.60063 1.00012 7.77219 1.04598 7.9236 1.133C8.07501 1.22002 8.20098 1.34517 8.289 1.496L9.353 3.319C9.55743 3.66957 9.83087 3.97502 10.1568 4.21686C10.4827 4.4587 10.8542 4.63191 11.249 4.726L15.926 5.84C16.8012 6.04826 17.5806 6.54546 18.1384 7.2513C18.6961 7.95713 18.9997 8.83038 19 9.73V12C19 12.2652 18.8946 12.5196 18.7071 12.7071C18.5196 12.8946 18.2652 13 18 13H2C1.73478 13 1.48043 12.8946 1.29289 12.7071C1.10536 12.5196 1 12.2652 1 12V2C1 1.73478 1.10536 1.48043 1.29289 1.29289C1.48043 1.10536 1.73478 1 2 1Z" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6 13V12C6 10.9391 5.57857 9.92172 4.82843 9.17157C4.07828 8.42143 3.06087 8 2 8H1M8 7L9.5 4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`, jr = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 18" fill="none">
  <path d="M12.6003 5.6V1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M9.39976 1V5.6C9.39976 6.925 8.32476 8 6.99976 8V8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14.9999 7.99998C13.6749 7.99998 12.5999 6.92498 12.5999 5.59998" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12.5 11.996V13.364C12.5 14.5 13.142 15.538 14.158 16.046L15.211 16.572C17.871 17.902 21 15.969 21 12.996V6.85102C21 5.94302 20.691 5.06202 20.123 4.35302L18.342 2.12802C17.454 1.01702 16.115 0.783017 15 1.18102" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M9.5 11.996V13.364C9.5 14.5 8.858 15.538 7.842 16.046L6.789 16.572C4.129 17.902 1 15.969 1 12.996V6.85102C1 5.94302 1.309 5.06202 1.877 4.35302L3.658 2.12802C4.546 1.01702 5.885 0.783017 7 1.18102" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`, $r = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
  <path d="M8.397 11.235C8.59206 11.196 8.76365 11.0811 8.87402 10.9156C8.98438 10.7501 9.02448 10.5476 8.9855 10.3525C8.94651 10.1574 8.83163 9.98585 8.66613 9.87548C8.50063 9.76512 8.29806 9.72502 8.103 9.764C7.2 9.944 6.518 10.576 6.155 11.423C5.795 12.261 5.742 13.309 6.023 14.431C6.04494 14.5285 6.08615 14.6207 6.14422 14.702C6.20228 14.7834 6.27602 14.8523 6.3611 14.9048C6.44618 14.9572 6.54089 14.9921 6.63966 15.0075C6.73843 15.0228 6.83927 15.0182 6.93625 14.994C7.03323 14.9698 7.12439 14.9265 7.20439 14.8666C7.28438 14.8067 7.35159 14.7313 7.40206 14.6451C7.45253 14.5588 7.48525 14.4633 7.49829 14.3642C7.51133 14.2651 7.50443 14.1644 7.478 14.068C7.258 13.19 7.33 12.488 7.533 12.014C7.733 11.548 8.051 11.305 8.397 11.235ZM5.471 3.419C5.42826 4.12898 5.5322 4.84015 5.77633 5.5082C6.02046 6.17625 6.39956 6.78687 6.89 7.302C5.93736 7.57514 5.08446 8.11888 4.43479 8.86724C3.78511 9.61561 3.36659 10.5364 3.23 11.518C2.90085 13.8732 3.38407 16.2703 4.6 18.314L4.95 18.904L4.993 18.967L6.409 20.873C6.70891 21.277 7.09328 21.6107 7.53532 21.851C7.97737 22.0913 8.46647 22.2323 8.96858 22.2643C9.47069 22.2963 9.97373 22.2184 10.4427 22.0362C10.9116 21.8539 11.3352 21.5716 11.684 21.209C11.7248 21.1666 11.7737 21.1329 11.8278 21.1098C11.8819 21.0868 11.9402 21.0749 11.999 21.0749C12.0578 21.0749 12.116 21.0868 12.1702 21.1098C12.2243 21.1329 12.2732 21.1666 12.314 21.209C12.6627 21.5716 13.0863 21.8539 13.5553 22.0362C14.0243 22.2184 14.5273 22.2963 15.0294 22.2643C15.5315 22.2323 16.0206 22.0913 16.4627 21.851C16.9047 21.6107 17.2891 21.277 17.589 20.873L19.005 18.966L19.047 18.903L19.398 18.313C20.6147 16.2699 21.099 13.8732 20.771 11.518C20.6742 10.824 20.4359 10.1573 20.071 9.5591C19.7061 8.96091 19.2223 8.44399 18.6496 8.04034C18.0768 7.63668 17.4273 7.35489 16.7412 7.21241C16.0551 7.06993 15.3471 7.06979 14.661 7.212L12.76 7.606H12.757C12.787 6.826 12.909 5.986 13.148 5.268C13.438 4.4 13.84 3.878 14.288 3.692C14.4717 3.61535 14.6174 3.46889 14.693 3.28482C14.7687 3.10075 14.7681 2.89416 14.6915 2.7105C14.6148 2.52684 14.4684 2.38115 14.2843 2.30548C14.1002 2.22981 13.8937 2.23035 13.71 2.307C12.658 2.746 12.06 3.787 11.725 4.793L11.679 4.935C11.433 4.45899 11.1149 4.02385 10.736 3.645C10.2174 3.12574 9.59442 2.7226 8.90827 2.46228C8.22213 2.20196 7.48851 2.0904 6.756 2.135C6.42171 2.15424 6.10611 2.29551 5.86907 2.532C5.63202 2.76849 5.49002 3.08376 5.47 3.418M6.963 3.625C7.4648 3.61052 7.96427 3.69886 8.43066 3.88459C8.89706 4.07033 9.32052 4.34952 9.675 4.705C10.0305 5.05948 10.3097 5.48294 10.4954 5.94933C10.6811 6.41573 10.7695 6.91519 10.755 7.417C10.5736 7.42099 10.3922 7.41264 10.212 7.392L9.595 7.264C9.00897 7.08808 8.47573 6.76957 8.043 6.337C7.68752 5.98253 7.40832 5.55906 7.22259 5.09267C7.03686 4.62627 6.94851 4.12681 6.963 3.625ZM9.033 8.68L9.235 8.722C9.475 8.79 9.71833 8.84067 9.965 8.874L10.935 9.074C11.6375 9.21954 12.3625 9.21954 13.065 9.074L14.967 8.68C15.4521 8.57945 15.9528 8.57956 16.4379 8.68033C16.923 8.7811 17.3823 8.98038 17.7872 9.26583C18.1922 9.55127 18.5343 9.91682 18.7922 10.3398C19.0502 10.7628 19.2186 11.2343 19.287 11.725C19.5678 13.7427 19.1527 15.7959 18.11 17.546L17.779 18.103L16.386 19.979C16.216 20.208 15.9981 20.3972 15.7475 20.5334C15.497 20.6696 15.2197 20.7495 14.9351 20.7676C14.6504 20.7856 14.3653 20.7415 14.0995 20.6381C13.8337 20.5347 13.5936 20.3746 13.396 20.169C13.2153 19.981 12.9986 19.8314 12.7587 19.7292C12.5188 19.627 12.2607 19.5744 12 19.5744C11.7393 19.5744 11.4812 19.627 11.2413 19.7292C11.0014 19.8314 10.7847 19.981 10.604 20.169C10.4064 20.3746 10.1663 20.5347 9.9005 20.6381C9.6347 20.7415 9.34955 20.7856 9.06493 20.7676C8.7803 20.7495 8.50304 20.6696 8.25246 20.5334C8.00188 20.3972 7.784 20.208 7.614 19.979L6.221 18.103L5.89 17.546C4.84768 15.7958 4.43289 13.7426 4.714 11.725C4.7824 11.2344 4.95077 10.763 5.20868 10.3401C5.46659 9.91718 5.80856 9.55169 6.21342 9.26625C6.61828 8.98082 7.07741 8.78151 7.5624 8.68067C8.04739 8.57983 8.54792 8.57961 9.033 8.68Z" fill="currentColor"/>
</svg>
`, Lr = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
  <path fill="currentColor" d="M6 13.42a3.31 3.31 0 0 0 2.36-.97l4.75-4.76A3.34 3.34 0 0 0 8.4 2.98L3.64 7.73A3.34 3.34 0 0 0 6 13.43Zm3.34-9.5a1.99 1.99 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-1.93 1.93-2.83-2.83 1.93-1.93ZM4.6 8.67 6.47 6.8 9.3 9.62 7.4 11.5c-.75.76-2.07.76-2.82 0a2 2 0 0 1 0-2.83Z"/>
</svg>
`, Ir = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
  <path d="M20.25 6.75H3.75C3.33579 6.75 3 7.08579 3 7.5V19.5C3 19.9142 3.33579 20.25 3.75 20.25H20.25C20.6642 20.25 21 19.9142 21 19.5V7.5C21 7.08579 20.6642 6.75 20.25 6.75Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M15.75 6.75V5.25C15.75 4.85218 15.592 4.47064 15.3107 4.18934C15.0294 3.90804 14.6478 3.75 14.25 3.75H9.75C9.35218 3.75 8.97064 3.90804 8.68934 4.18934C8.40804 4.47064 8.25 4.85218 8.25 5.25V6.75" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12 10.875V16.125" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14.625 13.5H9.375" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`, Er = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
  <path d="M14.3676 4V11.3846L18.6175 17.0092C18.8245 17.2816 18.9535 17.6091 18.9896 17.9542C19.0257 18.2993 18.9675 18.648 18.8216 18.9603C18.6758 19.2725 18.4482 19.5357 18.165 19.7196C17.8818 19.9035 17.5545 20.0007 17.2206 20H6.77939C6.4455 20.0007 6.11817 19.9035 5.83499 19.7196C5.5518 19.5357 5.32422 19.2725 5.17837 18.9603C5.03252 18.648 4.97431 18.2993 5.01041 17.9542C5.04652 17.6091 5.17548 17.2816 5.38249 17.0092L9.63238 11.3846V4M7.85666 4H16.1433" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`, Ar = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.33" d="M13.82 3.7v1.32H12.5h1.33M5.06 7.15a.98.98 0 0 1 1.96 0c0 1.23-1.96 1.23-1.96 2.68h1.96m3.58-1.81L8.92 8a.17.17 0 0 1-.17-.17V6.17m1.85.04v3.62"/>
  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.33" d="M13.53 5.03A6.3 6.3 0 0 0 8 1.78 6.22 6.22 0 1 0 14.22 8"/>
</svg>
`, Dr = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
  <path d="M18.85 16L18 15.15V13H19.5V16H18.85ZM17 14.15L15.85 13H17V14.15ZM20.5 16V13H22V16H20.5ZM19.8 22.6L13.2 16H1.99999V13H10.2L1.39999 4.2L2.79999 2.8L21.2 21.2L19.8 22.6ZM18 12V10.7C18 10.05 17.8083 9.554 17.425 9.212C17.0417 8.87067 16.5833 8.7 16.05 8.7H14.5C13.5667 8.7 12.775 8.375 12.125 7.725C11.475 7.075 11.15 6.28333 11.15 5.35C11.15 4.41667 11.475 3.625 12.125 2.975C12.775 2.325 13.5667 2 14.5 2V3.5C14 3.5 13.5667 3.675 13.2 4.025C12.8333 4.375 12.65 4.81667 12.65 5.35C12.65 5.88333 12.8333 6.325 13.2 6.675C13.5667 7.025 14 7.2 14.5 7.2H16.05C16.9833 7.2 17.7917 7.5 18.475 8.1C19.1583 8.7 19.5 9.45 19.5 10.35V12H18ZM20.5 12V9.75C20.5 8.65 20.1167 7.7 19.35 6.9C18.5833 6.1 17.6333 5.7 16.5 5.7V4.2C17 4.2 17.4333 4.01667 17.8 3.65C18.1667 3.28333 18.35 2.85 18.35 2.35H19.85C19.85 2.83333 19.7583 3.27067 19.575 3.662C19.3917 4.054 19.15 4.41667 18.85 4.75C19.7833 5.18333 20.5417 5.85 21.125 6.75C21.7083 7.65 22 8.65 22 9.75V12H20.5Z" fill="currentColor"/>
</svg>
`, Or = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
  <path d="M4 21H13.62C14.1971 21.0003 14.7674 20.8756 15.2916 20.6344C15.8159 20.3933 16.2817 20.0414 16.657 19.603L21.759 13.651C21.8658 13.5266 21.9404 13.3778 21.9762 13.2178C22.012 13.0577 22.0079 12.8913 21.9642 12.7333C21.9206 12.5752 21.8387 12.4303 21.7258 12.3113C21.6129 12.1923 21.4726 12.1029 21.317 12.051L19.349 11.395C18.8734 11.2404 18.3669 11.2054 17.8745 11.2931C17.3821 11.3809 16.919 11.5886 16.526 11.898L13.341 14.445L12.724 13.21C12.3935 12.5443 11.8831 11.9844 11.2507 11.5938C10.6184 11.2032 9.88926 10.9975 9.146 11H4C2.897 11 2 11.897 2 13V19C2 20.103 2.897 21 4 21ZM4 13H9.146C9.909 13 10.594 13.423 10.935 14.105L11.382 15H7V17H13.014C13.1679 16.998 13.3191 16.9603 13.456 16.89L13.459 16.889L13.463 16.887H13.466L13.468 16.886H13.472L13.473 16.885C13.484 16.888 13.476 16.884 13.476 16.884C13.488 16.884 13.478 16.883 13.478 16.883H13.479L13.481 16.882L13.484 16.881L13.486 16.88L13.488 16.879L13.491 16.878L13.493 16.877L13.495 16.876L13.498 16.874L13.5 16.873L13.502 16.872L13.505 16.871L13.507 16.87H13.508L13.51 16.869H13.511L13.513 16.868L13.515 16.867C13.526 16.866 13.518 16.866 13.518 16.866L13.52 16.865C13.5585 16.8417 13.5953 16.8157 13.63 16.787L17.776 13.47C18.037 13.262 18.399 13.197 18.716 13.303L19.273 13.489L15.14 18.312C14.9499 18.5279 14.716 18.7009 14.454 18.8195C14.1919 18.9381 13.9077 18.9996 13.62 19H4V13ZM13.761 2.32601C13.3 2.83201 11 5.45701 11 7.50001C11 9.43001 12.57 11 14.5 11C16.43 11 18 9.43001 18 7.50001C18 5.45701 15.7 2.83201 15.239 2.32601C14.86 1.91001 14.14 1.91001 13.761 2.32601ZM16 7.50001C16 8.32701 15.327 9.00001 14.5 9.00001C13.673 9.00001 13 8.32701 13 7.50001C13 6.79201 13.738 5.56601 14.5 4.56601C15.262 5.56601 16 6.79201 16 7.50001Z" fill="currentColor"/>
</svg>
`, Hr = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.33" d="M8 12v1.5"/>
  <path fill="currentColor" d="M5.75 9.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm4.5 0a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"/>
  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.33" d="m9 11-1 1-1-1m2.5-8 3.49-.87a.5.5 0 0 1 .61.39l1.03 5.47c.09.52-.57.82-.9.4L9.5 3Zm-3 0-3.49-.87a.5.5 0 0 0-.61.39L1.38 7.99c-.1.52.56.82.88.4L6.5 3Zm0 0h3"/>
  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.33" d="M13 7.46v4.04a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7.46"/>
</svg>
`, Tr = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
  <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M9.09 9C9.3251 8.33167 9.78915 7.76811 10.4 7.40913C11.0108 7.05016 11.7289 6.91894 12.4272 7.03871C13.1255 7.15849 13.7588 7.52153 14.2151 8.06353C14.6713 8.60553 14.9211 9.29152 14.92 10C14.92 12 11.92 13 11.92 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12 17H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`, Nt = {
  cat_bezbarier: kr,
  cat_consul: Mr,
  cat_dermo: Sr,
  cat_homeo: Lr,
  cat_nonstop: Ar,
  cat_tooth: Hr,
  cat_baby: Or,
  cat_geria: Dr,
  cat_shopping: Er,
  cat_special: $r,
  cat_shoes: zr,
  cat_china: Ir,
  cat_academy: Cr,
  cat_alzheimer: _r,
  cz_note2: Pr,
  cz_note3: xr,
  cat_lungs: jr
};
function Rr(n) {
  return n in Nt;
}
function Vr(n) {
  return Rr(n) ? Nt[n] : Tr;
}
const Nr = { class: "flex flex-col gap-2" }, Zr = { class: "text-mobile-body-s font-normal text-gray-500" }, qr = ["innerHTML"], Br = /* @__PURE__ */ z({
  __name: "PharmacyInfoTags",
  props: {
    parameters: {}
  },
  setup(n) {
    const { t: e } = U(), t = n;
    function a(o) {
      return Vr(o);
    }
    return (o, s) => (b(), x("div", Nr, [
      f("h3", Zr, P(m(e)("about_the_pharmacy")), 1),
      (b(!0), x(N, null, X(t.parameters, (r) => (b(), x("div", {
        key: r.id,
        class: "flex items-center gap-2 text-mobile-body-m text-secondary-700"
      }, [
        f("div", {
          class: "pharmacy-icon size-4 text-primary-500",
          innerHTML: a(r.uid)
        }, null, 8, qr),
        se(" " + P(r.name), 1)
      ]))), 128))
    ]));
  }
}), Wr = /* @__PURE__ */ We(Br, [["__scopeId", "data-v-0c5ef770"]]), Fr = {
  cz: Mn,
  sk: Za,
  ro: ra,
  rs: bo
};
function Zt(n, e) {
  const t = $n(/* @__PURE__ */ new Date(), n), a = Pn(t, "EEEEEE", { locale: Fr[e ?? "cz"] });
  return a.charAt(0).toUpperCase() + a.slice(1);
}
const Ur = { class: "flex flex-col gap-2" }, Kr = { class: "text-mobile-body-s font-normal text-gray-500" }, Gr = { class: "w-1/2" }, Xr = { class: "w-1/2" }, Yr = { class: "w-1/2" }, Qr = { class: "w-1/2" }, Jr = /* @__PURE__ */ z({
  __name: "PharmacyOpeningHours",
  props: {
    workingHours: {},
    openingHolidays: {}
  },
  setup(n) {
    const { t: e } = U(), t = n, a = S(() => {
      const r = Object.values(t.workingHours), l = (i) => !i.isClosed && !!i.openingHours;
      return r.filter(l);
    }), o = S(() => {
      const r = (/* @__PURE__ */ new Date()).getDay();
      return a.value.some((l) => l.dayOfWeek === r);
    }), s = S(() => {
      const r = /* @__PURE__ */ new Date(), l = new Date(r);
      return l.setDate(r.getDate() + 14), t.openingHolidays.find((i) => {
        const d = i.date.split("."), u = /* @__PURE__ */ new Date(`${d[1]}.${d[0]}.${d[2]}`);
        return u > r && u <= l;
      });
    });
    return (r, l) => (b(), x("div", Ur, [
      f("h3", Kr, P(m(e)("pharmacy_opening_hours")), 1),
      f("h4", {
        class: G(["text-mobile-body-m font-normal", o.value ? "text-primary-500" : "text-red-400"])
      }, P(o.value ? m(e)("open_today") : m(e)("closed_today")), 3),
      (b(!0), x(N, null, X(a.value, (i) => (b(), x("div", {
        key: i.dayOfWeek,
        class: "flex items-center justify-start gap-1 text-mobile-body-m text-secondary-700"
      }, [
        f("span", Gr, P(m(Zt)(i.dayOfWeek)), 1),
        f("span", Xr, P(i.openingHours.from) + " - " + P(i.openingHours.to), 1)
      ]))), 128)),
      s.value ? (b(), x("div", {
        key: 0,
        class: G(["flex items-center justify-start gap-1 text-mobile-body-m", s.value.isOpen ? "text-primary-500" : "text-red-400"])
      }, [
        f("span", Yr, P(s.value.date), 1),
        f("span", Qr, P(s.value.isOpen ? r.$t("open") : r.$t("close")), 1)
      ], 2)) : Z("", !0)
    ]));
  }
}), ei = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18"><path fill="currentColor" d="M14.25 2.25h-12c-.83 0-1.5.67-1.5 1.5v9c0 .83.67 1.5 1.5 1.5h7.5v-1.5h-7.5v-4.5h13.5v-4.5c0-.83-.67-1.5-1.5-1.5Zm0 3h-12v-1.5h12v1.5Zm3 6.75v1.5H15v2.25h-1.5V13.5h-2.25V12h2.25V9.75H15V12h2.25Z"/></svg>
`, ti = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 19 20"><path fill="currentColor" d="M16.23 6.26v-1.8c0-.87-.71-1.58-1.58-1.58H3.56c-.88 0-1.58.7-1.58 1.58v11.08c0 .87.7 1.59 1.58 1.59h11.09a1.6 1.6 0 0 0 1.58-1.59v-1.8c.47-.28.8-.78.8-1.37V7.63c0-.6-.33-1.09-.8-1.37Zm-.8 1.37v4.75H9.9V7.62h5.54ZM3.57 15.54V4.46h11.09v1.58H9.9a1.6 1.6 0 0 0-1.59 1.58v4.75c0 .88.72 1.59 1.59 1.59h4.75v1.58H3.56Z"/><path fill="currentColor" d="M12.27 11.19a1.19 1.19 0 1 0 0-2.38 1.19 1.19 0 0 0 0 2.38Z"/></svg>
`, ni = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M20 4H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Zm0 14H4v-6h16v6Zm0-10H4V6h16v2Z"/></svg>
`, ai = { class: "flex flex-col gap-2" }, oi = { class: "text-mobile-body-s font-normal text-gray-500" }, si = ["innerHTML"], ri = /* @__PURE__ */ z({
  __name: "PharmacyPaymentMethods",
  props: {
    paymentMethods: {}
  },
  setup(n) {
    const { t: e } = U(), t = n;
    function a(o) {
      switch (o) {
        case "PAY_CASH":
          return ti;
        case "UID_CARD_PAY":
          return ni;
        case "PAY_BENEFIT_GROUP":
          return ei;
        default:
          return;
      }
    }
    return (o, s) => (b(), x("div", ai, [
      f("h3", oi, P(m(e)("payment_methods")), 1),
      (b(!0), x(N, null, X(t.paymentMethods.filter((r) => r.isAccepted), (r) => (b(), x("div", {
        key: r.uid,
        class: "flex items-center gap-2 text-mobile-body-m text-secondary-700"
      }, [
        f("span", {
          class: "size-4 text-primary-500",
          innerHTML: a(r.uid)
        }, null, 8, si),
        se(" " + P(r.name), 1)
      ]))), 128))
    ]));
  }
}), ii = { class: "@container" }, li = { class: "grid grid-cols-1 gap-3.5 @md:grid-cols-2 @md:grid-rows-[1fr,auto] @xl:grid-cols-3" }, qt = /* @__PURE__ */ z({
  __name: "PharmacyDetailBodyContent",
  props: {
    pharmacyDetail: {}
  },
  setup(n) {
    const e = n;
    return (t, a) => (b(), x("div", ii, [
      f("div", li, [
        M(Jr, {
          class: "rounded-2xl bg-white p-4 shadow-level-2 @xl:row-span-2 lg:px-0 lg:shadow-none",
          "working-hours": e.pharmacyDetail.workingHours,
          "opening-holidays": e.pharmacyDetail.openingHolidays
        }, null, 8, ["working-hours", "opening-holidays"]),
        M(Wr, {
          class: "rounded-2xl bg-white p-4 shadow-level-2 @xl:col-start-3 @xl:row-span-2 @xl:row-start-1 lg:px-0 lg:shadow-none",
          parameters: e.pharmacyDetail.parameters
        }, null, 8, ["parameters"]),
        M(ri, {
          class: "rounded-2xl bg-white p-4 shadow-level-2 @md:order-last @xl:order-none @xl:col-start-2 lg:px-0 lg:shadow-none",
          "payment-methods": e.pharmacyDetail.paymentMethods
        }, null, 8, ["payment-methods"]),
        M(br, {
          class: "rounded-2xl bg-white p-4 shadow-level-2 @xl:col-start-2 lg:px-0 lg:shadow-none",
          contact: e.pharmacyDetail.contact
        }, null, 8, ["contact"])
      ])
    ]));
  }
}), ci = ["innerHTML"], Bt = /* @__PURE__ */ z({
  __name: "DrugAvailabilityBadge",
  props: {
    overallAvailability: {},
    individualItems: {}
  },
  setup(n) {
    const { t: e } = U(), t = n, a = S(() => {
      switch (t.overallAvailability) {
        case "stock":
          return {
            badge: {
              label: e("pickup_immediately"),
              variant: "success",
              icon: jt
            }
          };
        case "supplier":
          return {
            badge: {
              label: e("next_working_day"),
              variant: "info",
              icon: St
            }
          };
        default:
          return {
            badge: {
              label: e("we_will_contact_you"),
              variant: "warning",
              icon: zt
            }
          };
      }
    });
    return (o, s) => (b(), D($t, {
      overallAvailability: o.overallAvailability,
      individualItems: o.individualItems
    }, {
      default: I(() => [
        M(m(en), {
          class: "w-full text-nowrap sm:w-fit",
          label: a.value.badge.label,
          variant: a.value.badge.variant
        }, {
          prependIcon: I(() => [
            f("div", {
              class: "h-[14px] w-[14px]",
              innerHTML: a.value.badge.icon
            }, null, 8, ci)
          ]),
          _: 1
        }, 8, ["label", "variant"])
      ]),
      _: 1
    }, 8, ["overallAvailability", "individualItems"]));
  }
}), Wt = /* @__PURE__ */ z({
  __name: "NavigationButton",
  props: {
    coordinates: {}
  },
  setup(n) {
    const e = n;
    function t() {
      window.open(
        `https://www.google.com/maps/dir/?api=1&destination=${e.coordinates.lat},${e.coordinates.lng}`,
        "_blank"
      );
    }
    return (a, o) => (b(), D(m(ue), {
      class: "w-full",
      variant: "secondary",
      label: a.$t("navigate_to_pharmacy"),
      onClick: t
    }, null, 8, ["label"]));
  }
}), ui = `<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 21 21"
  fill="none"
>
  <path
    d="m4.596 8.726 10.203-4.858c1.487-.709 3.04.845 2.331 2.333l-4.858 10.202c-.664 1.394-2.676 1.308-3.219-.139l-.898-2.396a1.75 1.75 0 0 0-1.023-1.024l-2.398-.899c-1.445-.542-1.532-2.555-.138-3.219Z"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
`, di = { class: "flex items-center gap-1 sm:gap-2" }, pi = ["innerHTML"], hi = { class: "text-mobile-body-s text-secondary-800 sm:text-desktop-body-s" }, mi = { class: "flex gap-1" }, fi = {
  key: 0,
  class: "text-mobile-body-s text-gray-500 sm:text-desktop-body-s"
}, Ft = /* @__PURE__ */ z({
  __name: "PharmacyBasicInfo",
  props: {
    pharmacy: {}
  },
  setup(n) {
    const { t: e } = U(), t = n, a = S(() => t.pharmacy.distance.toFixed(10 < t.pharmacy.distance ? 0 : 1)), o = S(() => {
      if (!t.pharmacy.workingHours.openingHours || t.pharmacy.workingHours.isClosed)
        return {
          title: e("closed_today"),
          color: "text-red-400"
        };
      const s = /* @__PURE__ */ new Date(), r = new Date(t.pharmacy.workingHours.openingHours.from), l = new Date(t.pharmacy.workingHours.openingHours.to), i = new Date(r);
      if (i.setHours(r.getHours() - 1), s < r && s >= i)
        return {
          title: e("pharmacy_soon_open"),
          color: "text-orange-400"
        };
      const d = new Date(l);
      return d.setHours(l.getHours() - 1), s >= d && s < l ? {
        title: e("pharmacy_soon_close"),
        color: "text-orange-400"
      } : {
        title: e("open_today"),
        color: "text-primary-500"
      };
    });
    return (s, r) => (b(), x("div", di, [
      f("div", {
        class: "size-[21px] text-primary-500 sm:h-[16px] sm:w-[16px]",
        innerHTML: m(ui)
      }, null, 8, pi),
      f("span", hi, P(a.value) + " km ", 1),
      r[0] || (r[0] = f("div", { class: "size-[3px] rounded-full bg-gray-300 sm:mx-1" }, null, -1)),
      f("div", mi, [
        f("span", {
          class: G(["text-mobile-body-s sm:text-desktop-body-s", o.value.color])
        }, P(o.value.title), 3),
        t.pharmacy.workingHours.openingHours && !t.pharmacy.workingHours.isClosed ? (b(), x("span", fi, " (" + P(m(Zt)(t.pharmacy.workingHours.dayOfWeek)) + " " + P(t.pharmacy.workingHours.openingHours.from) + " - " + P(t.pharmacy.workingHours.openingHours.to) + ") ", 1)) : Z("", !0)
      ])
    ]));
  }
}), gi = { class: "pb-4 md:pt-10" }, vi = { class: "mb-5 max-w-lg pr-14" }, yi = { class: "mb-0.5 text-mobile-body-m font-bold text-secondary-800 sm:text-desktop-headline-m" }, wi = { class: "mb-2 text-desktop-body-s text-gray-500 sm:text-desktop-body-m" }, bi = { class: "w-full md:w-fit" }, ki = { class: "mb-6 flex flex-col items-center justify-between gap-5 sm:flex-row-reverse sm:gap-4" }, _i = /* @__PURE__ */ z({
  __name: "PharmacyDetailHeaderContent",
  props: {
    pharmacy: {}
  },
  setup(n) {
    const { t: e } = U(), t = n, a = fe();
    function o() {
      wt(`${a.datasetUrls.reservationsLink}?warehouseId=${t.pharmacy.id}`, { target: "_blank" });
    }
    return (s, r) => (b(), x(N, null, [
      f("div", gi, [
        f("div", vi, [
          f("div", yi, P(t.pharmacy.title), 1),
          f("div", wi, P(t.pharmacy.address.street) + ", " + P(t.pharmacy.address.city) + ", " + P(t.pharmacy.address.postCode), 1),
          M(Ft, {
            pharmacy: t.pharmacy
          }, null, 8, ["pharmacy"])
        ]),
        f("div", bi, [
          M(Bt, {
            overallAvailability: t.pharmacy.availability,
            individualItems: t.pharmacy.items
          }, null, 8, ["overallAvailability", "individualItems"])
        ])
      ]),
      f("div", ki, [
        M(m(ue), {
          class: "w-full",
          label: m(e)("reserve_ePrescription"),
          variant: "primary",
          onClick: o
        }, null, 8, ["label"]),
        M(Wt, {
          class: "w-full",
          coordinates: t.pharmacy.coordinates
        }, null, 8, ["coordinates"])
      ])
    ], 64));
  }
}), Ci = /* @__PURE__ */ z({
  __name: "MapPharmacyPreview",
  setup(n) {
    const { md: e } = $e(), t = Le(), { searchResults: a, searchCoordinates: o } = re(t), s = Ie(), { showMap: r, selectedPharmacy: l, selectedPharmacyDetail: i } = re(s), { setSelectedPharmacy: d, unselectPharmacy: u, closeMapDialog: c } = s, h = S(() => {
      var w;
      return ((w = l.value) == null ? void 0 : w.coordinates) ?? o.value;
    }), v = S({
      get() {
        return r.value;
      },
      set(w) {
        w || c(), r.value = w;
      }
    }), p = k(50), g = k();
    function y(w) {
      if (!w.length) return;
      const _ = w[0].size;
      if (!(_ > 40 && _ < 60)) {
        if (_ - p.value > 20 || _ > 90) {
          p.value = 100, u();
          return;
        }
        if (p.value - _ > 10 || _ < 20) {
          p.value = 0;
          return;
        }
      }
    }
    return B(
      l,
      (w) => {
        p.value = w ? 50 : 100, g.value = !!w;
      },
      { immediate: !0 }
    ), (w, _) => (b(), D(m(tn), {
      windowOpen: v.value,
      "onUpdate:windowOpen": _[1] || (_[1] = (C) => v.value = C),
      "hide-header": g.value && !m(e),
      "z-index": 50
    }, {
      activator: I((C) => [
        xe(w.$slots, "default", kt(_t(C)), void 0, !0)
      ]),
      default: I(() => [
        M(m(lr), {
          horizontal: !m(e),
          class: "h-dvh w-screen max-w-screen-sm md:flex md:max-h-[90vh] md:min-h-[80vh] md:max-w-screen-2xl md:flex-row-reverse",
          onResized: y
        }, {
          default: I(() => [
            M(m(vt), { size: p.value }, {
              default: I(() => [
                M(m(Os), {
                  class: G(["h-full", "transition-all duration-500 ease-in-out"]),
                  apiKey: m(ze).google.apiKey,
                  center: h.value,
                  zoom: m(l) ? 16 : 13,
                  libraries: ["visualization"],
                  "fullscreen-control": !1,
                  "map-type-control": !1
                }, {
                  default: I(() => [
                    (b(!0), x(N, null, X(m(a), (C) => {
                      var $;
                      return b(), D(ir, {
                        key: C.id,
                        pharmacy: C,
                        "is-active": C.id === (($ = m(l)) == null ? void 0 : $.id),
                        onSelectPharmacy: (E) => m(d)(C)
                      }, null, 8, ["pharmacy", "is-active", "onSelectPharmacy"]);
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["apiKey", "center", "zoom"])
              ]),
              _: 1
            }, 8, ["size"]),
            M(m(vt), {
              size: 100 - p.value,
              class: G(m(l) && "relative overflow-y-auto px-6 pb-7 pt-2 xl:pl-14")
            }, {
              default: I(() => [
                m(l) ? (b(), x(N, { key: 0 }, [
                  f("button", {
                    class: "absolute right-6 top-2 flex size-8 items-center justify-center rounded-full bg-gray-100 text-gray-600 transition duration-200 ease-in-out hover:bg-gray-200 focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-2 focus-visible:outline-secondary-300 md:top-12 xl:size-10",
                    onClick: _[0] || (_[0] = //@ts-ignore
                    (...C) => m(u) && m(u)(...C))
                  }, [
                    f("span", {
                      class: G(m(Ze).TIMES)
                    }, null, 2)
                  ]),
                  M(_i, { pharmacy: m(l) }, null, 8, ["pharmacy"]),
                  m(i) ? (b(), D(qt, {
                    key: 0,
                    "pharmacy-detail": m(i)
                  }, null, 8, ["pharmacy-detail"])) : Z("", !0)
                ], 64)) : Z("", !0)
              ]),
              _: 1
            }, 8, ["size", "class"])
          ]),
          _: 1
        }, 8, ["horizontal"])
      ]),
      _: 3
    }, 8, ["windowOpen", "hide-header"]));
  }
}), xi = /* @__PURE__ */ We(Ci, [["__scopeId", "data-v-fd884539"]]), Pi = { class: "mb-0.5 text-mobile-body-m font-bold text-secondary-800 sm:text-desktop-headline-m" }, Mi = { class: "mb-2 flex flex-wrap items-center gap-1 sm:gap-2" }, Si = { class: "text-desktop-body-s text-gray-500 sm:text-desktop-body-m" }, zi = /* @__PURE__ */ z({
  __name: "PharmacyInfo",
  props: {
    pharmacy: {},
    enableMapPreview: { type: Boolean }
  },
  setup(n) {
    const { t: e } = U(), t = n, a = Ie(), { setSelectedPharmacy: o } = a;
    function s() {
      o(t.pharmacy);
    }
    return (r, l) => (b(), x("div", null, [
      f("div", Pi, P(t.pharmacy.title), 1),
      f("div", Mi, [
        f("span", Si, P(t.pharmacy.address.street) + ", " + P(t.pharmacy.address.city) + ", " + P(t.pharmacy.address.postCode), 1),
        f("button", {
          class: "cursor-pointer text-mobile-body-s text-primary-500 underline hover:no-underline sm:text-desktop-body-s",
          onClick: s
        }, P(m(e)("show_on_map")), 1)
      ]),
      M(Ft, {
        pharmacy: t.pharmacy
      }, null, 8, ["pharmacy"])
    ]));
  }
}), ji = { class: "flex flex-col flex-wrap justify-between gap-5 sm:flex-row sm:pr-14 lg:flex-nowrap" }, $i = { class: "flex flex-col items-center justify-between gap-5 sm:flex-row sm:gap-[18px]" }, Li = { class: "w-full sm:w-[180px]" }, Ii = { class: "w-full sm:min-w-56" }, Ei = { class: "mt-2 md:hidden" }, Ai = /* @__PURE__ */ z({
  __name: "PharmacyPreview",
  props: {
    pharmacy: {}
  },
  setup(n) {
    const { getPharmacyDetail: e } = Mt(), t = n, a = k(), o = fe();
    function s() {
      wt(`${o.datasetUrls.reservationsLink}?warehouseId=${t.pharmacy.id}`, { target: "_blank" });
    }
    async function r(l) {
      l || (a.value = await e(t.pharmacy.id));
    }
    return (l, i) => (b(), D(m(nn), {
      class: "py-4 sm:py-5",
      "onUpdate:collapsed": r
    }, {
      header: I(() => [
        f("div", ji, [
          M(zi, {
            class: "w-full pr-14 sm:pr-0",
            pharmacy: t.pharmacy,
            "enable-map-preview": ""
          }, null, 8, ["pharmacy"]),
          f("div", $i, [
            f("div", Li, [
              M(Bt, {
                overallAvailability: t.pharmacy.availability,
                individualItems: t.pharmacy.items
              }, null, 8, ["overallAvailability", "individualItems"])
            ]),
            f("div", Ii, [
              M(m(ue), {
                class: "w-full",
                label: l.$t("reserve_ePrescription"),
                variant: "primary",
                onClick: s
              }, null, 8, ["label"])
            ])
          ])
        ])
      ]),
      default: I(() => [
        f("div", Ei, [
          M(Wt, {
            coordinates: t.pharmacy.coordinates
          }, null, 8, ["coordinates"])
        ]),
        a.value ? (b(), D(qt, {
          key: 0,
          class: "py-5",
          "pharmacy-detail": a.value
        }, null, 8, ["pharmacy-detail"])) : Z("", !0)
      ]),
      _: 1
    }));
  }
}), Di = {
  root: {
    class: [
      "max-w-[290px]",
      "w-full",
      "rounded",
      "shadow-level-4-flipped-y",
      "data-[p-overlaypanel-flipped=true]:shadow-level-4",
      "border-0",
      "mt-3",
      "data-[p-overlaypanel-flipped=true]:-mt-3",
      "transform origin-center",
      "bg-white",
      "text-secondary-700"
    ]
  },
  transition: {
    enterFromClass: "opacity-0 scale-y-[0.8]",
    enterActiveClass: "transition-[transform,opacity] duration-100 ease-out",
    leaveActiveClass: "transition-opacity duration-100 ease-linear",
    leaveToClass: "opacity-0"
  }
}, Oi = { class: "md:py-5" }, Hi = {
  key: 0,
  class: "unlimited-width md:limited-width md:flex md:flex-row-reverse md:flex-wrap md:items-center md:justify-between"
}, Ti = { class: "mb-5 flex items-center justify-between border-b border-b-gray-200 md:gap-3 md:border-none" }, Ri = ["aria-label"], Vi = { class: "text-mobile-body-m md:text-desktop-body-m" }, Ni = ["aria-label"], Zi = { class: "md:hidden" }, qi = { class: "hidden text-mobile-body-m md:block md:text-desktop-body-m" }, Bi = ["onClick"], Wi = { class: "text-desktop-body-m text-blue-700" }, Fi = ["innerHTML"], Ui = {
  key: 1,
  class: "w-full pb-1 pt-3 md:p-0 md:pb-4"
}, Ki = { class: "mx-4 flex flex-col justify-start gap-y-1 rounded-md bg-blue-50 p-3.5 md:mx-0 md:flex-row md:items-center md:gap-x-3.5 md:p-2" }, Gi = { class: "text-mobile-body-m text-blue-500 md:text-desktop-body-m" }, Xi = { id: "pharmacies-list" }, Yi = ["onClick"], Qi = /* @__PURE__ */ z({
  __name: "PharmaciesList",
  setup(n) {
    const { t: e } = U(), { md: t } = $e(), a = Le(), {
      activePageNumber: o,
      indexOfFirstItem: s,
      hasPagination: r,
      searchResults: l,
      filteredResults: i,
      resultsCount: d,
      hasBeenSearched: u,
      maxPageNumber: c,
      sortingBy: h,
      hasSearchedMoreDrugs: v
    } = re(a), { setSortingBy: p } = a, g = Ie(), { showMap: y } = re(g), w = Ct("sortingPopover"), _ = k(!1), C = S(
      () => l.value.filter((H) => H.availability !== "unavailable").length
    ), $ = S(
      () => v.value && l.value.filter((H) => H.availability === "stock").length === 0
    ), E = S(
      () => e("results", { currentPage: o.value, maxPage: c.value })
    ), q = S(() => [
      {
        label: e("sort_by_availability_of_medicines"),
        value: "availability"
      },
      {
        label: e("sort_by_distance_from_address"),
        value: "distance"
      }
    ]);
    function O(H) {
      var L;
      p(H), _.value = !1, (L = w.value) == null || L.hide();
    }
    function Q(H) {
      var L;
      t.value ? (L = w.value) == null || L.toggle(H) : _.value = !_.value;
    }
    function Ae(H) {
      s.value = H.first, _n("#pharmacies-list");
    }
    return (H, L) => (b(), x(N, null, [
      f("div", Oi, [
        m(u) ? (b(), x("div", Hi, [
          f("div", Ti, [
            f("button", {
              "aria-label": m(e)("show_on_map"),
              type: "button",
              class: "flex w-1/2 items-center justify-center gap-2 border-r border-r-gray-200 p-3 text-center text-gray-700 md:w-fit md:rounded-md md:border md:border-gray-700",
              onClick: L[0] || (L[0] = (A) => y.value = !0)
            }, [
              L[2] || (L[2] = f("span", {
                "aria-hidden": "true",
                class: "iconify-[mdi--map-outline] h-5 w-5 md:h-4 md:w-4"
              }, null, -1)),
              f("span", Vi, P(m(e)("show_on_map")), 1)
            ], 8, Ri),
            f("button", {
              "aria-label": m(e)("sort"),
              type: "button",
              class: "relative flex w-1/2 items-center justify-center gap-2 p-3 text-center text-gray-700 md:w-fit md:rounded-md md:border md:border-gray-700",
              onClick: Q
            }, [
              L[3] || (L[3] = f("span", {
                "aria-hidden": "true",
                class: "iconify-[material-symbols--sort] h-5 w-5 md:h-4 md:w-4"
              }, null, -1)),
              f("span", Zi, P(m(e)("sort")), 1),
              f("span", qi, P(`${m(e)("sort_by")}: ${m(h) === "availability" ? m(e)("sort_by_availability_of_medicines") : m(e)("sort_by_distance_from_address")}`), 1),
              M(m(an), {
                ref_key: "sortingPopover",
                ref: w,
                pt: m(Di)
              }, {
                default: I(() => [
                  (b(!0), x(N, null, X(q.value, (A) => (b(), x("div", {
                    key: A.value,
                    class: "cursor-pointer p-3",
                    onClick: (De) => O(A.value)
                  }, [
                    f("span", Wi, P(A.label), 1)
                  ], 8, Bi))), 128))
                ]),
                _: 1
              }, 8, ["pt"])
            ], 8, Ni)
          ]),
          C.value >= 1 ? (b(), x("div", {
            key: 0,
            class: "mb-2.5 text-center text-mobile-body-l text-blue-700 md:text-desktop-body-l",
            innerHTML: C.value > 1 ? m(e)("pharmacy_count_plural", { count: C.value }) : m(e)("pharmacy_count_singular", { count: C.value })
          }, null, 8, Fi)) : Z("", !0),
          $.value ? (b(), x("div", Ui, [
            f("div", Ki, [
              L[5] || (L[5] = f("span", { class: "iconify-[ic--outline-tips-and-updates] h-5 w-5 text-blue-500 md:my-3.5 md:ml-3.5" }, null, -1)),
              f("span", Gi, [
                L[4] || (L[4] = f("strong", null, "Tip!", -1)),
                se(" " + P(H.$t("unavailable_drugs_hint_message")), 1)
              ])
            ])
          ])) : Z("", !0)
        ])) : Z("", !0),
        f("div", Xi, [
          (b(!0), x(N, null, X(m(i), (A) => (b(), D(Ai, {
            class: "border-t border-t-blue-200 first:border-t-0 md:first:border-t",
            key: A.id,
            pharmacy: A
          }, null, 8, ["pharmacy"]))), 128))
        ]),
        m(r) ? (b(), D(m(on), {
          key: 1,
          class: "mx-auto w-fit",
          first: m(s),
          rows: m(ke),
          "page-link-size": m(t) ? 5 : 3,
          "total-records": m(d),
          template: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
          onPage: Ae
        }, yn({ _: 2 }, [
          m(t) ? {
            name: "report",
            fn: I(() => [
              se(P(E.value), 1)
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["first", "rows", "page-link-size", "total-records"])) : Z("", !0)
      ]),
      M(m(sn), {
        visible: _.value,
        "onUpdate:visible": L[1] || (L[1] = (A) => _.value = A),
        header: H.$t("sort_by")
      }, {
        default: I(() => [
          (b(!0), x(N, null, X(q.value, (A) => (b(), x("div", {
            key: A.value,
            class: "flex items-center gap-x-[17px] border-b border-gray-100 py-6",
            onClick: (De) => O(A.value)
          }, [
            f("span", {
              class: G(["h-6 w-6 text-green-500", {
                "iconify-[mdi--radio-button-checked]": A.value === m(h),
                "iconify-[mdi--radio-button-unchecked]": A.value !== m(h)
              }])
            }, null, 2),
            se(" " + P(A.label), 1)
          ], 8, Yi))), 128))
        ]),
        _: 1
      }, 8, ["visible", "header"])
    ], 64));
  }
});
async function Ji(n) {
  const e = fe();
  try {
    const { data: t } = await Se.get(
      `${e.datasetUrls.drugsSuggestionsPath}?query=${n}`
    );
    return t.data;
  } catch (t) {
    throw new Error(`Failed to fetch drugs suggestions with error: ${t}`);
  }
}
function el(n, e, t, a) {
  function o(s) {
    return s instanceof t ? s : new t(function(r) {
      r(s);
    });
  }
  return new (t || (t = Promise))(function(s, r) {
    function l(u) {
      try {
        d(a.next(u));
      } catch (c) {
        r(c);
      }
    }
    function i(u) {
      try {
        d(a.throw(u));
      } catch (c) {
        r(c);
      }
    }
    function d(u) {
      u.done ? s(u.value) : o(u.value).then(l, i);
    }
    d((a = a.apply(n, [])).next());
  });
}
function tl(n) {
  return n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var nl = function n(e, t) {
  if (e === t) return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor) return !1;
    var a, o, s;
    if (Array.isArray(e)) {
      if (a = e.length, a != t.length) return !1;
      for (o = a; o-- !== 0; )
        if (!n(e[o], t[o])) return !1;
      return !0;
    }
    if (e.constructor === RegExp) return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString) return e.toString() === t.toString();
    if (s = Object.keys(e), a = s.length, a !== Object.keys(t).length) return !1;
    for (o = a; o-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, s[o])) return !1;
    for (o = a; o-- !== 0; ) {
      var r = s[o];
      if (!n(e[r], t[r])) return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}, al = /* @__PURE__ */ tl(nl);
const yt = "__googleMapsScriptId";
var ce;
(function(n) {
  n[n.INITIALIZED = 0] = "INITIALIZED", n[n.LOADING = 1] = "LOADING", n[n.SUCCESS = 2] = "SUCCESS", n[n.FAILURE = 3] = "FAILURE";
})(ce || (ce = {}));
class oe {
  /**
   * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
   * using this library, instead the defaults are set by the Google Maps
   * JavaScript API server.
   *
   * ```
   * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
   * ```
   */
  constructor({ apiKey: e, authReferrerPolicy: t, channel: a, client: o, id: s = yt, language: r, libraries: l = [], mapIds: i, nonce: d, region: u, retries: c = 3, url: h = "https://maps.googleapis.com/maps/api/js", version: v }) {
    if (this.callbacks = [], this.done = !1, this.loading = !1, this.errors = [], this.apiKey = e, this.authReferrerPolicy = t, this.channel = a, this.client = o, this.id = s || yt, this.language = r, this.libraries = l, this.mapIds = i, this.nonce = d, this.region = u, this.retries = c, this.url = h, this.version = v, oe.instance) {
      if (!al(this.options, oe.instance.options))
        throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify(oe.instance.options)}`);
      return oe.instance;
    }
    oe.instance = this;
  }
  get options() {
    return {
      version: this.version,
      apiKey: this.apiKey,
      channel: this.channel,
      client: this.client,
      id: this.id,
      libraries: this.libraries,
      language: this.language,
      region: this.region,
      mapIds: this.mapIds,
      nonce: this.nonce,
      url: this.url,
      authReferrerPolicy: this.authReferrerPolicy
    };
  }
  get status() {
    return this.errors.length ? ce.FAILURE : this.done ? ce.SUCCESS : this.loading ? ce.LOADING : ce.INITIALIZED;
  }
  get failed() {
    return this.done && !this.loading && this.errors.length >= this.retries + 1;
  }
  /**
   * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
   *
   * @ignore
   * @deprecated
   */
  createUrl() {
    let e = this.url;
    return e += "?callback=__googleMapsCallback&loading=async", this.apiKey && (e += `&key=${this.apiKey}`), this.channel && (e += `&channel=${this.channel}`), this.client && (e += `&client=${this.client}`), this.libraries.length > 0 && (e += `&libraries=${this.libraries.join(",")}`), this.language && (e += `&language=${this.language}`), this.region && (e += `&region=${this.region}`), this.version && (e += `&v=${this.version}`), this.mapIds && (e += `&map_ids=${this.mapIds.join(",")}`), this.authReferrerPolicy && (e += `&auth_referrer_policy=${this.authReferrerPolicy}`), e;
  }
  deleteScript() {
    const e = document.getElementById(this.id);
    e && e.remove();
  }
  /**
   * Load the Google Maps JavaScript API script and return a Promise.
   * @deprecated, use importLibrary() instead.
   */
  load() {
    return this.loadPromise();
  }
  /**
   * Load the Google Maps JavaScript API script and return a Promise.
   *
   * @ignore
   * @deprecated, use importLibrary() instead.
   */
  loadPromise() {
    return new Promise((e, t) => {
      this.loadCallback((a) => {
        a ? t(a.error) : e(window.google);
      });
    });
  }
  importLibrary(e) {
    return this.execute(), google.maps.importLibrary(e);
  }
  /**
   * Load the Google Maps JavaScript API script with a callback.
   * @deprecated, use importLibrary() instead.
   */
  loadCallback(e) {
    this.callbacks.push(e), this.execute();
  }
  /**
   * Set the script on document.
   */
  setScript() {
    var e, t;
    if (document.getElementById(this.id)) {
      this.callback();
      return;
    }
    const a = {
      key: this.apiKey,
      channel: this.channel,
      client: this.client,
      libraries: this.libraries.length && this.libraries,
      v: this.version,
      mapIds: this.mapIds,
      language: this.language,
      region: this.region,
      authReferrerPolicy: this.authReferrerPolicy
    };
    Object.keys(a).forEach(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (s) => !a[s] && delete a[s]
    ), !((t = (e = window == null ? void 0 : window.google) === null || e === void 0 ? void 0 : e.maps) === null || t === void 0) && t.importLibrary || ((s) => {
      let r, l, i, d = "The Google Maps JavaScript API", u = "google", c = "importLibrary", h = "__ib__", v = document, p = window;
      p = p[u] || (p[u] = {});
      const g = p.maps || (p.maps = {}), y = /* @__PURE__ */ new Set(), w = new URLSearchParams(), _ = () => (
        // @ts-ignore
        r || (r = new Promise((C, $) => el(this, void 0, void 0, function* () {
          var E;
          yield l = v.createElement("script"), l.id = this.id, w.set("libraries", [...y] + "");
          for (i in s)
            w.set(i.replace(/[A-Z]/g, (q) => "_" + q[0].toLowerCase()), s[i]);
          w.set("callback", u + ".maps." + h), l.src = this.url + "?" + w, g[h] = C, l.onerror = () => r = $(Error(d + " could not load.")), l.nonce = this.nonce || ((E = v.querySelector("script[nonce]")) === null || E === void 0 ? void 0 : E.nonce) || "", v.head.append(l);
        })))
      );
      g[c] ? console.warn(d + " only loads once. Ignoring:", s) : g[c] = (C, ...$) => y.add(C) && _().then(() => g[c](C, ...$));
    })(a);
    const o = this.libraries.map((s) => this.importLibrary(s));
    o.length || o.push(this.importLibrary("core")), Promise.all(o).then(() => this.callback(), (s) => {
      const r = new ErrorEvent("error", { error: s });
      this.loadErrorCallback(r);
    });
  }
  /**
   * Reset the loader state.
   */
  reset() {
    this.deleteScript(), this.done = !1, this.loading = !1, this.errors = [], this.onerrorEvent = null;
  }
  resetIfRetryingFailed() {
    this.failed && this.reset();
  }
  loadErrorCallback(e) {
    if (this.errors.push(e), this.errors.length <= this.retries) {
      const t = this.errors.length * Math.pow(2, this.errors.length);
      console.error(`Failed to load Google Maps script, retrying in ${t} ms.`), setTimeout(() => {
        this.deleteScript(), this.setScript();
      }, t);
    } else
      this.onerrorEvent = e, this.callback();
  }
  callback() {
    this.done = !0, this.loading = !1, this.callbacks.forEach((e) => {
      e(this.onerrorEvent);
    }), this.callbacks = [];
  }
  execute() {
    if (this.resetIfRetryingFailed(), !this.loading)
      if (this.done)
        this.callback();
      else {
        if (window.google && window.google.maps && window.google.maps.version) {
          console.warn("Google Maps already loaded outside @googlemaps/js-api-loader. This may result in undesirable behavior as options and script parameters may not match."), this.callback();
          return;
        }
        this.loading = !0, this.setScript();
      }
  }
}
const ol = () => {
  const {
    google: { apiKey: n }
  } = ze;
  return {
    googleLoader: new oe({ apiKey: n })
  };
};
async function sl(n, e, t) {
  const a = k([]), { googleLoader: o } = ol(), { AutocompleteSessionToken: s, AutocompleteSuggestion: r } = await o.importLibrary("places"), { Geocoder: l } = await o.importLibrary("geocoding"), i = new s(), d = new l();
  function u(c) {
    return new Promise((h, v) => {
      d.geocode({ placeId: c }, (p, g) => {
        g === "OK" && p && p[0] ? h({
          lat: p[0].geometry.location.lat(),
          lng: p[0].geometry.location.lng()
        }) : v(new Error("Geocode was not successful for the following reason: " + g));
      });
    });
  }
  return B(
    n,
    Sn(async (c) => {
      if (c.length === 0 && (a.value = []), c.length < t)
        return;
      const { suggestions: h } = await r.fetchAutocompleteSuggestions({
        input: n.value,
        sessionToken: i,
        includedRegionCodes: [e]
      }), v = await Promise.all(
        h.map(async (p, g) => {
          var y, w;
          if ((y = p.placePrediction) != null && y.text.text && ((w = p.placePrediction) != null && w.placeId)) {
            const _ = await u(p.placePrediction.placeId);
            return _ ? {
              id: g,
              name: p.placePrediction.text.text,
              placeId: p.placePrediction.placeId,
              coordinates: _
            } : void 0;
          }
        })
      );
      a.value = v.filter((p) => !!p);
    }, 300)
  ), {
    predictedPlaces: a
  };
}
async function rl(n) {
  const {
    web: e,
    google: { autocompleteMinChars: t }
  } = ze, { predictedPlaces: a } = await sl(n, e, t);
  return {
    predictedPlaces: a
  };
}
const Ut = zn("Geolocation", {
  web: () => import("./web-CbzYdmA7.js").then((n) => new n.GeolocationWeb())
});
async function il() {
  try {
    return (await Ut.requestPermissions()).location === "granted";
  } catch {
    return !1;
  }
}
async function Kt() {
  try {
    const { coords: n } = await Ut.getCurrentPosition();
    return {
      lat: n.latitude,
      lng: n.longitude
    };
  } catch {
    return await il() ? Kt() : Promise.reject(new Error("Permission denied"));
  }
}
const ll = {
  key: 0,
  class: "flex flex-col"
}, cl = {
  key: 1,
  action: "",
  class: "rounded-lg bg-white p-4 shadow-level-2 sm:px-8 sm:pb-10 sm:pt-5"
}, ul = { class: "grid grid-cols-1 gap-2.5 sm:grid-cols-[minmax(0,1fr),minmax(0,1fr),auto] sm:gap-1" }, dl = { class: "hidden pb-1 text-mobile-body-s font-normal leading-tight text-gray-800 sm:block sm:text-desktop-body-m" }, pl = { class: "hidden pb-1 text-mobile-body-s font-normal leading-tight text-gray-800 sm:block sm:text-desktop-body-m" }, hl = { class: "sm:pl-1 sm:pt-6" }, ml = ["innerHTML"], fl = ["innerHTML"], gl = /* @__PURE__ */ z({
  __name: "SearchingForm",
  props: {
    preselectedDrug: {},
    searchDrug: {}
  },
  async setup(n) {
    let e, t;
    const a = n, { t: o } = U(), { sm: s } = $e(), r = Le(), { searchCoordinates: l, hasBeenSearched: i, hasSearchedMoreDrugs: d } = re(r), { onSearch: u } = r, c = Ct("drugsAutoComplete"), h = k([]), v = k([]), p = k([]), g = k(""), y = k(!1), w = k(!1), _ = k(!1), C = k(!1), { predictedPlaces: $ } = ([e, t] = wn(() => rl(g)), e = await e, t(), e), E = S(() => h.value.length ? o("add_medicine") : s.value ? o("search_placeholder") : o("search_medicine")), q = S(() => {
      if (!p.value.length)
        return s.value ? o("address_placeholder") : o("general_where");
    });
    async function O(j) {
      if (3 > j.query.length)
        return;
      const W = await Ji(j.query);
      v.value = W.filter(
        (K) => !h.value.some((Xt) => Xt.id === K.id)
      );
    }
    function Q(j) {
      g.value = j.query;
    }
    async function Ae() {
      if (w.value = h.value.length === 0, _.value = p.value.length === 0, h.value.length && p.value.length) {
        const j = p.value[0].coordinates;
        y.value = !0, l.value = j, await u({
          items: h.value.map((W) => W.id),
          coordinates: j
        }), y.value = !1, C.value = !0;
      }
    }
    const H = k(!1), L = k(), A = k(!1);
    async function De() {
      try {
        H.value = !0, L.value = await Kt();
      } catch {
        A.value = !0;
      } finally {
        H.value = !1;
      }
    }
    function Gt() {
      L.value && (p.value = [
        {
          id: 0,
          placeId: "current_location",
          name: o("current_location"),
          coordinates: { ...L.value }
        }
      ]);
    }
    return B(
      () => h.value,
      (j) => {
        j.length && (w.value = !1, d.value = 1 < j.length);
      }
    ), B(
      () => p.value,
      (j) => {
        j.length && (_.value = !1);
      }
    ), je(() => {
      var j, W;
      if (De(), a.preselectedDrug && (h.value = [a.preselectedDrug]), a.searchDrug) {
        const K = (W = (j = c.value) == null ? void 0 : j.$el) == null ? void 0 : W.getElementsByTagName("input")[0];
        K && (K.value = a.searchDrug, K.dispatchEvent(
          new CustomEvent("AutoCompleteCompleteEvent", {
            detail: {
              query: a.searchDrug
            }
          })
        ), K.focus());
      }
    }), (j, W) => (b(), x(N, null, [
      !m(s) && m(i) && C.value ? (b(), x("div", ll, [
        M(m(ue), {
          label: j.$t("adjust_search"),
          icon: "mdi mdi-tune leading-none",
          variant: "primary",
          onClick: W[0] || (W[0] = (K) => C.value = !1)
        }, null, 8, ["label"])
      ])) : (b(), x("form", cl, [
        f("div", ul, [
          f("div", null, [
            f("div", dl, P(j.$t("search_medicine")), 1),
            M(m(Ye), {
              ref: "drugsAutoComplete",
              modelValue: h.value,
              "onUpdate:modelValue": W[1] || (W[1] = (K) => h.value = K),
              placeholder: E.value,
              suggestions: v.value,
              containerIcon: m(s) ? m(Ze).SEARCH : "",
              completeOnFocus: !!a.searchDrug,
              optionItemIcon: "iconify-[solar--jar-of-pills-2-linear]",
              "input-id": "drugs-input",
              invalid: w.value,
              "label-error": m(o)("medicine_error"),
              "label-absolute": m(s),
              onComplete: O
            }, null, 8, ["modelValue", "placeholder", "suggestions", "containerIcon", "completeOnFocus", "invalid", "label-error", "label-absolute"])
          ]),
          f("div", null, [
            f("div", pl, P(j.$t("general_where")), 1),
            M(m(Ye), {
              modelValue: p.value,
              "onUpdate:modelValue": W[2] || (W[2] = (K) => p.value = K),
              placeholder: q.value,
              suggestions: m($),
              containerIcon: m(s) ? m(Ze).MAP_MARKER : "",
              optionItemIcon: "iconify-[prime--map-marker]",
              "input-id": "address-input",
              "single-selection": "",
              invalid: _.value,
              "label-error": m(o)("address_error"),
              "label-absolute": m(s),
              onComplete: Q
            }, {
              appendInnerIcon: I(() => [
                p.value.length ? Z("", !0) : (b(), D(m(ue), {
                  key: 0,
                  label: "",
                  icon: A.value ? "iconify-[mdi--gps-unknown]" : "iconify-[mdi--crosshairs-gps]",
                  class: G([
                    "!p-2 !text-desktop-body-l",
                    A.value ? "cursor-not-allowed !text-gray-200" : "!text-gray-600"
                  ]),
                  variant: "transparent",
                  "disabled-with-styling": A.value,
                  loading: H.value,
                  onClick: Gt
                }, null, 8, ["icon", "class", "disabled-with-styling", "loading"]))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder", "suggestions", "containerIcon", "invalid", "label-error", "label-absolute"])
          ]),
          f("div", hl, [
            M(m(ue), {
              class: "w-full",
              label: j.$t("check_availability"),
              onClick: Ae,
              variant: "primary"
            }, null, 8, ["label"])
          ])
        ])
      ])),
      M(m(rn), { visible: y.value }, {
        default: I(() => [
          f("span", {
            class: "text-secondary-700",
            innerHTML: j.$t("searching_medicine")
          }, null, 8, ml)
        ]),
        footer: I(() => [
          f("span", {
            innerHTML: j.$t("use_reserve_ePrescription")
          }, null, 8, fl)
        ]),
        _: 1
      }, 8, ["visible"])
    ], 64));
  }
}), vl = { class: "mx-auto max-w-screen-xl" }, yl = { class: "relative mb-3 text-center md:mb-5" }, wl = { class: "mb-3 text-mobile-headline-l font-bold leading-6 text-white md:mb-2 md:text-2xl" }, bl = { class: "text-center text-mobile-body-s text-white md:text-mobile-body-m" }, kl = { class: "mx-auto max-w-screen-sm py-8" }, _l = { class: "mb-5 text-center text-2xl font-bold text-secondary-800" }, Cl = { class: "faq-info mt-3 text-sm" }, xl = ["innerHTML"], Pl = ["innerHTML"], Ml = /* @__PURE__ */ z({
  __name: "App",
  props: {
    suggestQueryArgument: {},
    suggestItemDataObjectArgument: {}
  },
  setup(n) {
    const { t: e } = U(), t = Le(), { filteredResults: a } = re(t), o = Ie(), { showMap: s } = re(o), r = S(() => [
      {
        label: e("title_website"),
        url: "/"
      },
      {
        label: e("title_medicines_availability")
      }
    ]);
    return (l, i) => (b(), x("div", vl, [
      f("div", {
        class: G(["relative", m(a).length ? "pb-5 md:pb-16" : "pb-16"])
      }, [
        i[0] || (i[0] = f("div", { class: "unlimited-width absolute h-full bg-[url(/images/rx-drug-search/rx-layer-row.jpg)] bg-cover bg-center bg-no-repeat" }, null, -1)),
        M(m(ln), {
          model: r.value,
          class: "relative pb-5 pt-3 text-desktop-body-s leading-none text-white md:pt-5"
        }, null, 8, ["model"]),
        f("div", yl, [
          f("h2", wl, P(l.$t("title_medicines_availability")), 1),
          f("p", bl, P(l.$t("medicines_availability_description")), 1)
        ])
      ], 2),
      f("div", {
        class: G([m(a).length ? "-translate-y-7 sm:-translate-y-6 md:-translate-y-16" : "-translate-y-16"])
      }, [
        (b(), D(bn, null, {
          default: I(() => [
            M(gl, {
              "preselected-drug": l.suggestItemDataObjectArgument,
              "search-drug": l.suggestQueryArgument
            }, null, 8, ["preselected-drug", "search-drug"])
          ]),
          _: 1
        })),
        m(s) ? (b(), D(xi, { key: 0 })) : Z("", !0),
        M(Qi),
        f("div", kl, [
          f("h2", _l, P(l.$t("faq")), 1),
          M(ys),
          f("div", Cl, [
            f("p", {
              innerHTML: l.$t("faq_no_answer")
            }, null, 8, xl),
            f("p", {
              innerHTML: l.$t("faq_info_line_contact", { phoneNumber: l.$t("faq_phone_number"), faq_email: l.$t("faq_email") })
            }, null, 8, Pl)
          ])
        ])
      ], 2)
    ]));
  }
}), Sl = /* @__PURE__ */ We(Ml, [["__scopeId", "data-v-25291f73"]]);
try {
  const { datasetKeys: n, datasetValues: e, messages: t } = cn(tt, {
    datasetStagingValues: Pt,
    moduleLocales: gs
  }), a = un({
    App: Sl,
    datasetKeys: n,
    datasetValues: e
  });
  a.use(dn()), a.use(
    pn({
      ...ze.localeSettings,
      messages: t
    })
  ), a.mount(`#${tt}`);
} catch (n) {
  console.error("Failed to initialize the application:", n);
}
//# sourceMappingURL=rx-drug-search.js.map
